var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _rect, _rect2, _rect3, _g8, _g9, _g0, _g1, _g10, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _g11, _g12, _g13, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path, _g14, _g15, _rect16, _rect17, _g16, _g17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 175,
    height: 139,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 175 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-3 {\n        fill: #f3f5f6;\n      }\n\n      .cls-4 {\n        fill: #f3f4f5;\n      }\n\n      .cls-5 {\n        fill: #f3f4f4;\n      }\n\n      .cls-6 {\n        fill: #f6f7f8;\n      }\n\n      .cls-7 {\n        fill: #f6f7f7;\n      }\n\n      .cls-8 {\n        fill: #f7f8f9;\n      }\n\n      .cls-9 {\n        fill: #f7f8f8;\n      }\n\n      .cls-10 {\n        fill: #f2f4f5;\n      }\n\n      .cls-11 {\n        fill: #f2f3f4;\n      }\n\n      .cls-12 {\n        fill: #f9fafa;\n      }\n\n      .cls-13 {\n        fill: #f9fafb;\n      }\n\n      .cls-14 {\n        fill: #f8f9fa;\n      }\n\n      .cls-15 {\n        fill: #f8f9f9;\n      }\n\n      .cls-16 {\n        fill: #6a6f72;\n      }\n\n      .cls-17 {\n        fill: #6a6f71;\n      }\n\n      .cls-18 {\n        fill: #6a7073;\n      }\n\n      .cls-19 {\n        fill: #6a6b6d;\n      }\n\n      .cls-20 {\n        fill: #696f72;\n      }\n\n      .cls-21 {\n        fill: #69696b;\n      }\n\n      .cls-22 {\n        fill: #69696a;\n      }\n\n      .cls-23 {\n        fill: #696d70;\n      }\n\n      .cls-24 {\n        fill: #696a6c;\n      }\n\n      .cls-25 {\n        fill: #696c6f;\n      }\n\n      .cls-26 {\n        fill: #696e70;\n      }\n\n      .cls-27 {\n        fill: #696e71;\n      }\n\n      .cls-28 {\n        fill: #686d6f;\n      }\n\n      .cls-29 {\n        fill: #686b6e;\n      }\n\n      .cls-30 {\n        fill: #686e71;\n      }\n\n      .cls-31 {\n        fill: #686d70;\n      }\n\n      .cls-32 {\n        fill: #676d70;\n      }\n\n      .cls-33 {\n        fill: #67686a;\n      }\n\n      .cls-34 {\n        fill: #676768;\n      }\n\n      .cls-35 {\n        fill: #676769;\n      }\n\n      .cls-36 {\n        fill: #676a6d;\n      }\n\n      .cls-37 {\n        fill: #676c6f;\n      }\n\n      .cls-38 {\n        fill: #676c6e;\n      }\n\n      .cls-39 {\n        fill: #6a6a6b;\n      }\n\n      .cls-40 {\n        fill: #6a6a6c;\n      }\n\n      .cls-41 {\n        fill: #6a6e71;\n      }\n\n      .cls-42 {\n        fill: #6a6e72;\n      }\n\n      .cls-43 {\n        fill: #eeeff1;\n      }\n\n      .cls-44 {\n        fill: #eef0f1;\n      }\n\n      .cls-45 {\n        fill: #eef1f2;\n      }\n\n      .cls-46 {\n        fill: #ebedee;\n      }\n\n      .cls-47 {\n        fill: #ebecee;\n      }\n\n      .cls-48 {\n        fill: #ebedef;\n      }\n\n      .cls-49 {\n        fill: #ebeeef;\n      }\n\n      .cls-50 {\n        fill: #f0f2f3;\n      }\n\n      .cls-51 {\n        fill: #eaecee;\n      }\n\n      .cls-52 {\n        fill: #eaedee;\n      }\n\n      .cls-53 {\n        fill: #eaebed;\n      }\n\n      .cls-54 {\n        fill: #eaeced;\n      }\n\n      .cls-55 {\n        fill: #f4f6f6;\n      }\n\n      .cls-56 {\n        fill: #e9eaec;\n      }\n\n      .cls-57 {\n        fill: #e6e8e9;\n      }\n\n      .cls-58 {\n        fill: #e6e9eb;\n      }\n\n      .cls-59 {\n        fill: #e6e9ea;\n      }\n\n      .cls-60 {\n        fill: #e6e8ea;\n      }\n\n      .cls-61 {\n        fill: #e9ebed;\n      }\n\n      .cls-62 {\n        fill: #e9ebec;\n      }\n\n      .cls-63 {\n        fill: #e9eced;\n      }\n\n      .cls-64 {\n        fill: #f4f5f5;\n      }\n\n      .cls-65 {\n        fill: #f4f5f6;\n      }\n\n      .cls-66 {\n        fill: #f5f6f6;\n      }\n\n      .cls-67 {\n        fill: #f5f6f7;\n      }\n\n      .cls-68 {\n        fill: #fafbfb;\n      }\n\n      .cls-69 {\n        fill: #fafbfc;\n      }\n\n      .cls-70 {\n        fill: #fcfdfd;\n      }\n\n      .cls-71 {\n        fill: #e7e8ea;\n      }\n\n      .cls-72 {\n        fill: #e7eaeb;\n      }\n\n      .cls-73 {\n        fill: #e7e9eb;\n      }\n\n      .cls-74 {\n        fill: #e7e9ea;\n      }\n\n      .cls-75 {\n        fill: #e3e5e8;\n      }\n\n      .cls-76 {\n        fill: #e3e5e7;\n      }\n\n      .cls-77 {\n        fill: #e3e6e8;\n      }\n\n      .cls-78 {\n        fill: #e3e6e7;\n      }\n\n      .cls-79 {\n        fill: #e3e5e6;\n      }\n\n      .cls-80 {\n        fill: #e8ebec;\n      }\n\n      .cls-81 {\n        fill: #e8e9eb;\n      }\n\n      .cls-82 {\n        fill: #edf0f1;\n      }\n\n      .cls-83 {\n        fill: #edeef0;\n      }\n\n      .cls-84 {\n        fill: #edeff0;\n      }\n\n      .cls-85 {\n        fill: #e2e5e7;\n      }\n\n      .cls-86 {\n        fill: #e2e5e6;\n      }\n\n      .cls-87 {\n        fill: #e8eaeb;\n      }\n\n      .cls-88 {\n        fill: #e8eaec;\n      }\n\n      .cls-89 {\n        fill: #f0f1f3;\n      }\n\n      .cls-90 {\n        fill: #f1f2f3;\n      }\n\n      .cls-91 {\n        fill: #f1f3f4;\n      }\n\n      .cls-92 {\n        fill: #ecedef;\n      }\n\n      .cls-93 {\n        fill: #feffff;\n      }\n\n      .cls-94 {\n        fill: #fbfcfc;\n      }\n\n      .cls-95 {\n        fill: #e5e7e8;\n      }\n\n      .cls-96 {\n        fill: #e5e7e9;\n      }\n\n      .cls-97 {\n        fill: #e5e8ea;\n      }\n\n      .cls-98 {\n        fill: #e5e8e9;\n      }\n\n      .cls-99 {\n        fill: #e2e4e6;\n      }\n\n      .cls-100 {\n        fill: #e2e4e7;\n      }\n\n      .cls-101 {\n        fill: #e2e4e5;\n      }\n\n      .cls-102 {\n        fill: #eceff0;\n      }\n\n      .cls-103 {\n        fill: #eceeef;\n      }\n\n      .cls-104 {\n        fill: #eff0f2;\n      }\n\n      .cls-105 {\n        fill: #e4e7e9;\n      }\n\n      .cls-106 {\n        fill: #e4e6e7;\n      }\n\n      .cls-107 {\n        fill: #e4e6e8;\n      }\n\n      .cls-108 {\n        fill: #e4e6e9;\n      }\n\n      .cls-109 {\n        fill: #e4e7e8;\n      }\n\n      .cls-110 {\n        fill: #eff2f3;\n      }\n\n      .cls-111 {\n        fill: #eff1f2;\n      }\n\n      .cls-112 {\n        fill: #fdfefe;\n      }\n\n      .cls-113 {\n        fill: #91979a;\n      }\n\n      .cls-114 {\n        fill: #91979b;\n      }\n\n      .cls-115 {\n        fill: #6b7174;\n      }\n\n      .cls-116 {\n        fill: #919596;\n      }\n\n      .cls-117 {\n        fill: #919598;\n      }\n\n      .cls-118 {\n        fill: #919697;\n      }\n\n      .cls-119 {\n        fill: #7d7f81;\n      }\n\n      .cls-120 {\n        fill: #7d7f80;\n      }\n\n      .cls-121 {\n        fill: #7d7f82;\n      }\n\n      .cls-122 {\n        fill: #7d7d7e;\n      }\n\n      .cls-123 {\n        fill: #7d8084;\n      }\n\n      .cls-124 {\n        fill: #7d8085;\n      }\n\n      .cls-125 {\n        fill: #7d7e7f;\n      }\n\n      .cls-126 {\n        fill: #6b6f73;\n      }\n\n      .cls-127 {\n        fill: #6b6f72;\n      }\n\n      .cls-128 {\n        fill: #6b7073;\n      }\n\n      .cls-129 {\n        fill: #6b7072;\n      }\n\n      .cls-130 {\n        fill: #6b6b6c;\n      }\n\n      .cls-131 {\n        fill: #6b6d6f;\n      }\n\n      .cls-132 {\n        fill: #6b6b6d;\n      }\n\n      .cls-133 {\n        fill: #6b6c6e;\n      }\n\n      .cls-134 {\n        fill: #7e7f80;\n      }\n\n      .cls-135 {\n        fill: #7e8485;\n      }\n\n      .cls-136 {\n        fill: #7e8488;\n      }\n\n      .cls-137 {\n        fill: #7e8386;\n      }\n\n      .cls-138 {\n        fill: #7e8384;\n      }\n\n      .cls-139 {\n        fill: #7e8388;\n      }\n\n      .cls-140 {\n        fill: #7e7e7f;\n      }\n\n      .cls-141 {\n        fill: #7e8185;\n      }\n\n      .cls-142 {\n        fill: #7e8186;\n      }\n\n      .cls-143 {\n        fill: #7e8083;\n      }\n\n      .cls-144 {\n        fill: #7e8082;\n      }\n\n      .cls-145 {\n        fill: #7e8081;\n      }\n\n      .cls-146 {\n        fill: #7f7f80;\n      }\n\n      .cls-147 {\n        fill: #80858a;\n      }\n\n      .cls-148 {\n        fill: #808687;\n      }\n\n      .cls-149 {\n        fill: #808588;\n      }\n\n      .cls-150 {\n        fill: #808586;\n      }\n\n      .cls-151 {\n        fill: #80868a;\n      }\n\n      .cls-152 {\n        fill: #808387;\n      }\n\n      .cls-153 {\n        fill: #808388;\n      }\n\n      .cls-154 {\n        fill: #7f8081;\n      }\n\n      .cls-155 {\n        fill: #65686b;\n      }\n\n      .cls-156 {\n        fill: #81878b;\n      }\n\n      .cls-157 {\n        fill: #818788;\n      }\n\n      .cls-158 {\n        fill: #818182;\n      }\n\n      .cls-159 {\n        fill: #7d8287;\n      }\n\n      .cls-160 {\n        fill: #7d8285;\n      }\n\n      .cls-161 {\n        fill: #818384;\n      }\n\n      .cls-162 {\n        fill: #818386;\n      }\n\n      .cls-163 {\n        fill: #818385;\n      }\n\n      .cls-164 {\n        fill: #7d8283;\n      }\n\n      .cls-165 {\n        fill: #818687;\n      }\n\n      .cls-166 {\n        fill: #818689;\n      }\n\n      .cls-167 {\n        fill: #81868b;\n      }\n\n      .cls-168 {\n        fill: #818488;\n      }\n\n      .cls-169 {\n        fill: #818489;\n      }\n\n      .cls-170 {\n        fill: #818283;\n      }\n\n      .cls-171 {\n        fill: #7d8384;\n      }\n\n      .cls-172 {\n        fill: #7d8386;\n      }\n\n      .cls-173 {\n        fill: #74797b;\n      }\n\n      .cls-174 {\n        fill: #74797c;\n      }\n\n      .cls-175 {\n        fill: #74787c;\n      }\n\n      .cls-176 {\n        fill: #747b7c;\n      }\n\n      .cls-177 {\n        fill: #747a7d;\n      }\n\n      .cls-178 {\n        fill: #747678;\n      }\n\n      .cls-179 {\n        fill: #74777c;\n      }\n\n      .cls-180 {\n        fill: #68686a;\n      }\n\n      .cls-181 {\n        fill: #686869;\n      }\n\n      .cls-182 {\n        fill: #68696b;\n      }\n\n      .cls-183 {\n        fill: #747577;\n      }\n\n      .cls-184 {\n        fill: #747576;\n      }\n\n      .cls-185 {\n        fill: #747476;\n      }\n\n      .cls-186 {\n        fill: #747475;\n      }\n\n      .cls-187 {\n        fill: #656668;\n      }\n\n      .cls-188 {\n        fill: #656567;\n      }\n\n      .cls-189 {\n        fill: #656566;\n      }\n\n      .cls-190 {\n        fill: #656a6d;\n      }\n\n      .cls-191 {\n        fill: #656a6c;\n      }\n\n      .cls-192 {\n        fill: #656b6e;\n      }\n\n      .cls-193 {\n        fill: #999fa2;\n      }\n\n      .cls-194 {\n        fill: #999d9e;\n      }\n\n      .cls-195 {\n        fill: #999da0;\n      }\n\n      .cls-196 {\n        fill: #999fa3;\n      }\n\n      .cls-197 {\n        fill: #969a9b;\n      }\n\n      .cls-198 {\n        fill: #969a9d;\n      }\n\n      .cls-199 {\n        fill: #969899;\n      }\n\n      .cls-200 {\n        fill: #96989a;\n      }\n\n      .cls-201 {\n        fill: #96989b;\n      }\n\n      .cls-202 {\n        fill: #979da1;\n      }\n\n      .cls-203 {\n        fill: #979da0;\n      }\n\n      .cls-204 {\n        fill: #969c9f;\n      }\n\n      .cls-205 {\n        fill: #969ca0;\n      }\n\n      .cls-206 {\n        fill: #96999b;\n      }\n\n      .cls-207 {\n        fill: #969799;\n      }\n\n      .cls-208 {\n        fill: #969698;\n      }\n\n      .cls-209 {\n        fill: #6c6c6e;\n      }\n\n      .cls-210 {\n        fill: #6c6c6d;\n      }\n\n      .cls-211 {\n        fill: #6c6d6f;\n      }\n\n      .cls-212 {\n        fill: #6c6d6e;\n      }\n\n      .cls-213 {\n        fill: #999a9c;\n      }\n\n      .cls-214 {\n        fill: #999c9e;\n      }\n\n      .cls-215 {\n        fill: #99999b;\n      }\n\n      .cls-216 {\n        fill: #999b9d;\n      }\n\n      .cls-217 {\n        fill: #999b9e;\n      }\n\n      .cls-218 {\n        fill: #999b9c;\n      }\n\n      .cls-219 {\n        fill: #7c8182;\n      }\n\n      .cls-220 {\n        fill: #7c7f83;\n      }\n\n      .cls-221 {\n        fill: #7c7f84;\n      }\n\n      .cls-222 {\n        fill: #7c8184;\n      }\n\n      .cls-223 {\n        fill: #7c8186;\n      }\n\n      .cls-224 {\n        fill: #7c8283;\n      }\n\n      .cls-225 {\n        fill: #7c8285;\n      }\n\n      .cls-226 {\n        fill: #7c7e81;\n      }\n\n      .cls-227 {\n        fill: #7c7e80;\n      }\n\n      .cls-228 {\n        fill: #7c7e7f;\n      }\n\n      .cls-229 {\n        fill: #989a9b;\n      }\n\n      .cls-230 {\n        fill: #989a9d;\n      }\n\n      .cls-231 {\n        fill: #989a9c;\n      }\n\n      .cls-232 {\n        fill: #98999b;\n      }\n\n      .cls-233 {\n        fill: #989ea2;\n      }\n\n      .cls-234 {\n        fill: #989ea1;\n      }\n\n      .cls-235 {\n        fill: #98989a;\n      }\n\n      .cls-236 {\n        fill: #989c9f;\n      }\n\n      .cls-237 {\n        fill: #989c9d;\n      }\n\n      .cls-238 {\n        fill: #97989a;\n      }\n\n      .cls-239 {\n        fill: #979a9c;\n      }\n\n      .cls-240 {\n        fill: #989b9d;\n      }\n\n      .cls-241 {\n        fill: #97999a;\n      }\n\n      .cls-242 {\n        fill: #97999b;\n      }\n\n      .cls-243 {\n        fill: #97999c;\n      }\n\n      .cls-244 {\n        fill: #979799;\n      }\n\n      .cls-245 {\n        fill: #979b9c;\n      }\n\n      .cls-246 {\n        fill: #979b9e;\n      }\n\n      .cls-247 {\n        fill: #6c7174;\n      }\n\n      .cls-248 {\n        fill: #6c6e70;\n      }\n\n      .cls-249 {\n        fill: #6c7173;\n      }\n\n      .cls-250 {\n        fill: #6c7073;\n      }\n\n      .cls-251 {\n        fill: #6c7074;\n      }\n\n      .cls-252 {\n        fill: #6c7275;\n      }\n\n      .cls-253 {\n        fill: #7f8287;\n      }\n\n      .cls-254 {\n        fill: #7f8286;\n      }\n\n      .cls-255 {\n        fill: #7f8182;\n      }\n\n      .cls-256 {\n        fill: #7f8586;\n      }\n\n      .cls-257 {\n        fill: #7f8589;\n      }\n\n      .cls-258 {\n        fill: #7f8489;\n      }\n\n      .cls-259 {\n        fill: #7f8487;\n      }\n\n      .cls-260 {\n        fill: #7f8485;\n      }\n\n      .cls-261 {\n        fill: #7f8184;\n      }\n\n      .cls-262 {\n        fill: #7f8183;\n      }\n\n      .cls-263 {\n        fill: #7c7c7d;\n      }\n\n      .cls-264 {\n        fill: #7c7d7e;\n      }\n\n      .cls-265 {\n        fill: #919193;\n      }\n\n      .cls-266 {\n        fill: #8b8b8d;\n      }\n\n      .cls-267 {\n        fill: #8b8c8e;\n      }\n\n      .cls-268 {\n        fill: #8b8c8d;\n      }\n\n      .cls-269 {\n        fill: #8b8d90;\n      }\n\n      .cls-270 {\n        fill: #8b8d8e;\n      }\n\n      .cls-271 {\n        fill: #9ca0a1;\n      }\n\n      .cls-272 {\n        fill: #9ca0a3;\n      }\n\n      .cls-273 {\n        fill: #9c9d9f;\n      }\n\n      .cls-274 {\n        fill: #9c9fa1;\n      }\n\n      .cls-275 {\n        fill: #9ca2a5;\n      }\n\n      .cls-276 {\n        fill: #9ca2a6;\n      }\n\n      .cls-277 {\n        fill: #9c9c9e;\n      }\n\n      .cls-278 {\n        fill: #a1a4a6;\n      }\n\n      .cls-279 {\n        fill: #a1a1a3;\n      }\n\n      .cls-280 {\n        fill: #a1a7ab;\n      }\n\n      .cls-281 {\n        fill: #a1a5a6;\n      }\n\n      .cls-282 {\n        fill: #a1a6aa;\n      }\n\n      .cls-283 {\n        fill: #929497;\n      }\n\n      .cls-284 {\n        fill: #929496;\n      }\n\n      .cls-285 {\n        fill: #929495;\n      }\n\n      .cls-286 {\n        fill: #9fa0a2;\n      }\n\n      .cls-287 {\n        fill: #9f9fa1;\n      }\n\n      .cls-288 {\n        fill: #a0a6aa;\n      }\n\n      .cls-289 {\n        fill: #a0a4a5;\n      }\n\n      .cls-290 {\n        fill: #a0a2a4;\n      }\n\n      .cls-291 {\n        fill: #929598;\n      }\n\n      .cls-292 {\n        fill: #929294;\n      }\n\n      .cls-293 {\n        fill: #929395;\n      }\n\n      .cls-294 {\n        fill: #929798;\n      }\n\n      .cls-295 {\n        fill: #929697;\n      }\n\n      .cls-296 {\n        fill: #929699;\n      }\n\n      .cls-297 {\n        fill: #92989b;\n      }\n\n      .cls-298 {\n        fill: #92989c;\n      }\n\n      .cls-299 {\n        fill: #9fa2a4;\n      }\n\n      .cls-300 {\n        fill: #9fa3a4;\n      }\n\n      .cls-301 {\n        fill: #9fa5a8;\n      }\n\n      .cls-302 {\n        fill: #9fa5a9;\n      }\n\n      .cls-303 {\n        fill: #9fa1a3;\n      }\n\n      .cls-304 {\n        fill: #84878b;\n      }\n\n      .cls-305 {\n        fill: #84878c;\n      }\n\n      .cls-306 {\n        fill: #84878a;\n      }\n\n      .cls-307 {\n        fill: #848a8b;\n      }\n\n      .cls-308 {\n        fill: #848689;\n      }\n\n      .cls-309 {\n        fill: #848687;\n      }\n\n      .cls-310 {\n        fill: #848486;\n      }\n\n      .cls-311 {\n        fill: #848485;\n      }\n\n      .cls-312 {\n        fill: #848a8e;\n      }\n\n      .cls-313 {\n        fill: #848586;\n      }\n\n      .cls-314 {\n        fill: #84898a;\n      }\n\n      .cls-315 {\n        fill: #84898c;\n      }\n\n      .cls-316 {\n        fill: #9ea2a3;\n      }\n\n      .cls-317 {\n        fill: #a0a0a2;\n      }\n\n      .cls-318 {\n        fill: #a0a1a3;\n      }\n\n      .cls-319 {\n        fill: #939496;\n      }\n\n      .cls-320 {\n        fill: #939597;\n      }\n\n      .cls-321 {\n        fill: #939598;\n      }\n\n      .cls-322 {\n        fill: #939596;\n      }\n\n      .cls-323 {\n        fill: #93999c;\n      }\n\n      .cls-324 {\n        fill: #93999d;\n      }\n\n      .cls-325 {\n        fill: #939699;\n      }\n\n      .cls-326 {\n        fill: #93979a;\n      }\n\n      .cls-327 {\n        fill: #939798;\n      }\n\n      .cls-328 {\n        fill: #b4b7b9;\n      }\n\n      .cls-329 {\n        fill: #b4b7b8;\n      }\n\n      .cls-330 {\n        fill: #b4babe;\n      }\n\n      .cls-331 {\n        fill: #b4b4b6;\n      }\n\n      .cls-332 {\n        fill: #b4b9bd;\n      }\n\n      .cls-333 {\n        fill: #8a8a8c;\n      }\n\n      .cls-334 {\n        fill: #b5b7b9;\n      }\n\n      .cls-335 {\n        fill: #b5babe;\n      }\n\n      .cls-336 {\n        fill: #b5bbbf;\n      }\n\n      .cls-337 {\n        fill: #b5b8ba;\n      }\n\n      .cls-338 {\n        fill: #b5b8b9;\n      }\n\n      .cls-339 {\n        fill: #b7b9bb;\n      }\n\n      .cls-340 {\n        fill: #b7b7b9;\n      }\n\n      .cls-341 {\n        fill: #b7babc;\n      }\n\n      .cls-342 {\n        fill: #b7babb;\n      }\n\n      .cls-343 {\n        fill: #8a8f90;\n      }\n\n      .cls-344 {\n        fill: #8a9093;\n      }\n\n      .cls-345 {\n        fill: #8a9094;\n      }\n\n      .cls-346 {\n        fill: #8a9091;\n      }\n\n      .cls-347 {\n        fill: #8a8b8d;\n      }\n\n      .cls-348 {\n        fill: #8a8b8c;\n      }\n\n      .cls-349 {\n        fill: #8a8c8f;\n      }\n\n      .cls-350 {\n        fill: #8a8c8d;\n      }\n\n      .cls-351 {\n        fill: #8a8d91;\n      }\n\n      .cls-352 {\n        fill: #8a8d90;\n      }\n\n      .cls-353 {\n        fill: #8a8e91;\n      }\n\n      .cls-354 {\n        fill: #b8b8ba;\n      }\n\n      .cls-355 {\n        fill: #b8babc;\n      }\n\n      .cls-356 {\n        fill: #9d9d9f;\n      }\n\n      .cls-357 {\n        fill: #9d9fa1;\n      }\n\n      .cls-358 {\n        fill: #9da0a2;\n      }\n\n      .cls-359 {\n        fill: #9da1a4;\n      }\n\n      .cls-360 {\n        fill: #9da1a2;\n      }\n\n      .cls-361 {\n        fill: #b8bec1;\n      }\n\n      .cls-362 {\n        fill: #b8bbbc;\n      }\n\n      .cls-363 {\n        fill: #b8bbbd;\n      }\n\n      .cls-364 {\n        fill: #b8bdc1;\n      }\n\n      .cls-365 {\n        fill: #9da3a6;\n      }\n\n      .cls-366 {\n        fill: #9da3a7;\n      }\n\n      .cls-367 {\n        fill: #8b8e91;\n      }\n\n      .cls-368 {\n        fill: #8b8e92;\n      }\n\n      .cls-369 {\n        fill: #8b8f92;\n      }\n\n      .cls-370 {\n        fill: #8b9091;\n      }\n\n      .cls-371 {\n        fill: #8b9192;\n      }\n\n      .cls-372 {\n        fill: #8b9194;\n      }\n\n      .cls-373 {\n        fill: #8b9195;\n      }\n\n      .cls-374 {\n        fill: #9d9ea0;\n      }\n\n      .cls-375 {\n        fill: #9ea0a2;\n      }\n\n      .cls-376 {\n        fill: #9ea4a8;\n      }\n\n      .cls-377 {\n        fill: #9e9ea0;\n      }\n\n      .cls-378 {\n        fill: #9e9fa1;\n      }\n\n      .cls-379 {\n        fill: #9ea4a7;\n      }\n\n      .cls-380 {\n        fill: #9ea1a3;\n      }\n\n      .cls-381 {\n        fill: #9c9ea0;\n      }\n\n      .cls-382 {\n        fill: #a1a3a5;\n      }\n\n      .cls-383 {\n        fill: #a0a3a5;\n      }\n\n      .cls-384 {\n        fill: #b9b9bb;\n      }\n\n      .cls-385 {\n        fill: #8c8e91;\n      }\n\n      .cls-386 {\n        fill: #8c9093;\n      }\n\n      .cls-387 {\n        fill: #8c9295;\n      }\n\n      .cls-388 {\n        fill: #8c9293;\n      }\n\n      .cls-389 {\n        fill: #8c9296;\n      }\n\n      .cls-390 {\n        fill: #8c8f92;\n      }\n\n      .cls-391 {\n        fill: #8c8f93;\n      }\n\n      .cls-392 {\n        fill: #8f9192;\n      }\n\n      .cls-393 {\n        fill: #8f9599;\n      }\n\n      .cls-394 {\n        fill: #8f9598;\n      }\n\n      .cls-395 {\n        fill: #8f9495;\n      }\n\n      .cls-396 {\n        fill: #8f9193;\n      }\n\n      .cls-397 {\n        fill: #c2c7cc;\n      }\n\n      .cls-398 {\n        fill: #c2c8ca;\n      }\n\n      .cls-399 {\n        fill: #919395;\n      }\n\n      .cls-400 {\n        fill: #919396;\n      }\n\n      .cls-401 {\n        fill: #919394;\n      }\n\n      .cls-402 {\n        fill: #919294;\n      }\n\n      .cls-403 {\n        fill: #919497;\n      }\n\n      .cls-404 {\n        fill: #c2c4c5;\n      }\n\n      .cls-405 {\n        fill: #c2c4c6;\n      }\n\n      .cls-406 {\n        fill: #c2c5c6;\n      }\n\n      .cls-407 {\n        fill: #c2c2c4;\n      }\n\n      .cls-408 {\n        fill: #909193;\n      }\n\n      .cls-409 {\n        fill: #909295;\n      }\n\n      .cls-410 {\n        fill: #909092;\n      }\n\n      .cls-411 {\n        fill: #909497;\n      }\n\n      .cls-412 {\n        fill: #909294;\n      }\n\n      .cls-413 {\n        fill: #909293;\n      }\n\n      .cls-414 {\n        fill: #b3b9bd;\n      }\n\n      .cls-415 {\n        fill: #b3b8bc;\n      }\n\n      .cls-416 {\n        fill: #b3b6b7;\n      }\n\n      .cls-417 {\n        fill: #b3b6b8;\n      }\n\n      .cls-418 {\n        fill: #b3b3b5;\n      }\n\n      .cls-419 {\n        fill: #8f9396;\n      }\n\n      .cls-420 {\n        fill: #8f9092;\n      }\n\n      .cls-421 {\n        fill: #8f8f91;\n      }\n\n      .cls-422 {\n        fill: #8f9295;\n      }\n\n      .cls-423 {\n        fill: #909596;\n      }\n\n      .cls-424 {\n        fill: #909396;\n      }\n\n      .cls-425 {\n        fill: #90969a;\n      }\n\n      .cls-426 {\n        fill: #909699;\n      }\n\n      .cls-427 {\n        fill: #c1c7ca;\n      }\n\n      .cls-428 {\n        fill: #b6bcc0;\n      }\n\n      .cls-429 {\n        fill: #c1c1c3;\n      }\n\n      .cls-430 {\n        fill: #c1c3c5;\n      }\n\n      .cls-431 {\n        fill: #c1c3c4;\n      }\n\n      .cls-432 {\n        fill: #c1c6cb;\n      }\n\n      .cls-433 {\n        fill: #c1c4c5;\n      }\n\n      .cls-434 {\n        fill: #b6b6b8;\n      }\n\n      .cls-435 {\n        fill: #b6b9bb;\n      }\n\n      .cls-436 {\n        fill: #b6b9ba;\n      }\n\n      .cls-437 {\n        fill: #b6b8ba;\n      }\n\n      .cls-438 {\n        fill: #b6bbbf;\n      }\n\n      .cls-439 {\n        fill: #666668;\n      }\n\n      .cls-440 {\n        fill: #666667;\n      }\n\n      .cls-441 {\n        fill: #666769;\n      }\n\n      .cls-442 {\n        fill: #666b6e;\n      }\n\n      .cls-443 {\n        fill: #666b6d;\n      }\n\n      .cls-444 {\n        fill: #666c6f;\n      }\n\n      .cls-445 {\n        fill: #73787a;\n      }\n\n      .cls-446 {\n        fill: #73787b;\n      }\n\n      .cls-447 {\n        fill: #73797c;\n      }\n\n      .cls-448 {\n        fill: #737a7b;\n      }\n\n      .cls-449 {\n        fill: #73777b;\n      }\n\n      .cls-450 {\n        fill: #73767b;\n      }\n\n      .cls-451 {\n        fill: #737374;\n      }\n\n      .cls-452 {\n        fill: #737375;\n      }\n\n      .cls-453 {\n        fill: #66696c;\n      }\n\n      .cls-454 {\n        fill: #737475;\n      }\n\n      .cls-455 {\n        fill: #737577;\n      }\n\n      .cls-456 {\n        fill: #737476;\n      }\n\n      .cls-457 {\n        fill: #323437;\n      }\n\n      .cls-458 {\n        fill: #323436;\n      }\n\n      .cls-459 {\n        fill: #323334;\n      }\n\n      .cls-460 {\n        fill: #bababc;\n      }\n\n      .cls-461 {\n        fill: #babfc3;\n      }\n\n      .cls-462 {\n        fill: #bac0c3;\n      }\n\n      .cls-463 {\n        fill: #babdbf;\n      }\n\n      .cls-464 {\n        fill: #babdbe;\n      }\n\n      .cls-465 {\n        fill: #babcbd;\n      }\n\n      .cls-466 {\n        fill: #babcbe;\n      }\n\n      .cls-467 {\n        fill: #323233;\n      }\n\n      .cls-468 {\n        fill: #333538;\n      }\n\n      .cls-469 {\n        fill: #8d9194;\n      }\n\n      .cls-470 {\n        fill: #8d8f91;\n      }\n\n      .cls-471 {\n        fill: #8d8f92;\n      }\n\n      .cls-472 {\n        fill: #8d8f90;\n      }\n\n      .cls-473 {\n        fill: #8d9396;\n      }\n\n      .cls-474 {\n        fill: #8d9397;\n      }\n\n      .cls-475 {\n        fill: #8d9394;\n      }\n\n      .cls-476 {\n        fill: #8d9094;\n      }\n\n      .cls-477 {\n        fill: #8d9093;\n      }\n\n      .cls-478 {\n        fill: #333334;\n      }\n\n      .cls-479 {\n        fill: #33373a;\n      }\n\n      .cls-480 {\n        fill: #333639;\n      }\n\n      .cls-481 {\n        fill: #8e9195;\n      }\n\n      .cls-482 {\n        fill: #8e9194;\n      }\n\n      .cls-483 {\n        fill: #8e9295;\n      }\n\n      .cls-484 {\n        fill: #8e9497;\n      }\n\n      .cls-485 {\n        fill: #8e9495;\n      }\n\n      .cls-486 {\n        fill: #8e9498;\n      }\n\n      .cls-487 {\n        fill: #8e9091;\n      }\n\n      .cls-488 {\n        fill: #8e9092;\n      }\n\n      .cls-489 {\n        fill: #8e9093;\n      }\n\n      .cls-490 {\n        fill: #b9bec2;\n      }\n\n      .cls-491 {\n        fill: #b9bbbc;\n      }\n\n      .cls-492 {\n        fill: #b9bcbd;\n      }\n\n      .cls-493 {\n        fill: #b9bfc2;\n      }\n\n      .cls-494 {\n        fill: #b9bcbe;\n      }\n\n      .cls-495 {\n        fill: #b9bbbd;\n      }\n\n      .cls-496 {\n        fill: #8d8e90;\n      }\n\n      .cls-497 {\n        fill: #8d9293;\n      }\n\n      .cls-498 {\n        fill: #8d8d8f;\n      }\n\n      .cls-499 {\n        fill: #8e9394;\n      }\n\n      .cls-500 {\n        fill: #8e8f91;\n      }\n\n      .cls-501 {\n        fill: #8e8e90;\n      }\n\n      .cls-502 {\n        fill: #8c8d8e;\n      }\n\n      .cls-503 {\n        fill: #8c8d8f;\n      }\n\n      .cls-504 {\n        fill: #8c9192;\n      }\n\n      .cls-505 {\n        fill: #8c8e8f;\n      }\n\n      .cls-506 {\n        fill: #8c8c8e;\n      }\n\n      .cls-507 {\n        fill: #b7bcc0;\n      }\n\n      .cls-508 {\n        fill: #939395;\n      }\n\n      .cls-509 {\n        fill: #939394;\n      }\n\n      .cls-510 {\n        fill: #85888c;\n      }\n\n      .cls-511 {\n        fill: #85888d;\n      }\n\n      .cls-512 {\n        fill: #858b8f;\n      }\n\n      .cls-513 {\n        fill: #858b8c;\n      }\n\n      .cls-514 {\n        fill: #85888b;\n      }\n\n      .cls-515 {\n        fill: #858586;\n      }\n\n      .cls-516 {\n        fill: #858788;\n      }\n\n      .cls-517 {\n        fill: #85878a;\n      }\n\n      .cls-518 {\n        fill: #858687;\n      }\n\n      .cls-519 {\n        fill: #858a8d;\n      }\n\n      .cls-520 {\n        fill: #858a8b;\n      }\n\n      .cls-521 {\n        fill: #858587;\n      }\n\n      .cls-522 {\n        fill: #ced2d4;\n      }\n\n      .cls-523 {\n        fill: #ced2d6;\n      }\n\n      .cls-524 {\n        fill: #ced0d1;\n      }\n\n      .cls-525 {\n        fill: #ced1d2;\n      }\n\n      .cls-526 {\n        fill: #cdd1d6;\n      }\n\n      .cls-527 {\n        fill: #cdd1d3;\n      }\n\n      .cls-528 {\n        fill: #cdcfd0;\n      }\n\n      .cls-529 {\n        fill: #cdd2d5;\n      }\n\n      .cls-530 {\n        fill: #cdd0d1;\n      }\n\n      .cls-531 {\n        fill: #b1b7bb;\n      }\n\n      .cls-532 {\n        fill: #abb0b4;\n      }\n\n      .cls-533 {\n        fill: #abaeaf;\n      }\n\n      .cls-534 {\n        fill: #abaeb0;\n      }\n\n      .cls-535 {\n        fill: #acacae;\n      }\n\n      .cls-536 {\n        fill: #a9a9ab;\n      }\n\n      .cls-537 {\n        fill: #a4a9ad;\n      }\n\n      .cls-538 {\n        fill: #a4a4a6;\n      }\n\n      .cls-539 {\n        fill: #a4a8a9;\n      }\n\n      .cls-540 {\n        fill: #a4a7a9;\n      }\n\n      .cls-541 {\n        fill: #a4aaae;\n      }\n\n      .cls-542 {\n        fill: #a6abaf;\n      }\n\n      .cls-543 {\n        fill: #a6a9aa;\n      }\n\n      .cls-544 {\n        fill: #a6a9ab;\n      }\n\n      .cls-545 {\n        fill: #a6a8aa;\n      }\n\n      .cls-546 {\n        fill: #a6a8a9;\n      }\n\n      .cls-547 {\n        fill: #a9aeb2;\n      }\n\n      .cls-548 {\n        fill: #a9acad;\n      }\n\n      .cls-549 {\n        fill: #a9acae;\n      }\n\n      .cls-550 {\n        fill: #a9abac;\n      }\n\n      .cls-551 {\n        fill: #a9abad;\n      }\n\n      .cls-552 {\n        fill: #b2b4b6;\n      }\n\n      .cls-553 {\n        fill: #b2b5b6;\n      }\n\n      .cls-554 {\n        fill: #b2b5b7;\n      }\n\n      .cls-555 {\n        fill: #a6a6a8;\n      }\n\n      .cls-556 {\n        fill: #a6acb0;\n      }\n\n      .cls-557 {\n        fill: #bfc1c3;\n      }\n\n      .cls-558 {\n        fill: #bfc1c2;\n      }\n\n      .cls-559 {\n        fill: #b1b1b3;\n      }\n\n      .cls-560 {\n        fill: #b1b4b5;\n      }\n\n      .cls-561 {\n        fill: #b1b4b6;\n      }\n\n      .cls-562 {\n        fill: #b2b8bc;\n      }\n\n      .cls-563 {\n        fill: #b2b7bb;\n      }\n\n      .cls-564 {\n        fill: #bcc1c5;\n      }\n\n      .cls-565 {\n        fill: #bcbec0;\n      }\n\n      .cls-566 {\n        fill: #bcbebf;\n      }\n\n      .cls-567 {\n        fill: #bcbfc1;\n      }\n\n      .cls-568 {\n        fill: #bcbfc0;\n      }\n\n      .cls-569 {\n        fill: #aaaaac;\n      }\n\n      .cls-570 {\n        fill: #bcbcbe;\n      }\n\n      .cls-571 {\n        fill: #a7a7a9;\n      }\n\n      .cls-572 {\n        fill: #a7aaab;\n      }\n\n      .cls-573 {\n        fill: #a7aaac;\n      }\n\n      .cls-574 {\n        fill: #a7a9aa;\n      }\n\n      .cls-575 {\n        fill: #a7a9ab;\n      }\n\n      .cls-576 {\n        fill: #b0b0b2;\n      }\n\n      .cls-577 {\n        fill: #b0b5b9;\n      }\n\n      .cls-578 {\n        fill: #b0b2b3;\n      }\n\n      .cls-579 {\n        fill: #b0b6ba;\n      }\n\n      .cls-580 {\n        fill: #afb2b4;\n      }\n\n      .cls-581 {\n        fill: #afb2b3;\n      }\n\n      .cls-582 {\n        fill: #adb2b6;\n      }\n\n      .cls-583 {\n        fill: #adafb1;\n      }\n\n      .cls-584 {\n        fill: #adafb0;\n      }\n\n      .cls-585 {\n        fill: #adb0b1;\n      }\n\n      .cls-586 {\n        fill: #adb0b2;\n      }\n\n      .cls-587 {\n        fill: #afb4b8;\n      }\n\n      .cls-588 {\n        fill: #b0b3b4;\n      }\n\n      .cls-589 {\n        fill: #b0b3b5;\n      }\n\n      .cls-590 {\n        fill: #d8dcdf;\n      }\n\n      .cls-591 {\n        fill: #d8dcdd;\n      }\n\n      .cls-592 {\n        fill: #d8dbdc;\n      }\n\n      .cls-593 {\n        fill: #d8dbdd;\n      }\n\n      .cls-594 {\n        fill: #a5a8aa;\n      }\n\n      .cls-595 {\n        fill: #a5abaf;\n      }\n\n      .cls-596 {\n        fill: #a5a5a7;\n      }\n\n      .cls-597 {\n        fill: #bfc4c9;\n      }\n\n      .cls-598 {\n        fill: #b2b2b4;\n      }\n\n      .cls-599 {\n        fill: #bfc2c3;\n      }\n\n      .cls-600 {\n        fill: #bfc5c8;\n      }\n\n      .cls-601 {\n        fill: #b1b3b4;\n      }\n\n      .cls-602 {\n        fill: #b1b6ba;\n      }\n\n      .cls-603 {\n        fill: #aeb4b8;\n      }\n\n      .cls-604 {\n        fill: #a5a7a9;\n      }\n\n      .cls-605 {\n        fill: #a5a7a8;\n      }\n\n      .cls-606 {\n        fill: #a5aaae;\n      }\n\n      .cls-607 {\n        fill: #aeaeb0;\n      }\n\n      .cls-608 {\n        fill: #aeb1b3;\n      }\n\n      .cls-609 {\n        fill: #aeb1b2;\n      }\n\n      .cls-610 {\n        fill: #aeb3b7;\n      }\n\n      .cls-611 {\n        fill: #aeb0b1;\n      }\n\n      .cls-612 {\n        fill: #bbbdbe;\n      }\n\n      .cls-613 {\n        fill: #bbbdbf;\n      }\n\n      .cls-614 {\n        fill: #bbbbbd;\n      }\n\n      .cls-615 {\n        fill: #bbc0c4;\n      }\n\n      .cls-616 {\n        fill: #bbc1c4;\n      }\n\n      .cls-617 {\n        fill: #bbbebf;\n      }\n\n      .cls-618 {\n        fill: #bbbec0;\n      }\n\n      .cls-619 {\n        fill: #bdc3c6;\n      }\n\n      .cls-620 {\n        fill: #bdc2c7;\n      }\n\n      .cls-621 {\n        fill: #aaadaf;\n      }\n\n      .cls-622 {\n        fill: #aaadae;\n      }\n\n      .cls-623 {\n        fill: #aaacad;\n      }\n\n      .cls-624 {\n        fill: #aaacae;\n      }\n\n      .cls-625 {\n        fill: #bcc2c5;\n      }\n\n      .cls-626 {\n        fill: #a4a6a7;\n      }\n\n      .cls-627 {\n        fill: #a4a6a8;\n      }\n\n      .cls-628 {\n        fill: #a7acb0;\n      }\n\n      .cls-629 {\n        fill: #c0c3c4;\n      }\n\n      .cls-630 {\n        fill: #c0c6c9;\n      }\n\n      .cls-631 {\n        fill: #c0c2c4;\n      }\n\n      .cls-632 {\n        fill: #c0c2c3;\n      }\n\n      .cls-633 {\n        fill: #c0c5ca;\n      }\n\n      .cls-634 {\n        fill: #bec4c7;\n      }\n\n      .cls-635 {\n        fill: #bec3c8;\n      }\n\n      .cls-636 {\n        fill: #bfbfc1;\n      }\n\n      .cls-637 {\n        fill: #bdc0c1;\n      }\n\n      .cls-638 {\n        fill: #bdc0c2;\n      }\n\n      .cls-639 {\n        fill: #bdbfc1;\n      }\n\n      .cls-640 {\n        fill: #bdbfc0;\n      }\n\n      .cls-641 {\n        fill: #bdbdbf;\n      }\n\n      .cls-642 {\n        fill: #aaafb3;\n      }\n\n      .cls-643 {\n        fill: #c0c0c2;\n      }\n\n      .cls-644 {\n        fill: #ababad;\n      }\n\n      .cls-645 {\n        fill: #abadae;\n      }\n\n      .cls-646 {\n        fill: #abadaf;\n      }\n\n      .cls-647 {\n        fill: #bec1c2;\n      }\n\n      .cls-648 {\n        fill: #bebec0;\n      }\n\n      .cls-649 {\n        fill: #bec0c1;\n      }\n\n      .cls-650 {\n        fill: #bec0c2;\n      }\n\n      .cls-651 {\n        fill: #ccd0d2;\n      }\n\n      .cls-652 {\n        fill: #c4c9cc;\n      }\n\n      .cls-653 {\n        fill: #c4c9ce;\n      }\n\n      .cls-654 {\n        fill: #c4c9cd;\n      }\n\n      .cls-655 {\n        fill: #ccd1d5;\n      }\n\n      .cls-656 {\n        fill: #ccd1d4;\n      }\n\n      .cls-657 {\n        fill: #cccecf;\n      }\n\n      .cls-658 {\n        fill: #cccfd0;\n      }\n\n      .cls-659 {\n        fill: #cbd0d4;\n      }\n\n      .cls-660 {\n        fill: #cbd0d3;\n      }\n\n      .cls-661 {\n        fill: #c6c9ca;\n      }\n\n      .cls-662 {\n        fill: #cacccd;\n      }\n\n      .cls-663 {\n        fill: #caccce;\n      }\n\n      .cls-664 {\n        fill: #cacdce;\n      }\n\n      .cls-665 {\n        fill: #cacfd3;\n      }\n\n      .cls-666 {\n        fill: #cacfd2;\n      }\n\n      .cls-667 {\n        fill: #c9cbcd;\n      }\n\n      .cls-668 {\n        fill: #c9cbcc;\n      }\n\n      .cls-669 {\n        fill: #c9ced2;\n      }\n\n      .cls-670 {\n        fill: #c9cccd;\n      }\n\n      .cls-671 {\n        fill: #c9ced1;\n      }\n\n      .cls-672 {\n        fill: #d0d3d4;\n      }\n\n      .cls-673 {\n        fill: #d0d4d6;\n      }\n\n      .cls-674 {\n        fill: #d0d4d8;\n      }\n\n      .cls-675 {\n        fill: #d0d2d3;\n      }\n\n      .cls-676 {\n        fill: #cfd3d6;\n      }\n\n      .cls-677 {\n        fill: #cfd1d2;\n      }\n\n      .cls-678 {\n        fill: #c7c9cb;\n      }\n\n      .cls-679 {\n        fill: #c7c9ca;\n      }\n\n      .cls-680 {\n        fill: #c7ccd0;\n      }\n\n      .cls-681 {\n        fill: #c7cccf;\n      }\n\n      .cls-682 {\n        fill: #c7cacb;\n      }\n\n      .cls-683 {\n        fill: #dee0e1;\n      }\n\n      .cls-684 {\n        fill: #dee1e2;\n      }\n\n      .cls-685 {\n        fill: #dddfe0;\n      }\n\n      .cls-686 {\n        fill: #dde0e1;\n      }\n\n      .cls-687 {\n        fill: #dde0e2;\n      }\n\n      .cls-688 {\n        fill: #dde1e3;\n      }\n\n      .cls-689 {\n        fill: #cbcecf;\n      }\n\n      .cls-690 {\n        fill: #cbcfd1;\n      }\n\n      .cls-691 {\n        fill: #cbcdcf;\n      }\n\n      .cls-692 {\n        fill: #cbcdce;\n      }\n\n      .cls-693 {\n        fill: #d2d6da;\n      }\n\n      .cls-694 {\n        fill: #d2d6d8;\n      }\n\n      .cls-695 {\n        fill: #d2d5d8;\n      }\n\n      .cls-696 {\n        fill: #d2d5d6;\n      }\n\n      .cls-697 {\n        fill: #d2d4d5;\n      }\n\n      .cls-698 {\n        fill: #d1d5d9;\n      }\n\n      .cls-699 {\n        fill: #d1d5d7;\n      }\n\n      .cls-700 {\n        fill: #d1d4d7;\n      }\n\n      .cls-701 {\n        fill: #d1d4d5;\n      }\n\n      .cls-702 {\n        fill: #d1d3d4;\n      }\n\n      .cls-703 {\n        fill: #cfd2d3;\n      }\n\n      .cls-704 {\n        fill: #cfd3d5;\n      }\n\n      .cls-705 {\n        fill: #cfd3d7;\n      }\n\n      .cls-706 {\n        fill: #c3c6c7;\n      }\n\n      .cls-707 {\n        fill: #c3c5c7;\n      }\n\n      .cls-708 {\n        fill: #c3c5c6;\n      }\n\n      .cls-709 {\n        fill: #c3c3c5;\n      }\n\n      .cls-710 {\n        fill: #c3c9cb;\n      }\n\n      .cls-711 {\n        fill: #c3c8cd;\n      }\n\n      .cls-712 {\n        fill: #c4c7c8;\n      }\n\n      .cls-713 {\n        fill: #c4c6c8;\n      }\n\n      .cls-714 {\n        fill: #c4c6c7;\n      }\n\n      .cls-715 {\n        fill: #d6d9db;\n      }\n\n      .cls-716 {\n        fill: #d6d9da;\n      }\n\n      .cls-717 {\n        fill: #d6dadd;\n      }\n\n      .cls-718 {\n        fill: #d6dadb;\n      }\n\n      .cls-719 {\n        fill: #d3d7d9;\n      }\n\n      .cls-720 {\n        fill: #d3d7db;\n      }\n\n      .cls-721 {\n        fill: #dce0e3;\n      }\n\n      .cls-722 {\n        fill: #dce0e0;\n      }\n\n      .cls-723 {\n        fill: #dcdfe1;\n      }\n\n      .cls-724 {\n        fill: #dcdfe0;\n      }\n\n      .cls-725 {\n        fill: #dfe1e2;\n      }\n\n      .cls-726 {\n        fill: #dbdee0;\n      }\n\n      .cls-727 {\n        fill: #dbdedf;\n      }\n\n      .cls-728 {\n        fill: #dbdfe2;\n      }\n\n      .cls-729 {\n        fill: #dbdfdf;\n      }\n\n      .cls-730 {\n        fill: #d4d7d8;\n      }\n\n      .cls-731 {\n        fill: #d4d7d9;\n      }\n\n      .cls-732 {\n        fill: #d4d8da;\n      }\n\n      .cls-733 {\n        fill: #d4d8dc;\n      }\n\n      .cls-734 {\n        fill: #dadddf;\n      }\n\n      .cls-735 {\n        fill: #dadee1;\n      }\n\n      .cls-736 {\n        fill: #dadede;\n      }\n\n      .cls-737 {\n        fill: #daddde;\n      }\n\n      .cls-738 {\n        fill: #d9dde0;\n      }\n\n      .cls-739 {\n        fill: #d9ddde;\n      }\n\n      .cls-740 {\n        fill: #d4d6d7;\n      }\n\n      .cls-741 {\n        fill: #d9dcdd;\n      }\n\n      .cls-742 {\n        fill: #d9dcde;\n      }\n\n      .cls-743 {\n        fill: #afafb1;\n      }\n\n      .cls-744 {\n        fill: #afb5b9;\n      }\n\n      .cls-745 {\n        fill: #afb1b2;\n      }\n\n      .cls-746 {\n        fill: #dfe3e5;\n      }\n\n      .cls-747 {\n        fill: #d7dbde;\n      }\n\n      .cls-748 {\n        fill: #d7dadc;\n      }\n\n      .cls-749 {\n        fill: #d7dadb;\n      }\n\n      .cls-750 {\n        fill: #d7dbdc;\n      }\n\n      .cls-751 {\n        fill: #acafb0;\n      }\n\n      .cls-752 {\n        fill: #acafb1;\n      }\n\n      .cls-753 {\n        fill: #acb1b5;\n      }\n\n      .cls-754 {\n        fill: #acaeb0;\n      }\n\n      .cls-755 {\n        fill: #acaeaf;\n      }\n\n      .cls-756 {\n        fill: #adadaf;\n      }\n\n      .cls-757 {\n        fill: #d3d6d7;\n      }\n\n      .cls-758 {\n        fill: #d3d6d8;\n      }\n\n      .cls-759 {\n        fill: #d3d5d6;\n      }\n\n      .cls-760 {\n        fill: #c5c7c9;\n      }\n\n      .cls-761 {\n        fill: #c5c7c8;\n      }\n\n      .cls-762 {\n        fill: #c5c8c9;\n      }\n\n      .cls-763 {\n        fill: #c5cacd;\n      }\n\n      .cls-764 {\n        fill: #c5cace;\n      }\n\n      .cls-765 {\n        fill: #c5cacf;\n      }\n\n      .cls-766 {\n        fill: #c6cbcf;\n      }\n\n      .cls-767 {\n        fill: #c6cbd0;\n      }\n\n      .cls-768 {\n        fill: #c6c8c9;\n      }\n\n      .cls-769 {\n        fill: #c6c8ca;\n      }\n\n      .cls-770 {\n        fill: #c6cbce;\n      }\n\n      .cls-771 {\n        fill: #e1e4e5;\n      }\n\n      .cls-772 {\n        fill: #e1e4e6;\n      }\n\n      .cls-773 {\n        fill: #e1e3e4;\n      }\n\n      .cls-774 {\n        fill: #e0e3e4;\n      }\n\n      .cls-775 {\n        fill: #e0e2e3;\n      }\n\n      .cls-776 {\n        fill: #c8cacc;\n      }\n\n      .cls-777 {\n        fill: #c8cacb;\n      }\n\n      .cls-778 {\n        fill: #c8cdd1;\n      }\n\n      .cls-779 {\n        fill: #c8cbcc;\n      }\n\n      .cls-780 {\n        fill: #c8cdd0;\n      }\n\n      .cls-781 {\n        fill: #d5d9da;\n      }\n\n      .cls-782 {\n        fill: #d5d9dd;\n      }\n\n      .cls-783 {\n        fill: #d5d8d9;\n      }\n\n      .cls-784 {\n        fill: #d5d8da;\n      }\n\n      .cls-785 {\n        fill: #dee2e4;\n      }\n\n      .cls-786 {\n        fill: #dfe2e3;\n      }\n\n      .cls-787 {\n        fill: #a8aaac;\n      }\n\n      .cls-788 {\n        fill: #a8a8aa;\n      }\n\n      .cls-789 {\n        fill: #a8aaab;\n      }\n\n      .cls-790 {\n        fill: #a8abac;\n      }\n\n      .cls-791 {\n        fill: #a8abad;\n      }\n\n      .cls-792 {\n        fill: #a8adb1;\n      }\n\n      .cls-793 {\n        fill: #424447;\n      }\n\n      .cls-794 {\n        fill: #424548;\n      }\n\n      .cls-795 {\n        fill: #434649;\n      }\n\n      .cls-796 {\n        fill: #404245;\n      }\n\n      .cls-797 {\n        fill: #414346;\n      }\n\n      .cls-798 {\n        fill: #363b3f;\n      }\n\n      .cls-799 {\n        fill: #363739;\n      }\n\n      .cls-800 {\n        fill: #363c42;\n      }\n\n      .cls-801 {\n        fill: #363c41;\n      }\n\n      .cls-802 {\n        fill: #373e44;\n      }\n\n      .cls-803 {\n        fill: #373d43;\n      }\n\n      .cls-804 {\n        fill: #37383a;\n      }\n\n      .cls-805 {\n        fill: #44474a;\n      }\n\n      .cls-806 {\n        fill: #3e4043;\n      }\n\n      .cls-807 {\n        fill: #3f4144;\n      }\n\n      .cls-808 {\n        fill: #898d90;\n      }\n\n      .cls-809 {\n        fill: #898f93;\n      }\n\n      .cls-810 {\n        fill: #898f90;\n      }\n\n      .cls-811 {\n        fill: #898f92;\n      }\n\n      .cls-812 {\n        fill: #a3a3a5;\n      }\n\n      .cls-813 {\n        fill: #a3a8ac;\n      }\n\n      .cls-814 {\n        fill: #a3a9ad;\n      }\n\n      .cls-815 {\n        fill: #a3a7a8;\n      }\n\n      .cls-816 {\n        fill: #a3a6a8;\n      }\n\n      .cls-817 {\n        fill: #a3a5a6;\n      }\n\n      .cls-818 {\n        fill: #a3a5a7;\n      }\n\n      .cls-819 {\n        fill: #9b9fa0;\n      }\n\n      .cls-820 {\n        fill: #9b9fa2;\n      }\n\n      .cls-821 {\n        fill: #9ba1a4;\n      }\n\n      .cls-822 {\n        fill: #9b9c9e;\n      }\n\n      .cls-823 {\n        fill: #9ba1a5;\n      }\n\n      .cls-824 {\n        fill: #9b9b9d;\n      }\n\n      .cls-825 {\n        fill: #707071;\n      }\n\n      .cls-826 {\n        fill: #707778;\n      }\n\n      .cls-827 {\n        fill: #707274;\n      }\n\n      .cls-828 {\n        fill: #707578;\n      }\n\n      .cls-829 {\n        fill: #707577;\n      }\n\n      .cls-830 {\n        fill: #70757a;\n      }\n\n      .cls-831 {\n        fill: #707479;\n      }\n\n      .cls-832 {\n        fill: #707478;\n      }\n\n      .cls-833 {\n        fill: #707172;\n      }\n\n      .cls-834 {\n        fill: #707173;\n      }\n\n      .cls-835 {\n        fill: #707072;\n      }\n\n      .cls-836 {\n        fill: #707679;\n      }\n\n      .cls-837 {\n        fill: #6f7476;\n      }\n\n      .cls-838 {\n        fill: #6f7477;\n      }\n\n      .cls-839 {\n        fill: #71777a;\n      }\n\n      .cls-840 {\n        fill: #717173;\n      }\n\n      .cls-841 {\n        fill: #717172;\n      }\n\n      .cls-842 {\n        fill: #717375;\n      }\n\n      .cls-843 {\n        fill: #717579;\n      }\n\n      .cls-844 {\n        fill: #717879;\n      }\n\n      .cls-845 {\n        fill: #717679;\n      }\n\n      .cls-846 {\n        fill: #717678;\n      }\n\n      .cls-847 {\n        fill: #71767b;\n      }\n\n      .cls-848 {\n        fill: #717479;\n      }\n\n      .cls-849 {\n        fill: #949799;\n      }\n\n      .cls-850 {\n        fill: #94979a;\n      }\n\n      .cls-851 {\n        fill: #949597;\n      }\n\n      .cls-852 {\n        fill: #949496;\n      }\n\n      .cls-853 {\n        fill: #949495;\n      }\n\n      .cls-854 {\n        fill: #949899;\n      }\n\n      .cls-855 {\n        fill: #94989b;\n      }\n\n      .cls-856 {\n        fill: #949699;\n      }\n\n      .cls-857 {\n        fill: #949698;\n      }\n\n      .cls-858 {\n        fill: #949697;\n      }\n\n      .cls-859 {\n        fill: #949a9e;\n      }\n\n      .cls-860 {\n        fill: #949a9d;\n      }\n\n      .cls-861 {\n        fill: #6f7578;\n      }\n\n      .cls-862 {\n        fill: #6f7377;\n      }\n\n      .cls-863 {\n        fill: #6f7378;\n      }\n\n      .cls-864 {\n        fill: #6f6f70;\n      }\n\n      .cls-865 {\n        fill: #6f6f71;\n      }\n\n      .cls-866 {\n        fill: #727273;\n      }\n\n      .cls-867 {\n        fill: #727274;\n      }\n\n      .cls-868 {\n        fill: #6f7677;\n      }\n\n      .cls-869 {\n        fill: #6f7072;\n      }\n\n      .cls-870 {\n        fill: #6f7071;\n      }\n\n      .cls-871 {\n        fill: #6f7173;\n      }\n\n      .cls-872 {\n        fill: #a2a5a7;\n      }\n\n      .cls-873 {\n        fill: #a2a4a5;\n      }\n\n      .cls-874 {\n        fill: #a2a4a6;\n      }\n\n      .cls-875 {\n        fill: #a2a8ac;\n      }\n\n      .cls-876 {\n        fill: #a2a7ab;\n      }\n\n      .cls-877 {\n        fill: #a2a6a7;\n      }\n\n      .cls-878 {\n        fill: #a2a2a4;\n      }\n\n      .cls-879 {\n        fill: #959596;\n      }\n\n      .cls-880 {\n        fill: #959597;\n      }\n\n      .cls-881 {\n        fill: #95989a;\n      }\n\n      .cls-882 {\n        fill: #959799;\n      }\n\n      .cls-883 {\n        fill: #95979a;\n      }\n\n      .cls-884 {\n        fill: #959798;\n      }\n\n      .cls-885 {\n        fill: #959698;\n      }\n\n      .cls-886 {\n        fill: #95999a;\n      }\n\n      .cls-887 {\n        fill: #95999c;\n      }\n\n      .cls-888 {\n        fill: #959b9e;\n      }\n\n      .cls-889 {\n        fill: #959b9f;\n      }\n\n      .cls-890 {\n        fill: #898c8f;\n      }\n\n      .cls-891 {\n        fill: #898c90;\n      }\n\n      .cls-892 {\n        fill: #898e8f;\n      }\n\n      .cls-893 {\n        fill: #898b8e;\n      }\n\n      .cls-894 {\n        fill: #898b8c;\n      }\n\n      .cls-895 {\n        fill: #545456;\n      }\n\n      .cls-896 {\n        fill: #464647;\n      }\n\n      .cls-897 {\n        fill: #545556;\n      }\n\n      .cls-898 {\n        fill: #545455;\n      }\n\n      .cls-899 {\n        fill: #53585d;\n      }\n\n      .cls-900 {\n        fill: #535455;\n      }\n\n      .cls-901 {\n        fill: #535a5c;\n      }\n\n      .cls-902 {\n        fill: #46494c;\n      }\n\n      .cls-903 {\n        fill: #535355;\n      }\n\n      .cls-904 {\n        fill: #535354;\n      }\n\n      .cls-905 {\n        fill: #868b8e;\n      }\n\n      .cls-906 {\n        fill: #868b8c;\n      }\n\n      .cls-907 {\n        fill: #868c90;\n      }\n\n      .cls-908 {\n        fill: #868c8d;\n      }\n\n      .cls-909 {\n        fill: #868688;\n      }\n\n      .cls-910 {\n        fill: #868687;\n      }\n\n      .cls-911 {\n        fill: #86898e;\n      }\n\n      .cls-912 {\n        fill: #86898c;\n      }\n\n      .cls-913 {\n        fill: #86898d;\n      }\n\n      .cls-914 {\n        fill: #868788;\n      }\n\n      .cls-915 {\n        fill: #878c8d;\n      }\n\n      .cls-916 {\n        fill: #86888b;\n      }\n\n      .cls-917 {\n        fill: #868889;\n      }\n\n      .cls-918 {\n        fill: #878d90;\n      }\n\n      .cls-919 {\n        fill: #878d8e;\n      }\n\n      .cls-920 {\n        fill: #878d91;\n      }\n\n      .cls-921 {\n        fill: #9b9d9f;\n      }\n\n      .cls-922 {\n        fill: #9b9d9e;\n      }\n\n      .cls-923 {\n        fill: #9aa0a3;\n      }\n\n      .cls-924 {\n        fill: #9aa0a4;\n      }\n\n      .cls-925 {\n        fill: #9a9b9d;\n      }\n\n      .cls-926 {\n        fill: #9a9c9f;\n      }\n\n      .cls-927 {\n        fill: #9a9c9d;\n      }\n\n      .cls-928 {\n        fill: #9a9c9e;\n      }\n\n      .cls-929 {\n        fill: #9a9d9f;\n      }\n\n      .cls-930 {\n        fill: #9a9e9f;\n      }\n\n      .cls-931 {\n        fill: #9a9ea1;\n      }\n\n      .cls-932 {\n        fill: #9a9a9c;\n      }\n\n      .cls-933 {\n        fill: #898a8b;\n      }\n\n      .cls-934 {\n        fill: #898a8c;\n      }\n\n      .cls-935 {\n        fill: #89898a;\n      }\n\n      .cls-936 {\n        fill: #89898b;\n      }\n\n      .cls-937 {\n        fill: #6d6d6f;\n      }\n\n      .cls-938 {\n        fill: #6d6d6e;\n      }\n\n      .cls-939 {\n        fill: #6e7477;\n      }\n\n      .cls-940 {\n        fill: #6e6f71;\n      }\n\n      .cls-941 {\n        fill: #6e6f70;\n      }\n\n      .cls-942 {\n        fill: #6e6e6f;\n      }\n\n      .cls-943 {\n        fill: #6e6e70;\n      }\n\n      .cls-944 {\n        fill: #6e7375;\n      }\n\n      .cls-945 {\n        fill: #6e7376;\n      }\n\n      .cls-946 {\n        fill: #6e7072;\n      }\n\n      .cls-947 {\n        fill: #6e7277;\n      }\n\n      .cls-948 {\n        fill: #6e7276;\n      }\n\n      .cls-949 {\n        fill: #888a8b;\n      }\n\n      .cls-950 {\n        fill: #888a8d;\n      }\n\n      .cls-951 {\n        fill: #88898a;\n      }\n\n      .cls-952 {\n        fill: #888889;\n      }\n\n      .cls-953 {\n        fill: #88888a;\n      }\n\n      .cls-954 {\n        fill: #888e8f;\n      }\n\n      .cls-955 {\n        fill: #888e91;\n      }\n\n      .cls-956 {\n        fill: #888c8f;\n      }\n\n      .cls-957 {\n        fill: #888d8e;\n      }\n\n      .cls-958 {\n        fill: #888e92;\n      }\n\n      .cls-959 {\n        fill: #888b8e;\n      }\n\n      .cls-960 {\n        fill: #888b8f;\n      }\n\n      .cls-961 {\n        fill: #878889;\n      }\n\n      .cls-962 {\n        fill: #87898a;\n      }\n\n      .cls-963 {\n        fill: #87898c;\n      }\n\n      .cls-964 {\n        fill: #878b8e;\n      }\n\n      .cls-965 {\n        fill: #878789;\n      }\n\n      .cls-966 {\n        fill: #878788;\n      }\n\n      .cls-967 {\n        fill: #878a8e;\n      }\n\n      .cls-968 {\n        fill: #878a8d;\n      }\n\n      .cls-969 {\n        fill: #9b9ea0;\n      }\n\n      .cls-970 {\n        fill: #6d6e6f;\n      }\n\n      .cls-971 {\n        fill: #6d6e70;\n      }\n\n      .cls-972 {\n        fill: #6d7274;\n      }\n\n      .cls-973 {\n        fill: #6d7275;\n      }\n\n      .cls-974 {\n        fill: #6d6f71;\n      }\n\n      .cls-975 {\n        fill: #6d7175;\n      }\n\n      .cls-976 {\n        fill: #6d7176;\n      }\n\n      .cls-977 {\n        fill: #6d7376;\n      }\n\n      .cls-978 {\n        fill: #707378;\n      }\n\n      .cls-979 {\n        fill: #808285;\n      }\n\n      .cls-980 {\n        fill: #808284;\n      }\n\n      .cls-981 {\n        fill: #808283;\n      }\n\n      .cls-982 {\n        fill: #808081;\n      }\n\n      .cls-983 {\n        fill: #808182;\n      }\n\n      .cls-984 {\n        fill: #64676a;\n      }\n\n      .cls-985 {\n        fill: #555657;\n      }\n\n      .cls-986 {\n        fill: #555658;\n      }\n\n      .cls-987 {\n        fill: #555556;\n      }\n\n      .cls-988 {\n        fill: #555557;\n      }\n\n      .cls-989 {\n        fill: #555c5e;\n      }\n\n      .cls-990 {\n        fill: #555a60;\n      }\n\n      .cls-991 {\n        fill: #646a6d;\n      }\n\n      .cls-992 {\n        fill: #646567;\n      }\n\n      .cls-993 {\n        fill: #64696c;\n      }\n\n      .cls-994 {\n        fill: #64696b;\n      }\n\n      .cls-995 {\n        fill: #646466;\n      }\n\n      .cls-996 {\n        fill: #646465;\n      }\n\n      .cls-997 {\n        fill: #63696c;\n      }\n\n      .cls-998 {\n        fill: #63686b;\n      }\n\n      .cls-999 {\n        fill: #63686a;\n      }\n\n      .cls-1000 {\n        fill: #636568;\n      }\n\n      .cls-1001 {\n        fill: #636466;\n      }\n\n      .cls-1002 {\n        fill: #636365;\n      }\n\n      .cls-1003 {\n        fill: #636364;\n      }\n\n      .cls-1004 {\n        fill: #626769;\n      }\n\n      .cls-1005 {\n        fill: #62676a;\n      }\n\n      .cls-1006 {\n        fill: #62686b;\n      }\n\n      .cls-1007 {\n        fill: #565b61;\n      }\n\n      .cls-1008 {\n        fill: #626365;\n      }\n\n      .cls-1009 {\n        fill: #626264;\n      }\n\n      .cls-1010 {\n        fill: #626263;\n      }\n\n      .cls-1011 {\n        fill: #626467;\n      }\n\n      .cls-1012 {\n        fill: #5b5c5d;\n      }\n\n      .cls-1013 {\n        fill: #5b5d5f;\n      }\n\n      .cls-1014 {\n        fill: #5b5c5e;\n      }\n\n      .cls-1015 {\n        fill: #5b5b5d;\n      }\n\n      .cls-1016 {\n        fill: #5b5b5c;\n      }\n\n      .cls-1017 {\n        fill: #5b6164;\n      }\n\n      .cls-1018 {\n        fill: #595f62;\n      }\n\n      .cls-1019 {\n        fill: #595f65;\n      }\n\n      .cls-1020 {\n        fill: #595a5c;\n      }\n\n      .cls-1021 {\n        fill: #595a5b;\n      }\n\n      .cls-1022 {\n        fill: #59595a;\n      }\n\n      .cls-1023 {\n        fill: #59595b;\n      }\n\n      .cls-1024 {\n        fill: #565758;\n      }\n\n      .cls-1025 {\n        fill: #565759;\n      }\n\n      .cls-1026 {\n        fill: #565658;\n      }\n\n      .cls-1027 {\n        fill: #565657;\n      }\n\n      .cls-1028 {\n        fill: #5c6265;\n      }\n\n      .cls-1029 {\n        fill: #636669;\n      }\n\n      .cls-1030 {\n        fill: #4a5153;\n      }\n\n      .cls-1031 {\n        fill: #4a4a4b;\n      }\n\n      .cls-1032 {\n        fill: #4a4e51;\n      }\n\n      .cls-1033 {\n        fill: #474748;\n      }\n\n      .cls-1034 {\n        fill: #484f51;\n      }\n\n      .cls-1035 {\n        fill: #484849;\n      }\n\n      .cls-1036 {\n        fill: #484c4f;\n      }\n\n      .cls-1037 {\n        fill: #484b4e;\n      }\n\n      .cls-1038 {\n        fill: #474a4d;\n      }\n\n      .cls-1039 {\n        fill: #353a3e;\n      }\n\n      .cls-1040 {\n        fill: #5c5d5e;\n      }\n\n      .cls-1041 {\n        fill: #5c5c5d;\n      }\n\n      .cls-1042 {\n        fill: #5c5c5e;\n      }\n\n      .cls-1043 {\n        fill: #5c5e60;\n      }\n\n      .cls-1044 {\n        fill: #394148;\n      }\n\n      .cls-1045 {\n        fill: #38393b;\n      }\n\n      .cls-1046 {\n        fill: #383f45;\n      }\n\n      .cls-1047 {\n        fill: #383f46;\n      }\n\n      .cls-1048 {\n        fill: #313132;\n      }\n\n      .cls-1049 {\n        fill: #313233;\n      }\n\n      .cls-1050 {\n        fill: #3a3c3e;\n      }\n\n      .cls-1051 {\n        fill: #3a3b3d;\n      }\n\n      .cls-1052 {\n        fill: #3b3d3f;\n      }\n\n      .cls-1053 {\n        fill: #353638;\n      }\n\n      .cls-1054 {\n        fill: #35393d;\n      }\n\n      .cls-1055 {\n        fill: #3d3f41;\n      }\n\n      .cls-1056 {\n        fill: #5a5b5c;\n      }\n\n      .cls-1057 {\n        fill: #5a5b5d;\n      }\n\n      .cls-1058 {\n        fill: #5a5a5c;\n      }\n\n      .cls-1059 {\n        fill: #5a5a5b;\n      }\n\n      .cls-1060 {\n        fill: #5a6063;\n      }\n\n      .cls-1061 {\n        fill: #5a6066;\n      }\n\n      .cls-1062 {\n        fill: #394047;\n      }\n\n      .cls-1063 {\n        fill: #393a3c;\n      }\n\n      .cls-1064 {\n        fill: #585859;\n      }\n\n      .cls-1065 {\n        fill: #58585a;\n      }\n\n      .cls-1066 {\n        fill: #58595a;\n      }\n\n      .cls-1067 {\n        fill: #58595b;\n      }\n\n      .cls-1068 {\n        fill: #585e64;\n      }\n\n      .cls-1069 {\n        fill: #585e61;\n      }\n\n      .cls-1070 {\n        fill: #585d63;\n      }\n\n      .cls-1071 {\n        fill: #57585a;\n      }\n\n      .cls-1072 {\n        fill: #575859;\n      }\n\n      .cls-1073 {\n        fill: #575759;\n      }\n\n      .cls-1074 {\n        fill: #575758;\n      }\n\n      .cls-1075 {\n        fill: #575c62;\n      }\n\n      .cls-1076 {\n        fill: #575d60;\n      }\n\n      .cls-1077 {\n        fill: #3c3c3c;\n      }\n\n      .cls-1078 {\n        fill: #3c3e40;\n      }\n\n      .cls-1079 {\n        fill: #828487;\n      }\n\n      .cls-1080 {\n        fill: #828486;\n      }\n\n      .cls-1081 {\n        fill: #828485;\n      }\n\n      .cls-1082 {\n        fill: #828384;\n      }\n\n      .cls-1083 {\n        fill: #838385;\n      }\n\n      .cls-1084 {\n        fill: #838384;\n      }\n\n      .cls-1085 {\n        fill: #4c4f53;\n      }\n\n      .cls-1086 {\n        fill: #4c5054;\n      }\n\n      .cls-1087 {\n        fill: #4c5355;\n      }\n\n      .cls-1088 {\n        fill: #4c4c4d;\n      }\n\n      .cls-1089 {\n        fill: #5f5f60;\n      }\n\n      .cls-1090 {\n        fill: #5f5f61;\n      }\n\n      .cls-1091 {\n        fill: #5f6062;\n      }\n\n      .cls-1092 {\n        fill: #616366;\n      }\n\n      .cls-1093 {\n        fill: #61676a;\n      }\n\n      .cls-1094 {\n        fill: #616264;\n      }\n\n      .cls-1095 {\n        fill: #616668;\n      }\n\n      .cls-1096 {\n        fill: #616162;\n      }\n\n      .cls-1097 {\n        fill: #616163;\n      }\n\n      .cls-1098 {\n        fill: #494d50;\n      }\n\n      .cls-1099 {\n        fill: #49494a;\n      }\n\n      .cls-1100 {\n        fill: #5f6468;\n      }\n\n      .cls-1101 {\n        fill: #5f6466;\n      }\n\n      .cls-1102 {\n        fill: #5f6568;\n      }\n\n      .cls-1103 {\n        fill: #5f6164;\n      }\n\n      .cls-1104 {\n        fill: #606061;\n      }\n\n      .cls-1105 {\n        fill: #606062;\n      }\n\n      .cls-1106 {\n        fill: #5e6467;\n      }\n\n      .cls-1107 {\n        fill: #5d5f61;\n      }\n\n      .cls-1108 {\n        fill: #5d5e60;\n      }\n\n      .cls-1109 {\n        fill: #5d5d5e;\n      }\n\n      .cls-1110 {\n        fill: #495052;\n      }\n\n      .cls-1111 {\n        fill: #54595e;\n      }\n\n      .cls-1112 {\n        fill: #545b5d;\n      }\n\n      .cls-1113 {\n        fill: #545a5f;\n      }\n\n      .cls-1114 {\n        fill: #75797d;\n      }\n\n      .cls-1115 {\n        fill: #757779;\n      }\n\n      .cls-1116 {\n        fill: #757677;\n      }\n\n      .cls-1117 {\n        fill: #75777a;\n      }\n\n      .cls-1118 {\n        fill: #757678;\n      }\n\n      .cls-1119 {\n        fill: #75787d;\n      }\n\n      .cls-1120 {\n        fill: #757b7e;\n      }\n\n      .cls-1121 {\n        fill: #757a7d;\n      }\n\n      .cls-1122 {\n        fill: #757a7c;\n      }\n\n      .cls-1123 {\n        fill: #76787b;\n      }\n\n      .cls-1124 {\n        fill: #76787a;\n      }\n\n      .cls-1125 {\n        fill: #767778;\n      }\n\n      .cls-1126 {\n        fill: #767678;\n      }\n\n      .cls-1127 {\n        fill: #767677;\n      }\n\n      .cls-1128 {\n        fill: #767b7e;\n      }\n\n      .cls-1129 {\n        fill: #767b7d;\n      }\n\n      .cls-1130 {\n        fill: #767a7e;\n      }\n\n      .cls-1131 {\n        fill: #76797e;\n      }\n\n      .cls-1132 {\n        fill: #757c7d;\n      }\n\n      .cls-1133 {\n        fill: #797b7c;\n      }\n\n      .cls-1134 {\n        fill: #797b7e;\n      }\n\n      .cls-1135 {\n        fill: #797b7d;\n      }\n\n      .cls-1136 {\n        fill: #797c81;\n      }\n\n      .cls-1137 {\n        fill: #797e81;\n      }\n\n      .cls-1138 {\n        fill: #797e7f;\n      }\n\n      .cls-1139 {\n        fill: #777879;\n      }\n\n      .cls-1140 {\n        fill: #77797c;\n      }\n\n      .cls-1141 {\n        fill: #77797a;\n      }\n\n      .cls-1142 {\n        fill: #77797b;\n      }\n\n      .cls-1143 {\n        fill: #777778;\n      }\n\n      .cls-1144 {\n        fill: #777a7f;\n      }\n\n      .cls-1145 {\n        fill: #797f82;\n      }\n\n      .cls-1146 {\n        fill: #797f80;\n      }\n\n      .cls-1147 {\n        fill: #767d7e;\n      }\n\n      .cls-1148 {\n        fill: #767c7f;\n      }\n\n      .cls-1149 {\n        fill: #79797a;\n      }\n\n      .cls-1150 {\n        fill: #797a7b;\n      }\n\n      .cls-1151 {\n        fill: #787d7f;\n      }\n\n      .cls-1152 {\n        fill: #787d80;\n      }\n\n      .cls-1153 {\n        fill: #787e81;\n      }\n\n      .cls-1154 {\n        fill: #787e7f;\n      }\n\n      .cls-1155 {\n        fill: #787b80;\n      }\n\n      .cls-1156 {\n        fill: #787c80;\n      }\n\n      .cls-1157 {\n        fill: #7a7a7b;\n      }\n\n      .cls-1158 {\n        fill: #4b5254;\n      }\n\n      .cls-1159 {\n        fill: #4b4f52;\n      }\n\n      .cls-1160 {\n        fill: #4b4b4c;\n      }\n\n      .cls-1161 {\n        fill: #5e5f61;\n      }\n\n      .cls-1162 {\n        fill: #5e5e60;\n      }\n\n      .cls-1163 {\n        fill: #5e5e5f;\n      }\n\n      .cls-1164 {\n        fill: #5d6366;\n      }\n\n      .cls-1165 {\n        fill: #5e6062;\n      }\n\n      .cls-1166 {\n        fill: #606163;\n      }\n\n      .cls-1167 {\n        fill: #606265;\n      }\n\n      .cls-1168 {\n        fill: #606567;\n      }\n\n      .cls-1169 {\n        fill: #606569;\n      }\n\n      .cls-1170 {\n        fill: #606669;\n      }\n\n      .cls-1171 {\n        fill: #72777c;\n      }\n\n      .cls-1172 {\n        fill: #727779;\n      }\n\n      .cls-1173 {\n        fill: #72777a;\n      }\n\n      .cls-1174 {\n        fill: #72797a;\n      }\n\n      .cls-1175 {\n        fill: #727374;\n      }\n\n      .cls-1176 {\n        fill: #727375;\n      }\n\n      .cls-1177 {\n        fill: #72787b;\n      }\n\n      .cls-1178 {\n        fill: #717274;\n      }\n\n      .cls-1179 {\n        fill: #717273;\n      }\n\n      .cls-1180 {\n        fill: #72767a;\n      }\n\n      .cls-1181 {\n        fill: #72757a;\n      }\n\n      .cls-1182 {\n        fill: #727476;\n      }\n\n      .cls-1183 {\n        fill: #4f4f50;\n      }\n\n      .cls-1184 {\n        fill: #4f5357;\n      }\n\n      .cls-1185 {\n        fill: #52575c;\n      }\n\n      .cls-1186 {\n        fill: #52595b;\n      }\n\n      .cls-1187 {\n        fill: #787879;\n      }\n\n      .cls-1188 {\n        fill: #525253;\n      }\n\n      .cls-1189 {\n        fill: #525254;\n      }\n\n      .cls-1190 {\n        fill: #525354;\n      }\n\n      .cls-1191 {\n        fill: #78797a;\n      }\n\n      .cls-1192 {\n        fill: #787a7c;\n      }\n\n      .cls-1193 {\n        fill: #787a7b;\n      }\n\n      .cls-1194 {\n        fill: #787a7d;\n      }\n\n      .cls-1195 {\n        fill: #838485;\n      }\n\n      .cls-1196 {\n        fill: #83898d;\n      }\n\n      .cls-1197 {\n        fill: #83888d;\n      }\n\n      .cls-1198 {\n        fill: #83898a;\n      }\n\n      .cls-1199 {\n        fill: #83888b;\n      }\n\n      .cls-1200 {\n        fill: #838889;\n      }\n\n      .cls-1201 {\n        fill: #838586;\n      }\n\n      .cls-1202 {\n        fill: #838587;\n      }\n\n      .cls-1203 {\n        fill: #838588;\n      }\n\n      .cls-1204 {\n        fill: #83868b;\n      }\n\n      .cls-1205 {\n        fill: #83868a;\n      }\n\n      .cls-1206 {\n        fill: #838689;\n      }\n\n      .cls-1207 {\n        fill: #505152;\n      }\n\n      .cls-1208 {\n        fill: #505759;\n      }\n\n      .cls-1209 {\n        fill: #50555a;\n      }\n\n      .cls-1210 {\n        fill: #505052;\n      }\n\n      .cls-1211 {\n        fill: #505458;\n      }\n\n      .cls-1212 {\n        fill: #4f5658;\n      }\n\n      .cls-1213 {\n        fill: #82878c;\n      }\n\n      .cls-1214 {\n        fill: #828788;\n      }\n\n      .cls-1215 {\n        fill: #82878a;\n      }\n\n      .cls-1216 {\n        fill: #828889;\n      }\n\n      .cls-1217 {\n        fill: #82858a;\n      }\n\n      .cls-1218 {\n        fill: #82888c;\n      }\n\n      .cls-1219 {\n        fill: #828589;\n      }\n\n      .cls-1220 {\n        fill: #7a7f80;\n      }\n\n      .cls-1221 {\n        fill: #7a7f83;\n      }\n\n      .cls-1222 {\n        fill: #7a7f84;\n      }\n\n      .cls-1223 {\n        fill: #7a7f82;\n      }\n\n      .cls-1224 {\n        fill: #7a8081;\n      }\n\n      .cls-1225 {\n        fill: #7a8083;\n      }\n\n      .cls-1226 {\n        fill: #7a7d81;\n      }\n\n      .cls-1227 {\n        fill: #7a7d82;\n      }\n\n      .cls-1228 {\n        fill: #7a7c7f;\n      }\n\n      .cls-1229 {\n        fill: #7a7c7e;\n      }\n\n      .cls-1230 {\n        fill: #7a7c7d;\n      }\n\n      .cls-1231 {\n        fill: #828284;\n      }\n\n      .cls-1232 {\n        fill: #828283;\n      }\n\n      .cls-1233 {\n        fill: #7a7b7c;\n      }\n\n      .cls-1234 {\n        fill: #4d5155;\n      }\n\n      .cls-1235 {\n        fill: #777d80;\n      }\n\n      .cls-1236 {\n        fill: #777c7f;\n      }\n\n      .cls-1237 {\n        fill: #777c7e;\n      }\n\n      .cls-1238 {\n        fill: #757577;\n      }\n\n      .cls-1239 {\n        fill: #757576;\n      }\n\n      .cls-1240 {\n        fill: #777b7f;\n      }\n\n      .cls-1241 {\n        fill: #343436;\n      }\n\n      .cls-1242 {\n        fill: #34383b;\n      }\n\n      .cls-1243 {\n        fill: #34383c;\n      }\n\n      .cls-1244 {\n        fill: #343537;\n      }\n\n      .cls-1245 {\n        fill: #51585a;\n      }\n\n      .cls-1246 {\n        fill: #51565b;\n      }\n\n      .cls-1247 {\n        fill: #7b7d7e;\n      }\n\n      .cls-1248 {\n        fill: #7b7d7f;\n      }\n\n      .cls-1249 {\n        fill: #7b7d80;\n      }\n\n      .cls-1250 {\n        fill: #7b8182;\n      }\n\n      .cls-1251 {\n        fill: #7b7c7d;\n      }\n\n      .cls-1252 {\n        fill: #7b7b7c;\n      }\n\n      .cls-1253 {\n        fill: #7b8184;\n      }\n\n      .cls-1254 {\n        fill: #7b8083;\n      }\n\n      .cls-1255 {\n        fill: #7b8085;\n      }\n\n      .cls-1256 {\n        fill: #7b8081;\n      }\n\n      .cls-1257 {\n        fill: #7b7e83;\n      }\n\n      .cls-1258 {\n        fill: #7b7e82;\n      }\n\n      .cls-1259 {\n        fill: #4d4d4e;\n      }\n\n      .cls-1260 {\n        fill: #4d5456;\n      }\n\n      .cls-1261 {\n        fill: #4e4e4f;\n      }\n\n      .cls-1262 {\n        fill: #4e5256;\n      }\n\n      .cls-1263 {\n        fill: #4e5557;\n      }\n\n      .cls-1264 {\n        fill: #45484b;\n      }\n\n      .cls-1265 {\n        fill: #515153;\n      }\n\n      .cls-1266 {\n        fill: #515253;\n      }\n\n      .cls-1267 {\n        fill: #515152;\n      }\n\n      .cls-1268 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-1269 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-1270 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-1271 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-1272 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-1273 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-1274 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-1275 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-1276 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-1277 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-1278 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-1279 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-1280 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-1281 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-1282 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-1283 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-1284 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-1285 {\n        clip-path: url(#clippath-18);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.96,99.76l-22.17-5.21-3.16-7.53,24.52,5.74,.81,7Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.14,30.51l.14-.14h0c7-6.28,15.69-9.33,24.3-7.58l-36.03-9.16c-.65-.19-1.31-.37-1.99-.5-8.06-1.64-16.21,1-22.92,6.61-.63,.53-1.25,1.08-1.86,1.66L6.3,91.77l38.88,15.73L120.89,32.73c.73-.78,1.48-1.52,2.25-2.22h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.59,22.79c-8.61-1.75-17.3,1.3-24.3,7.59h0s-.14,.13-.14,.13c-.77,.7-1.52,1.44-2.25,2.22L45.18,107.5l10.46,15.72,52.3-27.74c4.67-2.48,10.38-2.28,14.71,.75,2.77,1.94,5.87,3.31,9.25,4,16.66,3.4,33.69-11.19,38.02-32.58,4.33-21.39-5.66-41.48-22.33-44.87h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.2,92.75l38.99,15.77,10.49,15.77L14.03,107.32l-9.83-14.57Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.08,99.61l26.46,10.7,4.28,6.46-26.91-11.52-3.83-5.64Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.66,19.32c5.02-2.6,11-.77,13.91-.03l5.65,1.44,.49-11.5c.22-2.6-1.03-5.11-3.25-6.49l-.36-.22c-2.66-1.67-6.17-.84-7.81,1.85l-8.65,14.96Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.64,1.69l-7.39-1.27c-.1-.02-.19-.04-.29-.05h-.01c-2.08-.28-4.22,.65-5.39,2.56l-9.76,13.99,8.85,2.4,8.64-14.96c1.16-1.91,3.27-2.87,5.34-2.68h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.02,90.32l4.68-.69,39.26,15.13-1.46,2.74L4.02,90.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M57.93,124.68l.96-3.18-10.93-16.74-1.46,2.74,11.43,17.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.02,90.32l.18,2.44,38.99,15.77,3.31-1.03L4.02,90.32Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.19,108.53l10.49,15.77,4.25,.39-11.43-17.18-3.31,1.03Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.76,10.02c-.38,2.46-2.24,4.22-4.16,3.92-1.92-.3-3.17-2.54-2.79-5,.38-2.46,2.24-4.22,4.17-3.92,1.92,.3,3.17,2.54,2.79,5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.43,45.34l19.48,6.14-7.72,7.45-19.48-6.24,7.72-7.35Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.43,33.38v11.97l19.48,6.14,9.7-9.37-29.19-8.74Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.43,33.38v11.97l-7.72,7.35-9.82-3.15,17.53-16.17Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.94,65.9c3.04-15.02-3.98-29.13-15.68-31.52-11.71-2.39-23.66,7.86-26.71,22.88-3.04,15.02,3.97,29.13,15.68,31.52,11.71,2.39,23.66-7.86,26.71-22.88Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.51,65.47c3-14.78-3.74-28.63-15.04-30.94-11.3-2.3-22.89,7.81-25.89,22.59-3,14.78,3.74,28.63,15.04,30.94,11.3,2.3,22.89-7.81,25.89-22.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.8,64.31c2.16-10.66-2.69-20.64-10.84-22.3-8.15-1.66-16.51,5.63-18.67,16.29-2.16,10.66,2.69,20.64,10.84,22.3,8.15,1.66,16.51-5.63,18.67-16.29Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.38,64.31c2.16-10.66-2.69-20.64-10.84-22.3-8.15-1.66-16.51,5.63-18.67,16.29-2.16,10.66,2.69,20.64,10.84,22.3,8.15,1.66,16.51-5.63,18.67-16.29Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1259",
    points: "104.63 94.11 129.96 98.59 129.96 99.76 104.63 99.76 104.63 94.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1259",
    points: "104.63 93.92 129.96 98.4 129.96 98.59 104.63 94.11 104.63 93.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1261",
    points: "104.63 93.73 129.96 98.21 129.96 98.4 104.63 93.92 104.63 93.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1183",
    points: "104.63 93.54 129.96 98.02 129.96 98.21 104.63 93.73 104.63 93.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1210",
    points: "104.63 93.36 129.96 97.84 129.96 98.02 104.63 93.54 104.63 93.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1265",
    points: "104.63 93.17 129.96 97.65 129.96 97.84 104.63 93.36 104.63 93.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1189",
    points: "104.63 92.98 129.96 97.46 129.96 97.65 104.63 93.17 104.63 92.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-903",
    points: "104.63 92.79 129.96 97.27 129.96 97.46 104.63 92.98 104.63 92.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-903",
    points: "104.63 92.69 129.96 97.17 129.96 97.27 104.63 92.79 104.63 92.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-895",
    points: "104.63 92.6 129.96 97.08 129.96 97.17 104.63 92.69 104.63 92.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-988",
    points: "104.63 92.5 129.96 96.98 129.96 97.08 104.63 92.6 104.63 92.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1026",
    points: "104.63 92.4 129.96 96.88 129.96 96.98 104.63 92.5 104.63 92.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1073",
    points: "104.63 92.31 129.96 96.78 129.96 96.88 104.63 92.4 104.63 92.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1065",
    points: "104.63 92.21 129.96 96.69 129.96 96.78 104.63 92.31 104.63 92.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1023",
    points: "104.63 92.11 129.96 96.59 129.96 96.69 104.63 92.21 104.63 92.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1058",
    points: "104.63 92.01 129.96 96.49 129.96 96.59 104.63 92.11 104.63 92.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1015",
    points: "104.63 91.92 129.96 96.4 129.96 96.49 104.63 92.01 104.63 91.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1042",
    points: "104.63 91.82 129.96 96.3 129.96 96.4 104.63 91.92 104.63 91.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1108",
    points: "104.63 91.72 129.96 96.2 129.96 96.3 104.63 91.82 104.63 91.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1161",
    points: "104.63 91.63 129.96 96.1 129.96 96.2 104.63 91.72 104.63 91.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1091",
    points: "104.63 91.53 129.96 96.01 129.96 96.1 104.63 91.63 104.63 91.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1166",
    points: "104.63 91.43 129.96 95.91 129.96 96.01 104.63 91.53 104.63 91.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1094",
    points: "104.63 91.33 129.96 95.81 129.96 95.91 104.63 91.43 104.63 91.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1008",
    points: "104.63 91.24 129.96 95.72 129.96 95.81 104.63 91.33 104.63 91.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1001",
    points: "104.63 91.14 129.96 95.62 129.96 95.72 104.63 91.24 104.63 91.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-992",
    points: "104.63 91.04 129.96 95.52 129.96 95.62 104.63 91.14 104.63 91.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "104.63 90.95 129.96 95.42 129.96 95.52 104.63 91.04 104.63 90.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-441",
    points: "104.63 90.85 129.96 95.33 129.96 95.42 104.63 90.95 104.63 90.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-441",
    points: "104.63 90.77 129.96 95.25 129.96 95.33 104.63 90.85 104.63 90.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "104.63 90.7 129.96 95.18 129.96 95.25 104.63 90.77 104.63 90.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "104.63 90.63 129.96 95.11 129.96 95.18 104.63 90.7 104.63 90.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "104.63 90.55 129.96 95.03 129.96 95.11 104.63 90.63 104.63 90.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "104.63 90.48 129.96 94.96 129.96 95.03 104.63 90.55 104.63 90.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "104.63 90.41 129.96 94.88 129.96 94.96 104.63 90.48 104.63 90.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "104.63 90.33 129.96 94.81 129.96 94.88 104.63 90.41 104.63 90.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-971",
    points: "104.63 90.26 129.96 94.74 129.96 94.81 104.63 90.33 104.63 90.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-940",
    points: "104.63 90.18 129.96 94.66 129.96 94.74 104.63 90.26 104.63 90.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-869",
    points: "104.63 90.11 129.96 94.59 129.96 94.66 104.63 90.18 104.63 90.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-834",
    points: "104.63 90.04 129.96 94.52 129.96 94.59 104.63 90.11 104.63 90.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1178",
    points: "104.63 89.96 129.96 94.44 129.96 94.52 104.63 90.04 104.63 89.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1176",
    points: "104.63 89.89 129.96 94.37 129.96 94.44 104.63 89.96 104.63 89.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-456",
    points: "104.63 89.82 129.96 94.29 129.96 94.37 104.63 89.89 104.63 89.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "104.63 89.74 129.96 94.22 129.96 94.29 104.63 89.82 104.63 89.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1118",
    points: "104.63 89.67 129.96 94.15 129.96 94.22 104.63 89.74 104.63 89.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1117",
    points: "104.63 89.59 129.96 94.07 129.96 94.15 104.63 89.67 104.63 89.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1123",
    points: "104.63 89.52 129.96 94 129.96 94.07 104.63 89.59 104.63 89.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1140",
    points: "104.63 89.45 129.96 93.93 129.96 94 104.63 89.52 104.63 89.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1194",
    points: "104.63 89.37 129.96 93.85 129.96 93.93 104.63 89.45 104.63 89.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1134",
    points: "104.63 89.3 129.96 93.78 129.96 93.85 104.63 89.37 104.63 89.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1228",
    points: "104.63 89.23 129.96 93.7 129.96 93.78 104.63 89.3 104.63 89.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1249",
    points: "104.63 89.15 129.96 93.63 129.96 93.7 104.63 89.23 104.63 89.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "104.63 89.08 129.96 93.56 129.96 93.63 104.63 89.15 104.63 89.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "104.63 89 129.96 93.48 129.96 93.56 104.63 89.08 104.63 89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "104.63 88.93 129.96 93.41 129.96 93.48 104.63 89 104.63 88.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "104.63 88.86 129.96 93.34 129.96 93.41 104.63 88.93 104.63 88.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-979",
    points: "104.63 88.78 129.96 93.26 129.96 93.34 104.63 88.86 104.63 88.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "104.63 88.71 129.96 93.19 129.96 93.26 104.63 88.78 104.63 88.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1079",
    points: "104.63 88.64 129.96 93.11 129.96 93.19 104.63 88.71 104.63 88.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1203",
    points: "104.63 88.56 129.96 93.04 129.96 93.11 104.63 88.64 104.63 88.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "104.63 88.49 129.96 92.97 129.96 93.04 104.63 88.56 104.63 88.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "104.63 88.43 129.96 92.91 129.96 92.97 104.63 88.49 104.63 88.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-517",
    points: "104.63 88.37 129.96 92.85 129.96 92.91 104.63 88.43 104.63 88.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-916",
    points: "104.63 88.31 129.96 92.79 129.96 92.85 104.63 88.37 104.63 88.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-963",
    points: "104.63 88.25 129.96 92.73 129.96 92.79 104.63 88.31 104.63 88.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-950",
    points: "104.63 88.19 129.96 92.67 129.96 92.73 104.63 88.25 104.63 88.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-893",
    points: "104.63 88.13 129.96 92.61 129.96 92.67 104.63 88.19 104.63 88.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-349",
    points: "104.63 88.07 129.96 92.55 129.96 92.61 104.63 88.13 104.63 88.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "104.63 88.01 129.96 92.49 129.96 92.55 104.63 88.07 104.63 88.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-385",
    points: "104.63 87.95 129.96 92.43 129.96 92.49 104.63 88.01 104.63 87.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "104.63 87.89 129.96 92.37 129.96 92.43 104.63 87.95 104.63 87.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-489",
    points: "104.63 87.83 129.96 92.31 129.96 92.37 104.63 87.89 104.63 87.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-483",
    points: "104.63 87.77 129.96 92.25 129.96 92.31 104.63 87.83 104.63 87.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-419",
    points: "104.63 87.71 129.96 92.19 129.96 92.25 104.63 87.77 104.63 87.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-411",
    points: "104.63 87.65 129.96 92.13 129.96 92.19 104.63 87.71 104.63 87.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "104.63 87.59 129.96 92.07 129.96 92.13 104.63 87.65 104.63 87.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "104.63 87.53 129.96 92.01 129.96 92.07 104.63 87.59 104.63 87.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-326",
    points: "104.63 87.47 129.96 91.95 129.96 92.01 104.63 87.53 104.63 87.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-855",
    points: "104.63 87.41 129.96 91.89 129.96 91.95 104.63 87.47 104.63 87.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-887",
    points: "104.63 87.35 129.96 91.83 129.96 91.89 104.63 87.41 104.63 87.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "104.63 87.29 129.96 91.77 129.96 91.83 104.63 87.35 104.63 87.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "104.63 87.23 129.96 91.71 129.96 91.77 104.63 87.29 104.63 87.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "104.63 87.17 129.96 91.65 129.96 91.71 104.63 87.23 104.63 87.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "129.96 91.65 104.63 87.17 104.63 87.02 129.96 87.02 129.96 91.65"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1268"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "147.59 22.92 103.69 11.48 147.59 11.48 147.59 22.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "147.59 23.05 103.2 11.48 103.69 11.48 147.59 22.92 147.59 23.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-838",
    points: "147.59 23.18 102.71 11.48 103.2 11.48 147.59 23.05 147.59 23.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-945",
    points: "147.59 23.31 102.21 11.48 102.71 11.48 147.59 23.18 147.59 23.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-973",
    points: "147.59 23.43 101.72 11.48 102.21 11.48 147.59 23.31 147.59 23.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "147.59 23.56 101.23 11.48 101.72 11.48 147.59 23.43 147.59 23.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "147.59 23.69 100.74 11.48 101.23 11.48 147.59 23.56 147.59 23.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "147.59 23.82 100.25 11.48 100.74 11.48 147.59 23.69 147.59 23.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "147.59 23.94 99.76 11.48 100.25 11.48 147.59 23.82 147.59 23.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "147.59 24.07 99.27 11.48 99.76 11.48 147.59 23.94 147.59 24.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "147.59 24.2 98.78 11.48 99.27 11.48 147.59 24.07 147.59 24.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "147.59 24.33 98.29 11.48 98.78 11.48 147.59 24.2 147.59 24.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "147.59 24.45 97.8 11.48 98.29 11.48 147.59 24.33 147.59 24.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-994",
    points: "147.59 24.58 97.31 11.48 97.8 11.48 147.59 24.45 147.59 24.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-999",
    points: "147.59 24.71 96.82 11.48 97.31 11.48 147.59 24.58 147.59 24.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1004",
    points: "147.59 24.84 96.33 11.48 96.82 11.48 147.59 24.71 147.59 24.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1095",
    points: "147.59 24.97 95.84 11.48 96.33 11.48 147.59 24.84 147.59 24.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1168",
    points: "147.59 25.09 95.35 11.48 95.84 11.48 147.59 24.97 147.59 25.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1101",
    points: "147.59 25.22 94.86 11.48 95.35 11.48 147.59 25.09 147.59 25.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1101",
    points: "147.59 25.27 94.68 11.48 94.86 11.48 147.59 25.22 147.59 25.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1168",
    points: "147.59 25.31 94.51 11.48 94.68 11.48 147.59 25.27 147.59 25.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1095",
    points: "147.59 25.36 94.33 11.48 94.51 11.48 147.59 25.31 147.59 25.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1004",
    points: "147.59 25.4 94.15 11.48 94.33 11.48 147.59 25.36 147.59 25.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-999",
    points: "147.59 25.45 93.98 11.48 94.15 11.48 147.59 25.4 147.59 25.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-994",
    points: "147.59 25.5 93.8 11.48 93.98 11.48 147.59 25.45 147.59 25.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "147.59 25.54 93.63 11.48 93.8 11.48 147.59 25.5 147.59 25.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "147.59 25.59 93.45 11.48 93.63 11.48 147.59 25.54 147.59 25.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "147.59 25.63 93.27 11.48 93.45 11.48 147.59 25.59 147.59 25.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "147.59 25.68 93.1 11.48 93.27 11.48 147.59 25.63 147.59 25.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "147.59 25.73 92.92 11.48 93.1 11.48 147.59 25.68 147.59 25.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "147.59 25.77 92.74 11.48 92.92 11.48 147.59 25.73 147.59 25.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "147.59 25.82 92.57 11.48 92.74 11.48 147.59 25.77 147.59 25.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "147.59 25.86 92.39 11.48 92.57 11.48 147.59 25.82 147.59 25.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-973",
    points: "147.59 25.91 92.21 11.48 92.39 11.48 147.59 25.86 147.59 25.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-945",
    points: "147.59 25.96 92.04 11.48 92.21 11.48 147.59 25.91 147.59 25.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-838",
    points: "147.59 26 91.86 11.48 92.04 11.48 147.59 25.96 147.59 26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "147.59 26.05 91.68 11.48 91.86 11.48 147.59 26 147.59 26.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-845",
    points: "147.59 26.09 91.51 11.48 91.68 11.48 147.59 26.05 147.59 26.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1173",
    points: "147.59 26.14 91.33 11.48 91.51 11.48 147.59 26.09 147.59 26.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "147.59 26.19 91.15 11.48 91.33 11.48 147.59 26.14 147.59 26.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "147.59 26.23 90.98 11.48 91.15 11.48 147.59 26.19 147.59 26.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1121",
    points: "147.59 26.28 90.8 11.48 90.98 11.48 147.59 26.23 147.59 26.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1128",
    points: "147.59 26.32 90.62 11.48 90.8 11.48 147.59 26.28 147.59 26.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1236",
    points: "147.59 26.37 90.45 11.48 90.62 11.48 147.59 26.32 147.59 26.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1236",
    points: "147.59 26.44 90.17 11.48 90.45 11.48 147.59 26.37 147.59 26.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1152",
    points: "147.59 26.51 89.9 11.48 90.17 11.48 147.59 26.44 147.59 26.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1137",
    points: "147.59 26.59 89.62 11.48 89.9 11.48 147.59 26.51 147.59 26.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1223",
    points: "147.59 26.66 89.35 11.48 89.62 11.48 147.59 26.59 147.59 26.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1254",
    points: "147.59 26.73 89.07 11.48 89.35 11.48 147.59 26.66 147.59 26.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "147.59 26.8 88.79 11.48 89.07 11.48 147.59 26.73 147.59 26.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "147.59 26.87 88.52 11.48 88.79 11.48 147.59 26.8 147.59 26.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "147.59 26.95 88.24 11.48 88.52 11.48 147.59 26.87 147.59 26.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "147.59 27.02 87.97 11.48 88.24 11.48 147.59 26.95 147.59 27.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "147.59 27.09 87.69 11.48 87.97 11.48 147.59 27.02 147.59 27.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "147.59 27.16 87.41 11.48 87.69 11.48 147.59 27.09 147.59 27.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1215",
    points: "147.59 27.23 87.14 11.48 87.41 11.48 147.59 27.16 147.59 27.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1199",
    points: "147.59 27.3 86.86 11.48 87.14 11.48 147.59 27.23 147.59 27.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "147.59 27.38 86.59 11.48 86.86 11.48 147.59 27.3 147.59 27.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-519",
    points: "147.59 27.45 86.31 11.48 86.59 11.48 147.59 27.38 147.59 27.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-905",
    points: "147.59 27.52 86.04 11.48 86.31 11.48 147.59 27.45 147.59 27.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-918",
    points: "147.59 27.59 85.76 11.48 86.04 11.48 147.59 27.52 147.59 27.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-955",
    points: "147.59 27.66 85.48 11.48 85.76 11.48 147.59 27.59 147.59 27.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-811",
    points: "147.59 27.74 85.21 11.48 85.48 11.48 147.59 27.66 147.59 27.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "147.59 27.81 84.93 11.48 85.21 11.48 147.59 27.74 147.59 27.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-372",
    points: "147.59 27.88 84.66 11.48 84.93 11.48 147.59 27.81 147.59 27.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "147.59 27.95 84.38 11.48 84.66 11.48 147.59 27.88 147.59 27.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-473",
    points: "147.59 28.02 84.11 11.48 84.38 11.48 147.59 27.95 147.59 28.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-484",
    points: "147.59 28.09 83.83 11.48 84.11 11.48 147.59 28.02 147.59 28.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "147.59 28.17 83.55 11.48 83.83 11.48 147.59 28.09 147.59 28.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-426",
    points: "147.59 28.24 83.28 11.48 83.55 11.48 147.59 28.17 147.59 28.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "147.59 28.31 83 11.48 83.28 11.48 147.59 28.24 147.59 28.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "147.59 28.38 82.73 11.48 83 11.48 147.59 28.31 147.59 28.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "147.59 28.45 82.45 11.48 82.73 11.48 147.59 28.38 147.59 28.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-860",
    points: "147.59 28.53 82.17 11.48 82.45 11.48 147.59 28.45 147.59 28.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-888",
    points: "147.59 28.6 81.9 11.48 82.17 11.48 147.59 28.53 147.59 28.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "147.59 28.67 81.62 11.48 81.9 11.48 147.59 28.6 147.59 28.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "147.59 28.73 81.4 11.48 81.62 11.48 147.59 28.67 147.59 28.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "147.59 28.78 81.18 11.48 81.4 11.48 147.59 28.73 147.59 28.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "147.59 28.84 80.96 11.48 81.18 11.48 147.59 28.78 147.59 28.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "147.59 28.9 80.74 11.48 80.96 11.48 147.59 28.84 147.59 28.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-923",
    points: "147.59 28.96 80.52 11.48 80.74 11.48 147.59 28.9 147.59 28.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-821",
    points: "147.59 29.01 80.3 11.48 80.52 11.48 147.59 28.96 147.59 29.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "147.59 29.07 80.08 11.48 80.3 11.48 147.59 29.01 147.59 29.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-365",
    points: "147.59 29.13 79.86 11.48 80.08 11.48 147.59 29.07 147.59 29.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-379",
    points: "147.59 29.19 79.64 11.48 79.86 11.48 147.59 29.13 147.59 29.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "147.59 29.24 79.42 11.48 79.64 11.48 147.59 29.19 147.59 29.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "147.59 29.3 79.2 11.48 79.42 11.48 147.59 29.24 147.59 29.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-876",
    points: "147.59 29.36 78.98 11.48 79.2 11.48 147.59 29.3 147.59 29.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-813",
    points: "147.59 29.42 78.76 11.48 78.98 11.48 147.59 29.36 147.59 29.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-537",
    points: "147.59 29.47 78.53 11.48 78.76 11.48 147.59 29.42 147.59 29.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-606",
    points: "147.59 29.53 78.31 11.48 78.53 11.48 147.59 29.47 147.59 29.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-542",
    points: "147.59 29.59 78.09 11.48 78.31 11.48 147.59 29.53 147.59 29.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-628",
    points: "147.59 29.65 77.87 11.48 78.09 11.48 147.59 29.59 147.59 29.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-792",
    points: "147.59 29.7 77.65 11.48 77.87 11.48 147.59 29.65 147.59 29.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-547",
    points: "147.59 29.76 77.43 11.48 77.65 11.48 147.59 29.7 147.59 29.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "147.59 29.82 77.21 11.48 77.43 11.48 147.59 29.76 147.59 29.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "147.59 29.96 76.66 11.48 77.21 11.48 147.59 29.82 147.59 29.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-532",
    points: "147.59 30.11 76.11 11.48 76.66 11.48 147.59 29.96 147.59 30.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-753",
    points: "147.59 30.25 75.56 11.48 76.11 11.48 147.59 30.11 147.59 30.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-582",
    points: "147.59 30.39 75 11.48 75.56 11.48 147.59 30.25 147.59 30.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-603",
    points: "147.59 30.54 74.45 11.48 75 11.48 147.59 30.39 147.59 30.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-744",
    points: "147.59 30.68 73.9 11.48 74.45 11.48 147.59 30.54 147.59 30.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-579",
    points: "147.59 30.72 147.56 30.82 73.35 11.48 73.9 11.48 147.59 30.68 147.59 30.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "147.56 30.82 147.53 30.95 72.8 11.48 73.35 11.48 147.56 30.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "147.53 30.95 147.48 31.13 72.06 11.48 72.8 11.48 147.53 30.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-562",
    points: "147.48 31.13 147.43 31.31 71.33 11.48 72.06 11.48 147.48 31.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-414",
    points: "147.43 31.31 147.39 31.49 70.59 11.48 71.33 11.48 147.43 31.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "147.39 31.49 147.34 31.67 69.86 11.48 70.59 11.48 147.39 31.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-336",
    points: "147.34 31.67 147.29 31.85 69.12 11.48 69.86 11.48 147.34 31.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-428",
    points: "147.29 31.85 147.25 32.03 68.39 11.48 69.12 11.48 147.29 31.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-361",
    points: "147.25 32.03 147.2 32.21 67.65 11.48 68.39 11.48 147.25 32.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-493",
    points: "147.2 32.21 147.15 32.39 66.91 11.48 67.65 11.48 147.2 32.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-462",
    points: "147.15 32.39 147.11 32.57 66.18 11.48 66.91 11.48 147.15 32.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-616",
    points: "147.11 32.57 147.06 32.75 65.44 11.48 66.18 11.48 147.11 32.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-625",
    points: "147.06 32.75 147.01 32.93 64.71 11.48 65.44 11.48 147.06 32.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-619",
    points: "147.01 32.93 146.97 33.11 63.97 11.48 64.71 11.48 147.01 32.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-619",
    points: "146.97 33.11 146.92 33.27 63.29 11.48 63.97 11.48 146.97 33.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-634",
    points: "146.92 33.27 146.88 33.44 62.62 11.48 63.29 11.48 146.92 33.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-600",
    points: "146.88 33.44 146.84 33.6 61.94 11.48 62.62 11.48 146.88 33.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-630",
    points: "146.84 33.6 146.79 33.77 61.26 11.48 61.94 11.48 146.84 33.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-427",
    points: "146.79 33.77 146.75 33.93 60.58 11.48 61.26 11.48 146.79 33.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-398",
    points: "146.75 33.93 146.71 34.1 59.9 11.48 60.58 11.48 146.75 33.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-710",
    points: "146.71 34.1 146.66 34.27 59.22 11.48 59.9 11.48 146.71 34.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-652",
    points: "146.66 34.27 146.62 34.43 58.54 11.48 59.22 11.48 146.66 34.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-763",
    points: "146.62 34.43 146.58 34.6 57.86 11.48 58.54 11.48 146.62 34.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-770",
    points: "146.58 34.6 146.53 34.76 57.18 11.48 57.86 11.48 146.58 34.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-681",
    points: "146.53 34.76 146.49 34.93 56.51 11.48 57.18 11.48 146.53 34.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-780",
    points: "146.49 34.93 146.45 35.09 55.83 11.48 56.51 11.48 146.49 34.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-671",
    points: "146.45 35.09 146.4 35.26 55.15 11.48 55.83 11.48 146.45 35.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-690",
    points: "146.4 35.26 146.36 35.42 54.47 11.48 55.15 11.48 146.4 35.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-651",
    points: "146.36 35.42 146.32 35.59 53.79 11.48 54.47 11.48 146.36 35.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-527",
    points: "146.32 35.59 146.27 35.76 53.11 11.48 53.79 11.48 146.32 35.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-522",
    points: "146.27 35.76 146.23 35.92 52.43 11.48 53.11 11.48 146.27 35.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-704",
    points: "146.23 35.92 146.19 36.09 51.75 11.48 52.43 11.48 146.23 35.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-673",
    points: "146.19 36.09 146.15 36.25 51.08 11.48 51.75 11.48 146.19 36.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-700",
    points: "146.15 36.25 146.1 36.42 50.4 11.48 51.08 11.48 146.15 36.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-695",
    points: "146.1 36.42 146.06 36.58 49.72 11.48 50.4 11.48 146.1 36.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-758",
    points: "146.06 36.58 146.02 36.75 49.04 11.48 49.72 11.48 146.06 36.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-731",
    points: "146.02 36.75 145.97 36.92 48.36 11.48 49.04 11.48 146.02 36.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-784",
    points: "145.97 36.92 145.93 37.08 47.68 11.48 48.36 11.48 145.97 36.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-715",
    points: "145.93 37.08 145.89 37.25 47 11.48 47.68 11.48 145.93 37.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-748",
    points: "145.89 37.25 145.84 37.41 46.32 11.48 47 11.48 145.89 37.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-748",
    points: "145.84 37.41 145.79 37.63 45.44 11.48 46.32 11.48 145.84 37.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-593",
    points: "145.79 37.63 145.73 37.84 44.56 11.48 45.44 11.48 145.79 37.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-742",
    points: "145.73 37.84 145.67 38.06 43.68 11.48 44.56 11.48 145.73 37.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-734",
    points: "145.67 38.06 145.62 38.27 42.79 11.48 43.68 11.48 145.67 38.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-726",
    points: "145.62 38.27 145.56 38.49 41.91 11.48 42.79 11.48 145.62 38.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-723",
    points: "145.56 38.49 145.51 38.7 41.03 11.48 41.91 11.48 145.56 38.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-687",
    points: "145.51 38.7 145.45 38.92 40.15 11.48 41.03 11.48 145.51 38.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-786",
    points: "145.45 38.92 145.39 39.13 39.26 11.48 40.15 11.48 145.45 38.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-774",
    points: "145.39 39.13 145.34 39.35 38.38 11.48 39.26 11.48 145.39 39.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-771",
    points: "145.34 39.35 145.28 39.56 37.5 11.48 38.38 11.48 145.34 39.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "145.28 39.56 145.23 39.78 36.62 11.48 37.5 11.48 145.28 39.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "145.23 39.78 145.17 40 35.73 11.48 36.62 11.48 145.23 39.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "145.17 40 145.11 40.21 34.85 11.48 35.73 11.48 145.17 40"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "145.11 40.21 145.06 40.43 33.97 11.48 34.85 11.48 145.11 40.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "145.06 40.43 145 40.64 33.09 11.48 33.97 11.48 145.06 40.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "145 40.64 144.86 41.18 30.88 11.48 33.09 11.48 145 40.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "144.86 41.18 144.72 41.72 28.67 11.48 30.88 11.48 144.86 41.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "144.72 41.72 144.58 42.26 26.47 11.48 28.67 11.48 144.72 41.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "144.58 42.26 144.44 42.79 25.1 11.7 25.15 11.48 26.47 11.48 144.58 42.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 84.42,
    y: -34.15,
    width: 0.56,
    height: 123.33,
    transform: "translate(36.72 102.54) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 84.28,
    y: -33.61,
    width: 0.56,
    height: 123.33,
    transform: "translate(36.09 102.81) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 76.48,
    y: -27.15,
    width: 12.79,
    height: 123.33,
    transform: "translate(28.58 106.01) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 73.25,
    y: -14.77,
    width: 12.79,
    height: 123.33,
    transform: "translate(14.19 112.15) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 70.03,
    y: -2.39,
    width: 12.79,
    height: 123.33,
    transform: "translate(-.2 118.29) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 66.8,
    y: 9.99,
    width: 12.79,
    height: 123.33,
    transform: "translate(-14.59 124.43) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 71.05,
    y: 16.59,
    width: 0.86,
    height: 123.33,
    transform: "translate(-22.27 127.7) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 70.84,
    y: 17.42,
    width: 0.86,
    height: 123.33,
    transform: "translate(-23.23 128.11) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 70.62,
    y: 18.25,
    width: 0.86,
    height: 123.33,
    transform: "translate(-24.2 128.52) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 70.41,
    y: 19.08,
    width: 0.86,
    height: 123.33,
    transform: "translate(-25.16 128.93) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 70.19,
    y: 19.91,
    width: 0.86,
    height: 123.33,
    transform: "translate(-26.12 129.34) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 69.97,
    y: 20.73,
    width: 0.86,
    height: 123.33,
    transform: "translate(-27.08 129.75) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 69.76,
    y: 21.56,
    width: 0.86,
    height: 123.33,
    transform: "translate(-28.05 130.16) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-774",
    x: 69.54,
    y: 22.39,
    width: 0.86,
    height: 123.33,
    transform: "translate(-29.01 130.57) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-786",
    x: 69.33,
    y: 23.22,
    width: 0.86,
    height: 123.33,
    transform: "translate(-29.97 130.98) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-684",
    x: 69.11,
    y: 24.05,
    width: 0.86,
    height: 123.33,
    transform: "translate(-30.93 131.4) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-686",
    x: 68.9,
    y: 24.87,
    width: 0.86,
    height: 123.33,
    transform: "translate(-31.9 131.81) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-724",
    x: 68.68,
    y: 25.7,
    width: 0.86,
    height: 123.33,
    transform: "translate(-32.86 132.22) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-727",
    x: 68.46,
    y: 26.53,
    width: 0.86,
    height: 123.33,
    transform: "translate(-33.82 132.63) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-727",
    x: 68.41,
    y: 27.23,
    width: 0.59,
    height: 123.33,
    transform: "translate(-34.64 132.97) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-737",
    x: 68.27,
    y: 27.8,
    width: 0.59,
    height: 123.33,
    transform: "translate(-35.3 133.26) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-741",
    x: 68.12,
    y: 28.37,
    width: 0.59,
    height: 123.33,
    transform: "translate(-35.97 133.54) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-592",
    x: 67.97,
    y: 28.95,
    width: 0.59,
    height: 123.33,
    transform: "translate(-36.63 133.82) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-749",
    x: 67.82,
    y: 29.52,
    width: 0.59,
    height: 123.33,
    transform: "translate(-37.29 134.11) rotate(-75.4)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-716",
    points: "127.71 107.01 127.58 107.5 127.23 107.5 8.22 76.49 8.37 75.92 127.71 107.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-783",
    points: "124.88 107.5 8.07 77.07 8.22 76.49 127.23 107.5 124.88 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-730",
    points: "122.54 107.5 7.92 77.64 8.07 77.07 124.88 107.5 122.54 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-757",
    points: "120.19 107.5 7.77 78.21 7.92 77.64 122.54 107.5 120.19 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-696",
    points: "117.85 107.5 7.62 78.78 7.77 78.21 120.19 107.5 117.85 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-701",
    points: "115.51 107.5 7.47 79.35 7.62 78.78 117.85 107.5 115.51 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-672",
    points: "113.16 107.5 7.32 79.93 7.47 79.35 115.51 107.5 113.16 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-703",
    points: "110.82 107.5 7.18 80.5 7.32 79.93 113.16 107.5 110.82 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-525",
    points: "108.47 107.5 7.03 81.07 7.18 80.5 110.82 107.5 108.47 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "106.13 107.5 6.88 81.64 7.03 81.07 108.47 107.5 106.13 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-658",
    points: "103.79 107.5 6.73 82.21 6.88 81.64 106.13 107.5 103.79 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-691",
    points: "101.44 107.5 6.58 82.78 6.73 82.21 103.79 107.5 101.44 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-663",
    points: "99.1 107.5 6.43 83.36 6.58 82.78 101.44 107.5 99.1 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-667",
    points: "96.75 107.5 6.3 83.93 6.3 83.84 6.43 83.36 99.1 107.5 96.75 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-776",
    points: "94.41 107.5 6.3 84.55 6.3 83.93 96.75 107.5 94.41 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-678",
    points: "92.06 107.5 6.3 85.16 6.3 84.55 94.41 107.5 92.06 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-769",
    points: "89.72 107.5 6.3 85.77 6.3 85.16 92.06 107.5 89.72 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-760",
    points: "87.38 107.5 6.3 86.38 6.3 85.77 89.72 107.5 87.38 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-713",
    points: "85.03 107.5 6.3 86.99 6.3 86.38 87.38 107.5 85.03 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-707",
    points: "82.69 107.5 6.3 87.6 6.3 86.99 85.03 107.5 82.69 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-405",
    points: "80.34 107.5 6.3 88.21 6.3 87.6 82.69 107.5 80.34 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-430",
    points: "78 107.5 6.3 88.82 6.3 88.21 80.34 107.5 78 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-631",
    points: "75.66 107.5 6.3 89.43 6.3 88.82 78 107.5 75.66 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-557",
    points: "73.31 107.5 6.3 90.04 6.3 89.43 75.66 107.5 73.31 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-650",
    points: "70.97 107.5 6.3 90.65 6.3 90.04 73.31 107.5 70.97 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-639",
    points: "68.62 107.5 6.3 91.26 6.3 90.65 70.97 107.5 68.62 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-565",
    points: "66.28 107.5 6.3 91.87 6.3 91.26 68.62 107.5 66.28 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-565",
    points: "64.07 107.5 6.3 92.45 6.3 91.87 66.28 107.5 64.07 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-613",
    points: "61.87 107.5 6.3 93.02 6.3 92.45 64.07 107.5 61.87 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-466",
    points: "59.66 107.5 6.3 93.6 6.3 93.02 61.87 107.5 59.66 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-495",
    points: "57.45 107.5 6.3 94.17 6.3 93.6 59.66 107.5 57.45 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "55.25 107.5 6.3 94.75 6.3 94.17 57.45 107.5 55.25 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "53.04 107.5 6.3 95.32 6.3 94.75 55.25 107.5 53.04 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-437",
    points: "50.84 107.5 6.3 95.9 6.3 95.32 53.04 107.5 50.84 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-334",
    points: "48.63 107.5 6.3 96.47 6.3 95.9 50.84 107.5 48.63 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "46.42 107.5 6.3 97.05 6.3 96.47 48.63 107.5 46.42 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-553",
    points: "44.22 107.5 6.3 97.62 6.3 97.05 46.42 107.5 44.22 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-560",
    points: "42.01 107.5 6.3 98.2 6.3 97.62 44.22 107.5 42.01 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-588",
    points: "39.8 107.5 6.3 98.77 6.3 98.2 42.01 107.5 39.8 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-581",
    points: "37.6 107.5 6.3 99.35 6.3 98.77 39.8 107.5 37.6 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-609",
    points: "35.39 107.5 6.3 99.92 6.3 99.35 37.6 107.5 35.39 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-585",
    points: "33.19 107.5 6.3 100.49 6.3 99.92 35.39 107.5 33.19 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-751",
    points: "30.98 107.5 6.3 101.07 6.3 100.49 33.19 107.5 30.98 107.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-751",
    points: "6.3 101.07 30.98 107.5 6.3 107.5 6.3 101.07"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1271"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-638",
    x: 45.18,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-567",
    x: 46.13,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-618",
    x: 47.08,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-463",
    x: 48.02,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-494",
    x: 48.97,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 49.91,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-341",
    x: 50.86,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-435",
    x: 51.81,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 52.75,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 53.7,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-417",
    x: 54.65,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-554",
    x: 55.59,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-561",
    x: 56.54,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-589",
    x: 57.48,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-580",
    x: 58.43,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-608",
    x: 59.38,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-586",
    x: 60.32,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-583",
    x: 61.27,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-754",
    x: 62.21,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-646",
    x: 63.16,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-624",
    x: 64.11,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-551",
    x: 65.05,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-787",
    x: 66,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-575",
    x: 66.95,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-545",
    x: 67.89,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-604",
    x: 68.84,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-627",
    x: 69.78,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-818",
    x: 70.73,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-874",
    x: 71.68,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-382",
    x: 72.62,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 73.57,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 74.51,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-375",
    x: 75.46,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-357",
    x: 76.41,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-381",
    x: 77.35,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-921",
    x: 78.3,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-928",
    x: 79.25,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 80.19,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 81.14,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 82.08,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 83.03,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-882",
    x: 83.98,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-857",
    x: 84.92,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 85.87,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 86.81,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-399",
    x: 87.76,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-412",
    x: 88.71,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-396",
    x: 89.65,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-488",
    x: 90.6,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-470",
    x: 91.54,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-496",
    x: 92.49,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-502",
    x: 93.44,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 94.38,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-348",
    x: 95.33,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-933",
    x: 96.28,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-951",
    x: 97.22,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-961",
    x: 98.17,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-914",
    x: 99.11,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-518",
    x: 100.06,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-313",
    x: 101.01,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1195",
    x: 101.95,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1082",
    x: 102.9,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 103.84,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-983",
    x: 104.79,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 105.74,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 106.68,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 107.63,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 108.58,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1251",
    x: 109.52,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1233",
    x: 110.47,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1150",
    x: 111.41,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1191",
    x: 112.36,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1139",
    x: 113.31,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1125",
    x: 114.25,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1116",
    x: 115.2,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 116.14,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-454",
    x: 117.09,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1175",
    x: 118.04,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1179",
    x: 118.98,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-833",
    x: 119.93,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-870",
    x: 120.88,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-941",
    x: 121.82,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-970",
    x: 122.77,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 123.71,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 124.66,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 125.61,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 126.55,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 127.5,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 128.44,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 129.39,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-440",
    x: 130.34,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 131.28,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-996",
    x: 132.23,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1003",
    x: 133.18,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1010",
    x: 134.12,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1096",
    x: 135.07,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1104",
    x: 136.01,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1089",
    x: 136.96,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1163",
    x: 137.91,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1109",
    x: 138.85,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1041",
    x: 139.8,
    y: 21.04,
    width: 0.95,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1041",
    x: 140.74,
    y: 21.04,
    width: 4.4,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1163",
    x: 145.15,
    y: 21.04,
    width: 4.4,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1163",
    x: 149.55,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1089",
    x: 150.11,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1104",
    x: 150.66,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1096",
    x: 151.22,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1003",
    x: 151.78,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-996",
    x: 152.34,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 152.9,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-440",
    x: 153.46,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 154.02,
    y: 21.04,
    width: 0.56,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 154.58,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 154.89,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 155.2,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 155.52,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 155.83,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 156.15,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-938",
    x: 156.46,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-942",
    x: 156.78,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-825",
    x: 157.09,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-841",
    x: 157.41,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-866",
    x: 157.72,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-451",
    x: 158.03,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 158.35,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1239",
    x: 158.66,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1127",
    x: 158.98,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1143",
    x: 159.29,
    y: 21.04,
    width: 0.31,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1143",
    x: 159.61,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1187",
    x: 159.78,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1149",
    x: 159.95,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1157",
    x: 160.12,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1252",
    x: 160.29,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 160.46,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 160.63,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 160.81,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 160.98,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-982",
    x: 161.15,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 161.32,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1231",
    x: 161.49,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1083",
    x: 161.66,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-310",
    x: 161.83,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-521",
    x: 162.01,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-909",
    x: 162.18,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-965",
    x: 162.35,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-953",
    x: 162.52,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-936",
    x: 162.69,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-333",
    x: 162.86,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 163.03,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-506",
    x: 163.21,
    y: 21.04,
    width: 0.17,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-506",
    x: 163.38,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-498",
    x: 163.56,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-501",
    x: 163.74,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-421",
    x: 163.92,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-410",
    x: 164.1,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 164.28,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 164.46,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-508",
    x: 164.63,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-852",
    x: 164.81,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-880",
    x: 164.99,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 165.17,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 165.35,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 165.53,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 165.71,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-824",
    x: 165.89,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 166.07,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-356",
    x: 166.25,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-377",
    x: 166.43,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 166.61,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-317",
    x: 166.79,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 166.97,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-878",
    x: 167.15,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-812",
    x: 167.33,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-538",
    x: 167.51,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-596",
    x: 167.69,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-555",
    x: 167.87,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-571",
    x: 168.05,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-788",
    x: 168.23,
    y: 21.04,
    width: 0.18,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-788",
    x: 168.41,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-536",
    x: 168.5,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-569",
    x: 168.59,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-644",
    x: 168.69,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-535",
    x: 168.78,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-756",
    x: 168.87,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-607",
    x: 168.97,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-743",
    x: 169.06,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-576",
    x: 169.15,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-559",
    x: 169.25,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-598",
    x: 169.34,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-418",
    x: 169.43,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-331",
    x: 169.52,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-434",
    x: 169.62,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-340",
    x: 169.71,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-354",
    x: 169.8,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-384",
    x: 169.9,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-460",
    x: 169.99,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-614",
    x: 170.08,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-570",
    x: 170.18,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-641",
    x: 170.27,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-648",
    x: 170.36,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-636",
    x: 170.46,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-643",
    x: 170.55,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-429",
    x: 170.64,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-407",
    x: 170.74,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-709",
    x: 170.83,
    y: 21.04,
    width: 0.09,
    height: 102.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-709",
    x: 170.92,
    y: 21.04,
    width: 3.32,
    height: 102.19
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1270"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 4.2,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 4.69,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 5.19,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-887",
    x: 5.68,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-850",
    x: 6.18,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 6.67,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 7.17,
    y: 92.75,
    width: 0.49,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 7.66,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-403",
    x: 8.27,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-424",
    x: 8.87,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-422",
    x: 9.47,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-482",
    x: 10.07,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-477",
    x: 10.68,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-390",
    x: 11.28,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-367",
    x: 11.88,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-352",
    x: 12.49,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-890",
    x: 13.09,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-959",
    x: 13.69,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-968",
    x: 14.3,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-912",
    x: 14.9,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-514",
    x: 15.5,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 16.11,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1206",
    x: 16.71,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1202",
    x: 17.31,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1080",
    x: 17.91,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 18.52,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-980",
    x: 19.12,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 19.72,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 20.33,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 20.93,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 21.53,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1248",
    x: 22.14,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1229",
    x: 22.74,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1135",
    x: 23.34,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1192",
    x: 23.95,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1142",
    x: 24.55,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1124",
    x: 25.15,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1115",
    x: 25.75,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 26.36,
    y: 92.75,
    width: 0.6,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 26.96,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-455",
    x: 27.75,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1182",
    x: 28.54,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-842",
    x: 29.34,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-827",
    x: 30.13,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-871",
    x: 30.92,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-946",
    x: 31.71,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-974",
    x: 32.5,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 33.29,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 34.09,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 34.88,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 35.67,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 36.46,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 37.25,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 38.04,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-439",
    x: 38.84,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 39.63,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-995",
    x: 40.42,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1002",
    x: 41.21,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1009",
    x: 42,
    y: 92.75,
    width: 0.79,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1009",
    x: 42.79,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1097",
    x: 44.35,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1105",
    x: 45.9,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1090",
    x: 47.46,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1163",
    x: 49.01,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1109",
    x: 50.57,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1041",
    x: 52.13,
    y: 92.75,
    width: 1.56,
    height: 31.54
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1269"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1044",
    x: 13.08,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1062",
    x: 14.19,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1047",
    x: 15.3,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1046",
    x: 16.4,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-802",
    x: 17.51,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-803",
    x: 18.62,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-800",
    x: 19.72,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-801",
    x: 20.83,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-798",
    x: 21.94,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1039",
    x: 23.04,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1054",
    x: 24.15,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1243",
    x: 25.26,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1242",
    x: 26.36,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-479",
    x: 27.47,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-480",
    x: 28.58,
    y: 99.61,
    width: 1.11,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-480",
    x: 29.68,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-468",
    x: 31.7,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-457",
    x: 33.72,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-458",
    x: 35.74,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-459",
    x: 37.76,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1049",
    x: 39.78,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1048",
    x: 41.8,
    y: 99.61,
    width: 2.02,
    height: 17.16
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1275"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1259",
    points: "139.22 20.74 139.93 20.02 139.93 20.74 139.22 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1259",
    points: "138.63 20.74 139.93 19.43 139.93 20.02 139.22 20.74 138.63 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1261",
    points: "138.04 20.74 139.93 18.84 139.93 19.43 138.63 20.74 138.04 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1183",
    points: "137.46 20.74 139.93 18.25 139.93 18.84 138.04 20.74 137.46 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1207",
    points: "136.87 20.74 139.93 17.66 139.93 18.25 137.46 20.74 136.87 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1266",
    points: "136.28 20.74 139.93 17.07 139.93 17.66 136.87 20.74 136.28 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1190",
    points: "135.69 20.74 139.93 16.48 139.93 17.07 136.28 20.74 135.69 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-900",
    points: "135.1 20.74 139.93 15.89 139.93 16.48 135.69 20.74 135.1 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-900",
    points: "134.8 20.74 139.93 15.59 139.93 15.89 135.1 20.74 134.8 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-897",
    points: "134.5 20.74 139.93 15.29 139.93 15.59 134.8 20.74 134.5 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-985",
    points: "134.19 20.74 139.93 14.98 139.93 15.29 134.5 20.74 134.19 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1024",
    points: "133.89 20.74 139.93 14.68 139.93 14.98 134.19 20.74 133.89 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1072",
    points: "133.59 20.74 139.93 14.38 139.93 14.68 133.89 20.74 133.59 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1066",
    points: "133.29 20.74 139.93 14.07 139.93 14.38 133.59 20.74 133.29 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1021",
    points: "132.99 20.74 139.93 13.77 139.93 14.07 133.29 20.74 132.99 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1056",
    points: "132.68 20.74 139.93 13.47 139.93 13.77 132.99 20.74 132.68 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1012",
    points: "132.38 20.74 139.93 13.17 139.93 13.47 132.68 20.74 132.38 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1040",
    points: "132.08 20.74 139.93 12.86 139.93 13.17 132.38 20.74 132.08 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1162",
    points: "131.78 20.74 139.93 12.56 139.93 12.86 132.08 20.74 131.78 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1090",
    points: "131.47 20.74 139.93 12.26 139.93 12.56 131.78 20.74 131.47 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1105",
    points: "131.17 20.74 139.93 11.95 139.93 12.26 131.47 20.74 131.17 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1097",
    points: "130.87 20.74 139.93 11.65 139.93 11.95 131.17 20.74 130.87 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1009",
    points: "130.57 20.74 139.93 11.35 139.93 11.65 130.87 20.74 130.57 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1002",
    points: "130.27 20.74 139.93 11.04 139.93 11.35 130.57 20.74 130.27 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-995",
    points: "129.96 20.74 139.93 10.74 139.93 11.04 130.27 20.74 129.96 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "129.66 20.74 139.93 10.44 139.93 10.74 129.96 20.74 129.66 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-439",
    points: "129.36 20.74 139.93 10.14 139.93 10.44 129.66 20.74 129.36 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "129.06 20.74 139.93 9.83 139.93 10.14 129.36 20.74 129.06 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "128.83 20.74 139.93 9.61 139.93 9.83 129.06 20.74 128.83 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "128.61 20.74 139.93 9.38 139.93 9.61 128.83 20.74 128.61 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "128.38 20.74 139.93 9.16 139.93 9.38 128.61 20.74 128.38 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "128.16 20.74 139.93 8.93 139.93 9.16 128.38 20.74 128.16 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "127.93 20.74 139.93 8.71 139.93 8.93 128.16 20.74 127.93 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "127.71 20.74 139.93 8.48 139.93 8.71 127.93 20.74 127.71 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-937",
    points: "127.48 20.74 139.93 8.26 139.93 8.48 127.71 20.74 127.48 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-943",
    points: "127.26 20.74 139.93 8.03 139.93 8.26 127.48 20.74 127.26 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-865",
    points: "127.04 20.74 139.93 7.8 139.93 8.03 127.26 20.74 127.04 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-835",
    points: "126.81 20.74 139.93 7.58 139.93 7.8 127.04 20.74 126.81 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-840",
    points: "126.59 20.74 139.93 7.35 139.93 7.58 126.81 20.74 126.59 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-867",
    points: "126.36 20.74 139.93 7.13 139.93 7.35 126.59 20.74 126.36 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-452",
    points: "126.14 20.74 139.93 6.9 139.93 7.13 126.36 20.74 126.14 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "125.91 20.74 139.93 6.68 139.93 6.9 126.14 20.74 125.91 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1238",
    points: "125.69 20.74 139.93 6.45 139.93 6.68 125.91 20.74 125.69 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1126",
    points: "125.46 20.74 139.93 6.23 139.93 6.45 125.69 20.74 125.46 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1139",
    points: "125.24 20.74 139.93 6 139.93 6.23 125.46 20.74 125.24 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1141",
    points: "125.01 20.74 139.93 5.78 139.93 6 125.24 20.74 125.01 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1193",
    points: "124.79 20.74 139.93 5.55 139.93 5.78 125.01 20.74 124.79 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1133",
    points: "124.56 20.74 139.93 5.33 139.93 5.55 124.79 20.74 124.56 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1230",
    points: "124.34 20.74 139.93 5.1 139.93 5.33 124.56 20.74 124.34 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1247",
    points: "124.11 20.74 139.93 4.88 139.93 5.1 124.34 20.74 124.11 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "123.89 20.74 139.93 4.65 139.93 4.88 124.11 20.74 123.89 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "123.66 20.74 139.93 4.42 139.93 4.65 123.89 20.74 123.66 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "123.44 20.74 139.93 4.2 139.93 4.42 123.66 20.74 123.44 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "123.21 20.74 139.93 3.97 139.93 4.2 123.44 20.74 123.21 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-981",
    points: "122.99 20.74 139.93 3.75 139.93 3.97 123.21 20.74 122.99 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "122.76 20.74 139.93 3.52 139.93 3.75 122.99 20.74 122.76 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1081",
    points: "122.54 20.74 139.93 3.3 139.93 3.52 122.76 20.74 122.54 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1201",
    points: "122.32 20.74 139.93 3.07 139.93 3.3 122.54 20.74 122.32 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "122.09 20.74 139.93 2.85 139.93 3.07 122.32 20.74 122.09 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-516",
    points: "121.87 20.74 139.93 2.62 139.93 2.85 122.09 20.74 121.87 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-917",
    points: "121.64 20.74 139.85 2.47 139.93 2.55 139.93 2.62 121.87 20.74 121.64 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-917",
    points: "121.46 20.74 139.77 2.38 139.85 2.47 121.64 20.74 121.46 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-962",
    points: "121.29 20.74 139.68 2.3 139.77 2.38 121.46 20.74 121.29 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-949",
    points: "121.11 20.74 139.59 2.21 139.68 2.3 121.29 20.74 121.11 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-894",
    points: "120.93 20.74 139.5 2.12 139.59 2.21 121.11 20.74 120.93 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-350",
    points: "120.76 20.74 139.41 2.03 139.5 2.12 120.93 20.74 120.76 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-270",
    points: "120.58 20.74 139.32 1.94 139.41 2.03 120.76 20.74 120.58 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-505",
    points: "120.4 20.74 139.23 1.85 139.32 1.94 120.58 20.74 120.4 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-472",
    points: "120.23 20.74 139.14 1.76 139.23 1.85 120.4 20.74 120.23 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-487",
    points: "120.05 20.74 139.06 1.68 139.14 1.76 120.23 20.74 120.05 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-392",
    points: "119.87 20.74 138.97 1.59 139.06 1.68 120.05 20.74 119.87 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-413",
    points: "119.69 20.74 138.88 1.5 138.97 1.59 119.87 20.74 119.69 20.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-401",
    points: "119.66 20.6 138.79 1.41 138.88 1.5 119.69 20.74 119.66 20.74 119.66 20.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-285",
    points: "119.66 20.42 138.7 1.32 138.79 1.41 119.66 20.6 119.66 20.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "119.66 20.24 138.61 1.23 138.7 1.32 119.66 20.42 119.66 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-858",
    points: "119.66 20.06 138.52 1.14 138.61 1.23 119.66 20.24 119.66 20.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-884",
    points: "119.66 19.89 138.43 1.06 138.52 1.14 119.66 20.06 119.66 19.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "119.66 19.71 138.35 .97 138.43 1.06 119.66 19.89 119.66 19.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "119.66 19.53 138.26 .88 138.35 .97 119.66 19.71 119.66 19.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "119.66 19.35 138.11 .85 138.23 .85 138.26 .88 119.66 19.53 119.66 19.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "119.66 19.18 137.93 .85 138.11 .85 119.66 19.35 119.66 19.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-927",
    points: "119.66 19 137.76 .85 137.93 .85 119.66 19.18 119.66 19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-922",
    points: "119.66 18.82 137.58 .85 137.76 .85 119.66 19 119.66 18.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-381",
    points: "119.66 18.64 137.4 .85 137.58 .85 119.66 18.82 119.66 18.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-274",
    points: "119.66 18.47 137.23 .85 137.4 .85 119.66 18.64 119.66 18.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-358",
    points: "119.66 18.29 137.05 .85 137.23 .85 119.66 18.47 119.66 18.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-380",
    points: "119.66 18.11 136.87 .85 137.05 .85 119.66 18.29 119.66 18.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "119.66 17.93 136.69 .85 136.87 .85 119.66 18.11 119.66 17.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-383",
    points: "119.66 17.76 136.52 .85 136.69 .85 119.66 17.93 119.66 17.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "119.66 17.58 136.34 .85 136.52 .85 119.66 17.76 119.66 17.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-872",
    points: "119.66 17.4 136.16 .85 136.34 .85 119.66 17.58 119.66 17.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-816",
    points: "119.66 17.22 135.99 .85 136.16 .85 119.66 17.4 119.66 17.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-540",
    points: "119.66 17.05 135.81 .85 135.99 .85 119.66 17.22 119.66 17.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-594",
    points: "119.66 16.87 135.63 .85 135.81 .85 119.66 17.05 119.66 16.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-544",
    points: "119.66 16.69 135.46 .85 135.63 .85 119.66 16.87 119.66 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-573",
    points: "119.66 16.51 135.28 .85 135.46 .85 119.66 16.69 119.66 16.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-791",
    points: "119.66 16.34 135.1 .85 135.28 .85 119.66 16.51 119.66 16.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-549",
    points: "119.66 16.16 134.92 .85 135.1 .85 119.66 16.34 119.66 16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-621",
    points: "119.66 15.98 134.75 .85 134.92 .85 119.66 16.16 119.66 15.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-534",
    points: "119.66 15.8 134.57 .85 134.75 .85 119.66 15.98 119.66 15.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-752",
    points: "119.66 15.63 134.39 .85 134.57 .85 119.66 15.8 119.66 15.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-586",
    points: "119.66 15.45 134.22 .85 134.39 .85 119.66 15.63 119.66 15.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-608",
    points: "119.66 15.27 134.04 .85 134.22 .85 119.66 15.45 119.66 15.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-580",
    points: "119.66 15.09 133.86 .85 134.04 .85 119.66 15.27 119.66 15.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-589",
    points: "119.66 14.92 133.68 .85 133.86 .85 119.66 15.09 119.66 14.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-561",
    points: "119.66 14.74 133.51 .85 133.68 .85 119.66 14.92 119.66 14.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-561",
    points: "119.66 14.58 133.35 .85 133.51 .85 119.66 14.74 119.66 14.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-554",
    points: "119.66 14.42 133.19 .85 133.35 .85 119.66 14.58 119.66 14.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "119.66 14.26 133.03 .85 133.19 .85 119.66 14.42 119.66 14.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-328",
    points: "119.66 14.1 132.87 .85 133.03 .85 119.66 14.26 119.66 14.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-337",
    points: "119.66 13.94 132.71 .85 132.87 .85 119.66 14.1 119.66 13.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-435",
    points: "119.66 13.78 132.55 .85 132.71 .85 119.66 13.94 119.66 13.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-363",
    points: "119.66 13.61 132.39 .85 132.55 .85 119.66 13.78 119.66 13.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-494",
    points: "119.66 13.45 132.23 .85 132.39 .85 119.66 13.61 119.66 13.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-463",
    points: "119.66 13.29 132.07 .85 132.23 .85 119.66 13.45 119.66 13.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-618",
    points: "119.66 13.13 131.91 .85 132.07 .85 119.66 13.29 119.66 13.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-567",
    points: "119.66 12.97 131.75 .85 131.91 .85 119.66 13.13 119.66 12.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-638",
    points: "119.66 12.81 131.59 .85 131.75 .85 119.66 12.97 119.66 12.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-638",
    points: "131.59 .85 119.66 12.81 119.66 .85 131.59 .85"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1274"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-868",
    points: "110.81 18.28 116.38 19.32 110.81 19.32 110.81 18.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-868",
    points: "110.81 18.25 116.58 19.32 116.38 19.32 110.81 18.28 110.81 18.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-826",
    points: "110.81 18.21 116.78 19.32 116.58 19.32 110.81 18.25 110.81 18.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-844",
    points: "110.81 18.17 116.98 19.32 116.78 19.32 110.81 18.21 110.81 18.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1174",
    points: "110.81 18.14 117.17 19.32 116.98 19.32 110.81 18.17 110.81 18.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-448",
    points: "110.81 18.1 117.37 19.32 117.17 19.32 110.81 18.14 110.81 18.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "110.81 18.06 117.57 19.32 117.37 19.32 110.81 18.1 110.81 18.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1132",
    points: "110.81 18.02 117.77 19.32 117.57 19.32 110.81 18.06 110.81 18.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1147",
    points: "110.81 17.99 117.96 19.32 117.77 19.32 110.81 18.02 110.81 17.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1154",
    points: "110.81 17.95 118.16 19.32 117.96 19.32 110.81 17.99 110.81 17.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1146",
    points: "110.81 17.91 118.36 19.32 118.16 19.32 110.81 17.95 110.81 17.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1224",
    points: "110.81 17.88 118.55 19.32 118.36 19.32 110.81 17.91 110.81 17.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1250",
    points: "110.81 17.84 118.75 19.32 118.55 19.32 110.81 17.88 110.81 17.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "110.81 17.8 118.95 19.32 118.75 19.32 110.81 17.84 110.81 17.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "110.81 17.77 119.15 19.32 118.95 19.32 110.81 17.8 110.81 17.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "110.81 17.73 119.34 19.32 119.15 19.32 110.81 17.77 110.81 17.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "110.81 17.69 119.54 19.32 119.34 19.32 110.81 17.73 110.81 17.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "110.81 17.66 119.74 19.32 119.54 19.32 110.81 17.69 110.81 17.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "110.81 17.62 119.96 19.32 119.74 19.32 110.81 17.66 110.81 17.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "110.81 17.58 120.17 19.32 119.96 19.32 110.81 17.62 110.81 17.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1216",
    points: "110.81 17.53 120.39 19.32 120.17 19.32 110.81 17.58 110.81 17.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1198",
    points: "110.81 17.49 120.6 19.32 120.39 19.32 110.81 17.53 110.81 17.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-307",
    points: "110.81 17.45 120.82 19.32 120.6 19.32 110.81 17.49 110.81 17.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-513",
    points: "110.81 17.41 121.04 19.32 120.82 19.32 110.81 17.45 110.81 17.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-908",
    points: "110.81 17.37 121.25 19.32 121.04 19.32 110.81 17.41 110.81 17.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-919",
    points: "110.81 17.33 121.47 19.32 121.25 19.32 110.81 17.37 110.81 17.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-954",
    points: "110.81 17.29 121.69 19.32 121.47 19.32 110.81 17.33 110.81 17.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-810",
    points: "110.81 17.25 121.9 19.32 121.69 19.32 110.81 17.29 110.81 17.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-346",
    points: "110.81 17.21 122.12 19.32 121.9 19.32 110.81 17.25 110.81 17.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-371",
    points: "110.81 17.17 122.34 19.32 122.12 19.32 110.81 17.21 110.81 17.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-388",
    points: "110.81 17.13 122.55 19.32 122.34 19.32 110.81 17.17 110.81 17.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-475",
    points: "110.81 17.09 122.77 19.32 122.55 19.32 110.81 17.13 110.81 17.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-485",
    points: "110.81 17.05 122.99 19.32 122.77 19.32 110.81 17.09 110.81 17.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-423",
    points: "110.81 17.01 123.2 19.32 122.99 19.32 110.81 17.05 110.81 17.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "110.81 16.97 123.42 19.32 123.2 19.32 110.81 17.01 110.81 16.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "110.81 16.93 123.63 19.32 123.42 19.32 110.81 16.97 110.81 16.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-327",
    points: "110.81 16.89 123.85 19.32 123.63 19.32 110.81 16.93 110.81 16.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-854",
    points: "110.81 16.85 124.07 19.32 123.85 19.32 110.81 16.89 110.81 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-886",
    points: "110.81 16.81 124.28 19.32 124.07 19.32 110.81 16.85 110.81 16.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "110.81 16.77 124.5 19.32 124.28 19.32 110.81 16.81 110.81 16.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "110.81 16.73 124.72 19.32 124.5 19.32 110.81 16.77 110.81 16.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "110.81 16.69 124.93 19.32 124.72 19.32 110.81 16.73 110.81 16.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "110.81 16.65 125.15 19.32 124.93 19.32 110.81 16.69 110.81 16.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-930",
    points: "110.81 16.6 125.37 19.32 125.15 19.32 110.81 16.65 110.81 16.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-819",
    points: "110.81 16.56 125.58 19.32 125.37 19.32 110.81 16.6 110.81 16.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-271",
    points: "110.81 16.52 125.8 19.32 125.58 19.32 110.81 16.56 110.81 16.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-360",
    points: "110.81 16.48 126.02 19.32 125.8 19.32 110.81 16.52 110.81 16.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "110.81 16.44 126.23 19.32 126.02 19.32 110.81 16.48 110.81 16.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "110.81 16.4 126.45 19.32 126.23 19.32 110.81 16.44 110.81 16.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "110.81 16.35 126.71 19.32 126.45 19.32 110.81 16.4 110.81 16.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "110.81 16.31 126.97 19.32 126.71 19.32 110.81 16.35 110.81 16.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "110.81 16.26 127.22 19.32 126.97 19.32 110.81 16.31 110.81 16.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-877",
    points: "110.81 16.21 127.48 19.32 127.22 19.32 110.81 16.26 110.81 16.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-815",
    points: "110.81 16.16 127.74 19.32 127.48 19.32 110.81 16.21 110.81 16.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-539",
    points: "110.81 16.11 128 19.32 127.74 19.32 110.81 16.16 110.81 16.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-543",
    points: "110.81 16.06 128.26 19.32 128 19.32 110.81 16.11 110.81 16.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-572",
    points: "110.81 16.02 128.51 19.32 128.26 19.32 110.81 16.06 110.81 16.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-790",
    points: "110.81 15.97 128.77 19.32 128.51 19.32 110.81 16.02 110.81 15.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-548",
    points: "110.81 15.92 129.03 19.32 128.77 19.32 110.81 15.97 110.81 15.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-622",
    points: "110.81 15.87 129.29 19.32 129.03 19.32 110.81 15.92 110.81 15.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-533",
    points: "110.81 15.82 129.55 19.32 129.29 19.32 110.81 15.87 110.81 15.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-751",
    points: "110.81 15.78 129.8 19.32 129.55 19.32 110.81 15.82 110.81 15.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-751",
    points: "110.81 15.71 130.15 19.32 129.8 19.32 110.81 15.78 110.81 15.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-585",
    points: "110.81 15.65 130.5 19.32 130.15 19.32 110.81 15.71 110.81 15.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-609",
    points: "110.81 15.58 130.85 19.32 130.5 19.32 110.81 15.65 110.81 15.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-581",
    points: "110.81 15.51 131.2 19.32 130.85 19.32 110.81 15.58 110.81 15.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-588",
    points: "110.81 15.45 131.55 19.32 131.2 19.32 110.81 15.51 110.81 15.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-560",
    points: "110.81 15.38 131.9 19.32 131.55 19.32 110.81 15.45 110.81 15.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-553",
    points: "110.81 15.32 132.25 19.32 131.9 19.32 110.81 15.38 110.81 15.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "110.81 15.25 132.39 19.29 132.39 19.32 132.25 19.32 110.81 15.32 110.81 15.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-334",
    points: "110.81 15.19 132.41 19.22 132.39 19.29 110.81 15.25 110.81 15.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-437",
    points: "110.81 15.12 132.42 19.16 132.41 19.22 110.81 15.19 110.81 15.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "110.81 15.06 132.43 19.1 132.42 19.16 110.81 15.12 110.81 15.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "110.81 14.99 132.44 19.03 132.43 19.1 110.81 15.06 110.81 14.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-495",
    points: "110.81 14.93 132.45 18.97 132.44 19.03 110.81 14.99 110.81 14.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-466",
    points: "110.81 14.86 132.46 18.91 132.45 18.97 110.81 14.93 110.81 14.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-613",
    points: "110.81 14.8 132.48 18.84 132.46 18.91 110.81 14.86 110.81 14.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-565",
    points: "110.81 14.73 132.49 18.78 132.48 18.84 110.81 14.8 110.81 14.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-565",
    points: "110.81 14.66 132.5 18.71 132.49 18.78 110.81 14.73 110.81 14.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-639",
    points: "110.81 14.59 132.51 18.64 132.5 18.71 110.81 14.66 110.81 14.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-650",
    points: "110.81 14.52 132.53 18.57 132.51 18.64 110.81 14.59 110.81 14.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-557",
    points: "110.81 14.44 132.54 18.5 132.53 18.57 110.81 14.52 110.81 14.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-631",
    points: "110.81 14.37 132.55 18.43 132.54 18.5 110.81 14.44 110.81 14.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-430",
    points: "110.81 14.3 132.57 18.36 132.55 18.43 110.81 14.37 110.81 14.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-405",
    points: "110.81 14.23 132.58 18.3 132.57 18.36 110.81 14.3 110.81 14.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-707",
    points: "110.81 14.16 132.59 18.23 132.58 18.3 110.81 14.23 110.81 14.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-713",
    points: "110.81 14.08 132.6 18.16 132.59 18.23 110.81 14.16 110.81 14.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-760",
    points: "110.81 14.01 132.62 18.09 132.6 18.16 110.81 14.08 110.81 14.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-769",
    points: "110.81 13.94 132.63 18.02 132.62 18.09 110.81 14.01 110.81 13.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-678",
    points: "110.81 13.87 132.64 17.95 132.63 18.02 110.81 13.94 110.81 13.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-776",
    points: "110.81 13.8 132.66 17.88 132.64 17.95 110.81 13.87 110.81 13.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-667",
    points: "110.81 13.73 132.67 17.81 132.66 17.88 110.81 13.8 110.81 13.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-663",
    points: "110.81 13.65 132.68 17.74 132.67 17.81 110.81 13.73 110.81 13.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-691",
    points: "110.81 13.58 132.7 17.67 132.68 17.74 110.81 13.65 110.81 13.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-658",
    points: "110.81 13.51 132.71 17.6 132.7 17.67 110.81 13.58 110.81 13.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "110.81 13.44 132.72 17.53 132.71 17.6 110.81 13.51 110.81 13.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-525",
    points: "110.81 13.37 132.73 17.46 132.72 17.53 110.81 13.44 110.81 13.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-703",
    points: "110.81 13.29 132.75 17.39 132.73 17.46 110.81 13.37 110.81 13.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-672",
    points: "110.81 13.22 132.76 17.32 132.75 17.39 110.81 13.29 110.81 13.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-701",
    points: "110.81 13.15 132.77 17.25 132.76 17.32 110.81 13.22 110.81 13.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-696",
    points: "110.81 13.08 132.79 17.19 132.77 17.25 110.81 13.15 110.81 13.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-757",
    points: "110.81 13.01 132.8 17.12 132.79 17.19 110.81 13.08 110.81 13.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-730",
    points: "110.81 12.94 132.81 17.05 132.8 17.12 110.81 13.01 110.81 12.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-783",
    points: "110.81 12.86 132.83 16.98 132.81 17.05 110.81 12.94 110.81 12.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-716",
    points: "110.81 12.79 132.84 16.91 132.83 16.98 110.81 12.86 110.81 12.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-749",
    points: "110.81 12.72 132.85 16.84 132.84 16.91 110.81 12.79 110.81 12.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-592",
    points: "110.81 12.65 132.86 16.77 132.85 16.84 110.81 12.72 110.81 12.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-741",
    points: "110.81 12.58 132.88 16.7 132.86 16.77 110.81 12.65 110.81 12.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-737",
    points: "110.81 12.5 132.89 16.63 132.88 16.7 110.81 12.58 110.81 12.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-727",
    points: "110.81 12.43 132.9 16.56 132.89 16.63 110.81 12.5 110.81 12.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-727",
    points: "110.81 12.32 132.92 16.45 132.9 16.56 110.81 12.43 110.81 12.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-724",
    points: "110.81 12.21 132.94 16.34 132.92 16.45 110.81 12.32 110.81 12.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-686",
    points: "110.81 12.1 132.96 16.23 132.94 16.34 110.81 12.21 110.81 12.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-684",
    points: "110.81 11.98 132.98 16.13 132.96 16.23 110.81 12.1 110.81 11.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-786",
    points: "110.81 11.87 133 16.02 132.98 16.13 110.81 11.98 110.81 11.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-774",
    points: "110.81 11.76 133.02 15.91 133 16.02 110.81 11.87 110.81 11.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "110.81 11.65 133.05 15.8 133.02 15.91 110.81 11.76 110.81 11.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "110.81 11.53 133.07 15.69 133.05 15.8 110.81 11.65 110.81 11.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "110.81 11.42 133.09 15.58 133.07 15.69 110.81 11.53 110.81 11.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "110.81 11.31 133.11 15.47 133.09 15.58 110.81 11.42 110.81 11.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "110.81 11.2 133.13 15.36 133.11 15.47 110.81 11.31 110.81 11.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "110.81 11.08 133.15 15.26 133.13 15.36 110.81 11.2 110.81 11.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "110.81 10.97 133.17 15.15 133.15 15.26 110.81 11.08 110.81 10.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "110.81 8.78 133.56 13.03 133.17 15.15 110.81 10.97 110.81 8.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "110.81 6.58 133.65 10.85 133.65 12.58 133.56 13.03 110.81 8.78 110.81 6.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "110.81 6.03 111.1 4.45 133.65 8.66 133.65 10.85 110.81 6.58 110.81 6.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "111.1 4.45 111.5 2.33 133.65 6.46 133.65 8.66 111.1 4.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "111.5 2.33 111.52 2.22 133.65 6.36 133.65 6.46 111.5 2.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "111.52 2.22 111.54 2.12 133.65 6.25 133.65 6.36 111.52 2.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "111.54 2.12 111.56 2.02 133.65 6.15 133.65 6.25 111.54 2.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "111.56 2.02 111.58 1.92 133.65 6.04 133.65 6.15 111.56 2.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "111.58 1.92 111.59 1.82 133.65 5.94 133.65 6.04 111.58 1.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "111.59 1.82 111.61 1.72 133.65 5.84 133.65 5.94 111.59 1.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "111.61 1.72 111.62 1.67 133.65 5.78 133.65 5.84 111.61 1.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "111.62 1.67 111.63 1.61 133.65 5.72 133.65 5.78 111.62 1.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "111.63 1.61 111.64 1.56 133.65 5.67 133.65 5.72 111.63 1.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "111.64 1.56 111.65 1.5 133.65 5.61 133.65 5.67 111.64 1.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "111.65 1.5 111.66 1.45 133.65 5.56 133.65 5.61 111.65 1.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-771",
    points: "111.66 1.45 111.67 1.4 133.65 5.5 133.65 5.56 111.66 1.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-774",
    points: "111.67 1.4 111.68 1.34 133.65 5.45 133.65 5.5 111.67 1.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-786",
    points: "111.68 1.34 111.69 1.29 133.65 5.39 133.65 5.45 111.68 1.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-687",
    points: "111.69 1.29 111.7 1.24 133.65 5.33 133.65 5.39 111.69 1.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-723",
    points: "111.7 1.24 111.71 1.18 133.65 5.28 133.65 5.33 111.7 1.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-726",
    points: "111.71 1.18 111.72 1.13 133.65 5.22 133.65 5.28 111.71 1.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-734",
    points: "111.72 1.13 111.73 1.07 133.65 5.17 133.65 5.22 111.72 1.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-742",
    points: "111.73 1.07 111.74 1.02 133.65 5.11 133.65 5.17 111.73 1.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-593",
    points: "111.74 1.02 111.75 .97 133.65 5.06 133.65 5.11 111.74 1.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-748",
    points: "111.75 .97 111.76 .91 133.65 5 133.65 5.06 111.75 .97"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-748",
    x: 122.69,
    y: -8.19,
    width: 0.03,
    height: 22.26,
    transform: "translate(97.28 123.02) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-715",
    x: 122.69,
    y: -8.22,
    width: 0.03,
    height: 22.25,
    transform: "translate(97.32 123) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-784",
    x: 122.7,
    y: -8.25,
    width: 0.03,
    height: 22.25,
    transform: "translate(97.35 122.98) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-731",
    x: 122.7,
    y: -8.27,
    width: 0.03,
    height: 22.24,
    transform: "translate(97.38 122.95) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-758",
    x: 122.7,
    y: -8.3,
    width: 0.03,
    height: 22.24,
    transform: "translate(97.42 122.93) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-695",
    x: 122.71,
    y: -8.33,
    width: 0.03,
    height: 22.23,
    transform: "translate(97.45 122.91) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-700",
    x: 122.71,
    y: -8.36,
    width: 0.03,
    height: 22.22,
    transform: "translate(97.48 122.88) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-673",
    x: 122.71,
    y: -8.39,
    width: 0.03,
    height: 22.22,
    transform: "translate(97.52 122.86) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-704",
    x: 122.71,
    y: -8.42,
    width: 0.03,
    height: 22.21,
    transform: "translate(97.55 122.84) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-522",
    x: 122.72,
    y: -8.45,
    width: 0.03,
    height: 22.21,
    transform: "translate(97.58 122.81) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-527",
    x: 122.72,
    y: -8.48,
    width: 0.03,
    height: 22.2,
    transform: "translate(97.62 122.79) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-651",
    x: 122.72,
    y: -8.5,
    width: 0.03,
    height: 22.19,
    transform: "translate(97.65 122.77) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-690",
    x: 122.73,
    y: -8.53,
    width: 0.03,
    height: 22.19,
    transform: "translate(97.69 122.75) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-671",
    x: 122.73,
    y: -8.56,
    width: 0.03,
    height: 22.18,
    transform: "translate(97.72 122.72) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-780",
    x: 122.73,
    y: -8.59,
    width: 0.03,
    height: 22.18,
    transform: "translate(97.75 122.7) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-681",
    x: 122.73,
    y: -8.62,
    width: 0.03,
    height: 22.17,
    transform: "translate(97.79 122.68) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-770",
    x: 122.74,
    y: -8.65,
    width: 0.03,
    height: 22.16,
    transform: "translate(97.82 122.65) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-763",
    x: 122.74,
    y: -8.68,
    width: 0.03,
    height: 22.16,
    transform: "translate(97.85 122.63) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-652",
    x: 122.74,
    y: -8.7,
    width: 0.03,
    height: 22.15,
    transform: "translate(97.89 122.61) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-710",
    x: 122.75,
    y: -8.73,
    width: 0.03,
    height: 22.15,
    transform: "translate(97.92 122.58) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-398",
    x: 122.75,
    y: -8.76,
    width: 0.03,
    height: 22.14,
    transform: "translate(97.95 122.56) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-427",
    x: 122.75,
    y: -8.79,
    width: 0.03,
    height: 22.13,
    transform: "translate(97.99 122.54) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-630",
    x: 122.75,
    y: -8.82,
    width: 0.03,
    height: 22.13,
    transform: "translate(98.02 122.52) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-600",
    x: 122.76,
    y: -8.85,
    width: 0.03,
    height: 22.12,
    transform: "translate(98.05 122.49) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-634",
    x: 122.76,
    y: -8.88,
    width: 0.03,
    height: 22.12,
    transform: "translate(98.09 122.47) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-619",
    x: 122.76,
    y: -8.91,
    width: 0.03,
    height: 22.11,
    transform: "translate(98.12 122.45) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-619",
    x: 122.77,
    y: -8.93,
    width: 0.02,
    height: 22.11,
    transform: "translate(98.14 122.43) rotate(-79.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-625",
    points: "111.92 .09 111.92 .09 112 .09 133.65 4.13 133.65 4.15 111.92 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-616",
    points: "112.09 .09 133.65 4.11 133.65 4.13 112 .09 112.09 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-462",
    points: "112.19 .09 133.65 4.1 133.65 4.11 112.09 .09 112.19 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-493",
    points: "112.28 .09 133.65 4.08 133.65 4.1 112.19 .09 112.28 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-361",
    points: "112.37 .09 133.65 4.06 133.65 4.08 112.28 .09 112.37 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-428",
    points: "112.47 .09 133.65 4.04 133.65 4.06 112.37 .09 112.47 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-336",
    points: "112.56 .09 133.65 4.03 133.65 4.04 112.47 .09 112.56 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "112.65 .09 133.65 4.01 133.65 4.03 112.56 .09 112.65 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-414",
    points: "112.75 .09 133.65 3.99 133.65 4.01 112.65 .09 112.75 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-562",
    points: "112.84 .09 133.65 3.97 133.65 3.99 112.75 .09 112.84 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "112.93 .09 133.65 3.96 133.65 3.97 112.84 .09 112.93 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "113.21 .09 133.65 3.9 133.65 3.96 112.93 .09 113.21 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-579",
    points: "113.49 .09 133.65 3.85 133.65 3.9 113.21 .09 113.49 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-744",
    points: "113.77 .09 133.65 3.8 133.65 3.85 113.49 .09 113.77 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-603",
    points: "114.05 .09 133.65 3.75 133.65 3.8 113.77 .09 114.05 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-582",
    points: "114.33 .09 133.65 3.69 133.65 3.75 114.05 .09 114.33 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-753",
    points: "114.61 .09 133.65 3.64 133.65 3.69 114.33 .09 114.61 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-532",
    points: "114.89 .09 133.65 3.59 133.65 3.64 114.61 .09 114.89 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "115.17 .09 133.65 3.54 133.65 3.59 114.89 .09 115.17 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "115.28 .09 133.65 3.52 133.65 3.54 115.17 .09 115.28 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-547",
    points: "115.39 .09 133.65 3.5 133.65 3.52 115.28 .09 115.39 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-792",
    points: "115.51 .09 133.65 3.48 133.65 3.5 115.39 .09 115.51 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-628",
    points: "115.62 .09 133.65 3.45 133.65 3.48 115.51 .09 115.62 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-542",
    points: "115.73 .09 133.65 3.43 133.65 3.45 115.62 .09 115.73 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-606",
    points: "115.84 .09 133.65 3.41 133.65 3.43 115.73 .09 115.84 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-537",
    points: "115.95 .09 133.65 3.39 133.65 3.41 115.84 .09 115.95 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-813",
    points: "116.06 .09 133.65 3.37 133.65 3.39 115.95 .09 116.06 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-876",
    points: "116.18 .09 133.65 3.35 133.65 3.37 116.06 .09 116.18 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-282",
    points: "116.29 .09 133.65 3.33 133.65 3.35 116.18 .09 116.29 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "116.4 .09 133.65 3.31 133.65 3.33 116.29 .09 116.4 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-379",
    points: "116.51 .09 133.65 3.29 133.65 3.31 116.4 .09 116.51 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-365",
    points: "116.62 .09 133.65 3.27 133.65 3.29 116.51 .09 116.62 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-275",
    points: "116.74 .09 133.65 3.25 133.65 3.27 116.62 .09 116.74 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-821",
    points: "116.85 .09 133.65 3.22 133.65 3.25 116.74 .09 116.85 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-923",
    points: "116.96 .09 133.65 3.2 133.65 3.22 116.85 .09 116.96 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "117.07 .09 133.65 3.18 133.65 3.2 116.96 .09 117.07 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "117.18 .09 133.65 3.16 133.65 3.18 117.07 .09 117.18 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "117.29 .09 133.65 3.14 133.65 3.16 117.18 .09 117.29 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "117.41 .09 133.65 3.12 133.65 3.14 117.29 .09 117.41 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "117.51 .09 133.65 3.1 133.65 3.12 117.41 .09 117.51 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-888",
    points: "117.62 .09 133.65 3.08 133.65 3.1 117.51 .09 117.62 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-860",
    points: "117.72 .09 133.65 3.06 133.65 3.08 117.62 .09 117.72 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "117.83 .09 133.65 3.04 133.65 3.06 117.72 .09 117.83 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "117.93 .09 133.65 3.02 133.65 3.04 117.83 .09 117.93 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "118.04 .09 133.65 3 133.65 3.02 117.93 .09 118.04 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-426",
    points: "118.14 .09 133.65 2.98 133.65 3 118.04 .09 118.14 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "118.25 .09 133.65 2.96 133.65 2.98 118.14 .09 118.25 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-484",
    points: "118.35 .09 133.65 2.94 133.65 2.96 118.25 .09 118.35 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-473",
    points: "118.46 .09 133.65 2.92 133.65 2.94 118.35 .09 118.46 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "118.56 .09 133.65 2.9 133.65 2.92 118.46 .09 118.56 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-372",
    points: "118.66 .09 133.65 2.89 133.65 2.9 118.56 .09 118.66 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "118.77 .09 133.65 2.87 133.65 2.89 118.66 .09 118.77 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-811",
    points: "118.87 .09 133.65 2.85 133.65 2.87 118.77 .09 118.87 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-955",
    points: "118.98 .09 133.65 2.83 133.65 2.85 118.87 .09 118.98 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-918",
    points: "119.08 .09 133.65 2.81 133.65 2.83 118.98 .09 119.08 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-905",
    points: "119.19 .09 133.65 2.79 133.65 2.81 119.08 .09 119.19 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-519",
    points: "119.29 .09 133.65 2.77 133.65 2.79 119.19 .09 119.29 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "119.4 .09 133.65 2.75 133.65 2.77 119.29 .09 119.4 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1199",
    points: "119.5 .09 133.65 2.73 133.65 2.75 119.4 .09 119.5 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1215",
    points: "119.61 .09 133.65 2.71 133.65 2.73 119.5 .09 119.61 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "119.71 .09 133.65 2.69 133.65 2.71 119.61 .09 119.71 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "119.82 .09 133.65 2.67 133.65 2.69 119.71 .09 119.82 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "119.92 .09 133.65 2.65 133.65 2.67 119.82 .09 119.92 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "120.03 .09 133.65 2.63 133.65 2.65 119.92 .09 120.03 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "120.13 .09 133.65 2.61 133.65 2.63 120.03 .09 120.13 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "120.24 .09 133.65 2.59 133.65 2.61 120.13 .09 120.24 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1254",
    points: "120.34 .09 133.65 2.57 133.65 2.59 120.24 .09 120.34 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1223",
    points: "120.45 .09 133.65 2.55 133.65 2.57 120.34 .09 120.45 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1137",
    points: "120.55 .09 133.65 2.53 133.65 2.55 120.45 .09 120.55 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1152",
    points: "120.66 .09 133.65 2.51 133.65 2.53 120.55 .09 120.66 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1236",
    points: "120.76 .09 133.65 2.49 133.65 2.51 120.66 .09 120.76 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1236",
    points: "120.81 .09 133.65 2.49 133.65 2.49 120.76 .09 120.81 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1128",
    points: "120.85 .09 133.65 2.48 133.65 2.49 120.81 .09 120.85 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1121",
    points: "120.9 .09 133.65 2.47 133.65 2.48 120.85 .09 120.9 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "120.94 .09 133.65 2.46 133.65 2.47 120.9 .09 120.94 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "120.99 .09 133.65 2.45 133.65 2.46 120.94 .09 120.99 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1173",
    points: "121.03 .09 133.65 2.44 133.65 2.45 120.99 .09 121.03 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-845",
    points: "121.07 .09 133.65 2.43 133.65 2.44 121.03 .09 121.07 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "121.12 .09 133.65 2.43 133.65 2.43 121.07 .09 121.12 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-838",
    points: "121.16 .09 133.65 2.42 133.65 2.43 121.12 .09 121.16 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-945",
    points: "121.21 .09 133.65 2.41 133.65 2.42 121.16 .09 121.21 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-973",
    points: "121.25 .09 133.65 2.4 133.65 2.41 121.21 .09 121.25 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "121.3 .09 133.65 2.39 133.65 2.4 121.25 .09 121.3 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "121.34 .09 133.65 2.38 133.65 2.39 121.3 .09 121.34 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "121.39 .09 133.65 2.38 133.65 2.38 121.34 .09 121.39 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "121.43 .09 133.65 2.37 133.65 2.38 121.39 .09 121.43 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "121.48 .09 133.65 2.36 133.65 2.37 121.43 .09 121.48 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "121.52 .09 133.65 2.35 133.65 2.36 121.48 .09 121.52 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "121.57 .09 133.65 2.34 133.65 2.35 121.52 .09 121.57 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "121.61 .09 133.65 2.33 133.65 2.34 121.57 .09 121.61 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-994",
    points: "121.66 .09 133.65 2.33 133.65 2.33 121.61 .09 121.66 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-999",
    points: "121.7 .09 133.65 2.32 133.65 2.33 121.66 .09 121.7 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1004",
    points: "121.75 .09 133.65 2.31 133.65 2.32 121.7 .09 121.75 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1095",
    points: "121.79 .09 133.65 2.3 133.65 2.31 121.75 .09 121.79 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1168",
    points: "121.84 .09 133.65 2.29 133.65 2.3 121.79 .09 121.84 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1101",
    points: "121.88 .09 133.65 2.28 133.65 2.29 121.84 .09 121.88 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1101",
    points: "122 .09 133.65 2.26 133.65 2.28 121.88 .09 122 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1168",
    points: "122.13 .09 133.65 2.24 133.65 2.26 122 .09 122.13 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1095",
    points: "122.25 .09 133.65 2.21 133.65 2.24 122.13 .09 122.25 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1004",
    points: "122.38 .09 133.65 2.19 133.65 2.21 122.25 .09 122.38 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-999",
    points: "122.5 .09 133.65 2.17 133.65 2.19 122.38 .09 122.5 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-994",
    points: "122.63 .09 133.65 2.15 133.65 2.17 122.5 .09 122.63 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "122.75 .09 133.65 2.12 133.65 2.15 122.63 .09 122.75 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "122.87 .09 133.65 2.1 133.65 2.12 122.75 .09 122.87 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "123 .09 133.65 2.08 133.65 2.1 122.87 .09 123 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "123.12 .09 133.65 2.05 133.65 2.08 123 .09 123.12 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "123.25 .09 133.65 2.03 133.65 2.05 123.12 .09 123.25 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "123.37 .09 133.65 2.01 133.65 2.03 123.25 .09 123.37 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "123.5 .09 133.65 1.98 133.65 2.01 123.37 .09 123.5 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "123.62 .09 133.65 1.96 133.65 1.98 123.5 .09 123.62 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-973",
    points: "123.74 .09 133.65 1.94 133.65 1.96 123.62 .09 123.74 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-945",
    points: "123.87 .09 133.65 1.91 133.65 1.94 123.74 .09 123.87 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-838",
    points: "123.99 .09 133.65 1.89 133.65 1.91 123.87 .09 123.99 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "124.12 .09 133.65 1.87 133.65 1.89 123.99 .09 124.12 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-828",
    points: "124.17 .09 133.65 1.86 133.65 1.87 124.12 .09 124.17 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-845",
    points: "124.22 .09 133.65 1.85 133.65 1.86 124.17 .09 124.22 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1173",
    points: "124.28 .09 133.65 1.84 133.65 1.85 124.22 .09 124.28 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "124.33 .09 133.65 1.83 133.65 1.84 124.28 .09 124.33 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "124.38 .09 133.65 1.82 133.65 1.83 124.33 .09 124.38 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1121",
    points: "124.44 .09 133.65 1.81 133.65 1.82 124.38 .09 124.44 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1128",
    points: "124.49 .09 133.65 1.8 133.65 1.81 124.44 .09 124.49 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1236",
    points: "124.54 .09 133.65 1.79 133.65 1.8 124.49 .09 124.54 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1152",
    points: "124.6 .09 133.65 1.78 133.65 1.79 124.54 .09 124.6 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1137",
    points: "124.65 .09 133.65 1.77 133.65 1.78 124.6 .09 124.65 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1221",
    points: "124.7 .09 133.65 1.76 133.65 1.77 124.65 .09 124.7 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1222",
    points: "124.76 .09 133.65 1.75 133.65 1.76 124.7 .09 124.76 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1255",
    points: "124.81 .09 133.65 1.74 133.65 1.75 124.76 .09 124.81 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "124.86 .09 133.65 1.73 133.65 1.74 124.81 .09 124.86 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "124.92 .09 133.65 1.72 133.65 1.73 124.86 .09 124.92 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "124.97 .09 133.65 1.71 133.65 1.72 124.92 .09 124.97 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "125.02 .09 133.65 1.7 133.65 1.71 124.97 .09 125.02 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "125.08 .09 133.65 1.69 133.65 1.7 125.02 .09 125.08 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "125.13 .09 133.65 1.68 133.65 1.69 125.08 .09 125.13 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1213",
    points: "125.18 .09 133.65 1.67 133.65 1.68 125.13 .09 125.18 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1197",
    points: "125.24 .09 133.65 1.66 133.65 1.67 125.18 .09 125.24 .09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1197",
    points: "133.65 1.66 125.24 .09 133.65 .09 133.65 1.66"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 107.94,
    y: 93.34,
    width: 23.97,
    height: 6.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 44.11,
    y: 21.68,
    width: 103.48,
    height: 86.9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.76,
    y: 21.68,
    width: 104.84,
    height: 86.9
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1272"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "5.34 89.63 4.02 93.22 4.02 89.63 5.34 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "7.06 89.63 5.26 94.52 4.02 94.06 4.02 93.22 5.34 89.63 7.06 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "8.78 89.63 6.78 95.07 5.26 94.52 7.06 89.63 8.78 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "10.5 89.63 8.3 95.63 6.78 95.07 8.78 89.63 10.5 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "12.22 89.63 9.81 96.18 8.3 95.63 10.5 89.63 12.22 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "13.94 89.63 11.33 96.74 9.81 96.18 12.22 89.63 13.94 89.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "14.51 89.63 15.52 90 12.85 97.3 11.33 96.74 13.94 89.63 14.51 89.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 11.06,
    y: 93.12,
    width: 7.77,
    height: 1.62,
    transform: "translate(-78.39 75.64) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 12.57,
    y: 93.67,
    width: 7.77,
    height: 1.62,
    transform: "translate(-77.92 77.43) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 14.09,
    y: 94.23,
    width: 7.77,
    height: 1.62,
    transform: "translate(-77.44 79.22) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 15.61,
    y: 94.79,
    width: 7.77,
    height: 1.62,
    transform: "translate(-76.97 81) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 17.12,
    y: 95.34,
    width: 7.77,
    height: 1.62,
    transform: "translate(-76.5 82.79) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 18.64,
    y: 95.9,
    width: 7.77,
    height: 1.62,
    transform: "translate(-76.02 84.58) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 20.16,
    y: 96.45,
    width: 7.77,
    height: 1.62,
    transform: "translate(-75.55 86.37) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 21.68,
    y: 97.01,
    width: 7.77,
    height: 1.62,
    transform: "translate(-75.08 88.16) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 23.19,
    y: 97.57,
    width: 7.77,
    height: 1.62,
    transform: "translate(-74.61 89.95) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 24.71,
    y: 98.12,
    width: 7.77,
    height: 1.62,
    transform: "translate(-74.13 91.74) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 26.23,
    y: 98.68,
    width: 7.77,
    height: 1.62,
    transform: "translate(-73.66 93.53) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 27.74,
    y: 99.23,
    width: 7.77,
    height: 1.62,
    transform: "translate(-73.19 95.31) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 29.26,
    y: 99.79,
    width: 7.77,
    height: 1.62,
    transform: "translate(-72.71 97.1) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 30.78,
    y: 100.34,
    width: 7.77,
    height: 1.62,
    transform: "translate(-72.24 98.89) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 32.29,
    y: 100.9,
    width: 7.77,
    height: 1.62,
    transform: "translate(-71.77 100.68) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 33.81,
    y: 101.46,
    width: 7.77,
    height: 1.62,
    transform: "translate(-71.29 102.47) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 35.33,
    y: 102.01,
    width: 7.77,
    height: 1.62,
    transform: "translate(-70.82 104.26) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 36.84,
    y: 102.57,
    width: 7.77,
    height: 1.62,
    transform: "translate(-70.35 106.05) rotate(-69.87)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "42.82 100.01 44.34 100.56 41.8 107.5 40.69 107.5 40.15 107.3 42.82 100.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "44.34 100.56 45.86 101.12 43.52 107.5 41.8 107.5 44.34 100.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "45.86 101.12 47.37 101.67 45.24 107.5 43.52 107.5 45.86 101.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "47.37 101.67 47.96 101.89 47.96 104.77 46.96 107.5 45.24 107.5 47.37 101.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "46.96 107.5 47.96 104.77 47.96 107.5 46.96 107.5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1273"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-359",
    x: 46.5,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 46.77,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-820",
    x: 47.04,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-931",
    x: 47.31,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 47.58,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 47.85,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 48.12,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 48.39,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-887",
    x: 48.66,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-855",
    x: 48.93,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-326",
    x: 49.2,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 49.46,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 49.73,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-411",
    x: 50,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-419",
    x: 50.27,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-483",
    x: 50.54,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-469",
    x: 50.81,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-386",
    x: 51.08,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-369",
    x: 51.35,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-353",
    x: 51.62,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-808",
    x: 51.89,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-956",
    x: 52.16,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-964",
    x: 52.43,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-911",
    x: 52.7,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-511",
    x: 52.97,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 53.24,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1204",
    x: 53.5,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1217",
    x: 53.77,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 54.04,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 54.31,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 54.58,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 54.85,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 55.12,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 55.39,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1257",
    x: 55.66,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1227",
    x: 55.93,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1136",
    x: 56.2,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1155",
    x: 56.47,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1144",
    x: 56.74,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1131",
    x: 57.01,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1119",
    x: 57.27,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 57.54,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-450",
    x: 57.81,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1181",
    x: 58.08,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-848",
    x: 58.35,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-978",
    x: 58.62,
    y: 104.76,
    width: 0.27,
    height: 19.92
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1276"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-432",
    x: 4.02,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-397",
    x: 5.59,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-711",
    x: 7.16,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-654",
    x: 8.74,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-764",
    x: 10.31,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-766",
    x: 11.88,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-680",
    x: 13.46,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-778",
    x: 15.03,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-671",
    x: 16.61,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-666",
    x: 18.18,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-660",
    x: 19.75,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-656",
    x: 21.33,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-529",
    x: 22.9,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-676",
    x: 24.47,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-673",
    x: 26.05,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-699",
    x: 27.62,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-694",
    x: 29.19,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-719",
    x: 30.77,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-732",
    x: 32.34,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-781",
    x: 33.91,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-718",
    x: 35.49,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-750",
    x: 37.06,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-591",
    x: 38.63,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-739",
    x: 40.21,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-736",
    x: 41.78,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-729",
    x: 43.36,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-722",
    x: 44.93,
    y: 90.32,
    width: 1.57,
    height: 18.21
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1280"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-363",
    x: 43.19,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-341",
    x: 43.44,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-435",
    x: 43.69,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 43.93,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 44.18,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-417",
    x: 44.42,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-554",
    x: 44.67,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-552",
    x: 44.91,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-601",
    x: 45.16,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-578",
    x: 45.4,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-745",
    x: 45.65,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-611",
    x: 45.9,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-584",
    x: 46.14,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-755",
    x: 46.39,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-645",
    x: 46.63,
    y: 107.5,
    width: 0.25,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-645",
    x: 46.88,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-623",
    x: 47.21,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-550",
    x: 47.54,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-789",
    x: 47.87,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-574",
    x: 48.2,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-546",
    x: 48.54,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-605",
    x: 48.87,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-626",
    x: 49.2,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-817",
    x: 49.53,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-873",
    x: 49.86,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-878",
    x: 50.19,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 50.52,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-317",
    x: 50.86,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 51.19,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-377",
    x: 51.52,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-356",
    x: 51.85,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 52.18,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-824",
    x: 52.51,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-932",
    x: 52.84,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 53.18,
    y: 107.5,
    width: 0.33,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 53.51,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 54.14,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 54.77,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 55.4,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-879",
    x: 56.03,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-853",
    x: 56.67,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-509",
    x: 57.3,
    y: 107.5,
    width: 0.63,
    height: 17.18
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1284"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1061",
    points: "129.43 14.15 137.14 13.79 137.14 14.24 129.43 14.24 129.43 14.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1061",
    points: "129.43 14.03 137.14 13.66 137.14 13.79 129.43 14.15 129.43 14.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1019",
    points: "129.43 13.9 137.14 13.54 137.14 13.66 129.43 14.03 129.43 13.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1068",
    points: "129.43 13.78 137.14 13.41 137.14 13.54 129.43 13.9 129.43 13.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1070",
    points: "129.43 13.65 137.14 13.29 137.14 13.41 129.43 13.78 129.43 13.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1075",
    points: "129.43 13.53 137.14 13.17 137.14 13.29 129.43 13.65 129.43 13.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1007",
    points: "129.43 13.41 137.14 13.04 137.14 13.17 129.43 13.53 129.43 13.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-990",
    points: "129.43 13.28 137.14 12.92 137.14 13.04 129.43 13.41 129.43 13.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1113",
    points: "129.43 13.16 137.14 12.79 137.14 12.92 129.43 13.28 129.43 13.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1111",
    points: "129.43 13.03 137.14 12.67 137.14 12.79 129.43 13.16 129.43 13.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-899",
    points: "129.43 12.91 137.14 12.54 137.14 12.67 129.43 13.03 129.43 12.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1185",
    points: "129.43 12.79 137.14 12.42 137.14 12.54 129.43 12.91 129.43 12.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1246",
    points: "129.43 12.66 137.14 12.3 137.14 12.42 129.43 12.79 129.43 12.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1209",
    points: "129.43 12.54 137.14 12.17 137.14 12.3 129.43 12.66 129.43 12.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1211",
    points: "129.43 12.41 137.14 12.05 137.14 12.17 129.43 12.54 129.43 12.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1184",
    points: "129.43 12.29 137.14 11.92 137.14 12.05 129.43 12.41 129.43 12.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1262",
    points: "129.43 12.16 137.14 11.8 137.14 11.92 129.43 12.29 129.43 12.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1234",
    points: "129.43 12.04 137.14 11.68 137.14 11.8 129.43 12.16 129.43 12.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1086",
    points: "129.43 11.92 137.14 11.55 137.14 11.68 129.43 12.04 129.43 11.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1085",
    points: "129.43 11.79 137.14 11.43 137.14 11.55 129.43 11.92 129.43 11.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1159",
    points: "129.43 11.67 137.14 11.3 137.14 11.43 129.43 11.79 129.43 11.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1032",
    points: "129.43 11.54 137.14 11.18 137.14 11.3 129.43 11.67 129.43 11.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1098",
    points: "129.43 11.42 137.14 11.05 137.14 11.18 129.43 11.54 129.43 11.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1036",
    points: "129.43 11.29 137.14 10.93 137.14 11.05 129.43 11.42 129.43 11.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1037",
    points: "129.43 11.17 137.14 10.81 137.14 10.93 129.43 11.29 129.43 11.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1038",
    points: "129.43 11.05 137.14 10.68 137.14 10.81 129.43 11.17 129.43 11.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-902",
    points: "129.43 10.92 137.14 10.56 137.14 10.68 129.43 11.05 129.43 10.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-902",
    points: "129.43 10.74 137.14 10.38 137.14 10.56 129.43 10.92 129.43 10.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1264",
    points: "129.43 10.56 137.14 10.2 137.14 10.38 129.43 10.74 129.43 10.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-805",
    points: "129.43 10.38 137.14 10.02 137.14 10.2 129.43 10.56 129.43 10.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-795",
    points: "129.43 10.2 137.14 9.84 137.14 10.02 129.43 10.38 129.43 10.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-794",
    points: "129.43 10.02 137.14 9.66 137.14 9.84 129.43 10.2 129.43 10.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-793",
    points: "129.43 9.85 137.14 9.48 137.14 9.66 129.43 10.02 129.43 9.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-797",
    points: "129.43 9.67 137.14 9.3 137.14 9.48 129.43 9.85 129.43 9.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-796",
    points: "129.43 9.49 137.14 9.12 137.14 9.3 129.43 9.67 129.43 9.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-807",
    points: "129.43 9.31 137.14 8.94 137.14 9.12 129.43 9.49 129.43 9.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-806",
    points: "129.43 9.13 137.14 8.76 137.14 8.94 129.43 9.31 129.43 9.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1055",
    points: "129.43 8.95 137.14 8.58 137.14 8.76 129.43 9.13 129.43 8.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1078",
    points: "129.43 8.77 137.14 8.4 137.14 8.58 129.43 8.95 129.43 8.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1052",
    points: "129.43 8.59 137.14 8.22 137.14 8.4 129.43 8.77 129.43 8.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1050",
    points: "129.43 8.41 137.14 8.05 137.14 8.22 129.43 8.59 129.43 8.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1051",
    points: "129.43 8.23 137.14 7.87 137.14 8.05 129.43 8.41 129.43 8.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1063",
    points: "129.43 8.05 137.14 7.69 137.14 7.87 129.43 8.23 129.43 8.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1045",
    points: "129.43 7.87 137.14 7.51 137.14 7.69 129.43 8.05 129.43 7.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-804",
    points: "129.43 7.69 137.14 7.33 137.14 7.51 129.43 7.87 129.43 7.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-799",
    points: "129.43 7.51 137.14 7.15 137.14 7.33 129.43 7.69 129.43 7.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-799",
    points: "129.43 7.18 137.14 6.81 137.14 7.15 129.43 7.51 129.43 7.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1053",
    points: "129.43 6.85 137.14 6.48 137.14 6.81 129.43 7.18 129.43 6.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1244",
    points: "129.43 6.51 137.14 6.15 137.14 6.48 129.43 6.85 129.43 6.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1241",
    points: "129.43 6.18 137.14 5.82 137.14 6.15 129.43 6.51 129.43 6.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-478",
    points: "129.43 5.85 137.14 5.48 137.14 5.82 129.43 6.18 129.43 5.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-467",
    points: "129.43 5.51 137.14 5.15 137.14 5.48 129.43 5.85 129.43 5.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1048",
    points: "129.43 5.18 137.14 4.82 137.14 5.15 129.43 5.51 129.43 5.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1048",
    points: "137.14 4.82 129.43 5.18 129.43 4.72 137.14 4.72 137.14 4.82"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.55,
    y: 5,
    width: 6.43,
    height: 9.09
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 130.55,
    y: 5,
    width: 6.43,
    height: 9.06
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 90.02,
    width: 54,
    height: 34.68
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4,
    y: 90.21,
    width: 53.96,
    height: 34.49
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.19,
    y: 92.62,
    width: 49.52,
    height: 31.7
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.07,
    y: 99.6,
    width: 30.78,
    height: 17.17
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.17,
    y: 104.73,
    width: 4.97,
    height: 4.53
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.3,
    y: 1.38,
    width: 16.14,
    height: 18.15
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1279"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1048",
    x: 68.71,
    y: 58.43,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-467",
    x: 68.71,
    y: 57.93,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-478",
    x: 68.71,
    y: 57.42,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1241",
    x: 68.71,
    y: 56.92,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1244",
    x: 68.71,
    y: 56.41,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1053",
    x: 68.71,
    y: 55.91,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-799",
    x: 68.71,
    y: 55.4,
    width: 27.2,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-799",
    x: 68.71,
    y: 55.13,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-804",
    x: 68.71,
    y: 54.86,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1045",
    x: 68.71,
    y: 54.59,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1063",
    x: 68.71,
    y: 54.32,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1051",
    x: 68.71,
    y: 54.04,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1050",
    x: 68.71,
    y: 53.77,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1052",
    x: 68.71,
    y: 53.5,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1078",
    x: 68.71,
    y: 53.23,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1055",
    x: 68.71,
    y: 52.96,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-806",
    x: 68.71,
    y: 52.68,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-807",
    x: 68.71,
    y: 52.41,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-796",
    x: 68.71,
    y: 52.14,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-797",
    x: 68.71,
    y: 51.87,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-793",
    x: 68.71,
    y: 51.6,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-794",
    x: 68.71,
    y: 51.32,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-795",
    x: 68.71,
    y: 51.05,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-805",
    x: 68.71,
    y: 50.78,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1264",
    x: 68.71,
    y: 50.51,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-902",
    x: 68.71,
    y: 50.24,
    width: 27.2,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-902",
    x: 68.71,
    y: 50.05,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1038",
    x: 68.71,
    y: 49.86,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1037",
    x: 68.71,
    y: 49.67,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1036",
    x: 68.71,
    y: 49.48,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1098",
    x: 68.71,
    y: 49.3,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1032",
    x: 68.71,
    y: 49.11,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1159",
    x: 68.71,
    y: 48.92,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1085",
    x: 68.71,
    y: 48.73,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1086",
    x: 68.71,
    y: 48.54,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1234",
    x: 68.71,
    y: 48.35,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1262",
    x: 68.71,
    y: 48.17,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1184",
    x: 68.71,
    y: 47.98,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1211",
    x: 68.71,
    y: 47.79,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1209",
    x: 68.71,
    y: 47.6,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1246",
    x: 68.71,
    y: 47.41,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1185",
    x: 68.71,
    y: 47.23,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-899",
    x: 68.71,
    y: 47.04,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1111",
    x: 68.71,
    y: 46.85,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1113",
    x: 68.71,
    y: 46.66,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-990",
    x: 68.71,
    y: 46.47,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1007",
    x: 68.71,
    y: 46.28,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1075",
    x: 68.71,
    y: 46.1,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1070",
    x: 68.71,
    y: 45.91,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1068",
    x: 68.71,
    y: 45.72,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1019",
    x: 68.71,
    y: 45.53,
    width: 27.2,
    height: 0.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1061",
    x: 68.71,
    y: 45.34,
    width: 27.2,
    height: 0.19
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1278"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "105.61 42.06 77.23 33.38 105.61 33.38 105.61 42.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "105.61 42.08 77.17 33.38 77.23 33.38 105.61 42.06 105.61 42.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "105.61 42.09 77.12 33.38 77.17 33.38 105.61 42.08 105.61 42.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "105.61 42.11 77.06 33.38 77.12 33.38 105.61 42.09 105.61 42.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "105.61 42.13 77.01 33.38 77.06 33.38 105.61 42.11 105.61 42.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "105.61 42.14 76.95 33.38 77.01 33.38 105.61 42.13 105.61 42.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "105.61 42.16 76.9 33.38 76.95 33.38 105.61 42.14 105.61 42.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "105.61 42.18 76.84 33.38 76.9 33.38 105.61 42.16 105.61 42.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "105.61 42.19 76.79 33.38 76.84 33.38 105.61 42.18 105.61 42.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "105.61 42.21 76.73 33.38 76.79 33.38 105.61 42.19 105.61 42.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "105.61 42.23 76.67 33.38 76.73 33.38 105.61 42.21 105.61 42.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "105.61 42.25 76.62 33.38 76.67 33.38 105.61 42.23 105.61 42.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "105.61 42.26 76.56 33.38 76.62 33.38 105.61 42.25 105.61 42.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "105.61 42.28 76.51 33.38 76.56 33.38 105.61 42.26 105.61 42.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "105.61 42.3 76.45 33.38 76.51 33.38 105.61 42.28 105.61 42.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "105.61 42.31 76.43 33.39 76.43 33.38 76.45 33.38 105.61 42.3 105.61 42.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "105.61 42.35 76.43 33.42 76.43 33.39 105.61 42.31 105.61 42.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "105.61 42.39 76.43 33.46 76.43 33.42 105.61 42.35 105.61 42.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "105.61 42.42 76.43 33.5 76.43 33.46 105.61 42.39 105.61 42.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "105.61 42.46 76.43 33.53 76.43 33.5 105.61 42.42 105.61 42.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "105.61 42.5 76.43 33.57 76.43 33.53 105.61 42.46 105.61 42.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "105.61 42.53 76.43 33.6 76.43 33.57 105.61 42.5 105.61 42.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "105.61 42.57 76.43 33.64 76.43 33.6 105.61 42.53 105.61 42.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "105.61 42.59 76.43 33.66 76.43 33.64 105.61 42.57 105.61 42.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "105.61 42.61 76.43 33.68 76.43 33.66 105.61 42.59 105.61 42.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "105.61 42.63 76.43 33.7 76.43 33.68 105.61 42.61 105.61 42.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "105.61 42.65 76.43 33.73 76.43 33.7 105.61 42.63 105.61 42.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "105.61 42.68 76.43 33.75 76.43 33.73 105.61 42.65 105.61 42.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "105.61 42.7 76.43 33.77 76.43 33.75 105.61 42.68 105.61 42.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "105.61 42.72 76.43 33.79 76.43 33.77 105.61 42.7 105.61 42.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "105.61 42.75 76.43 33.82 76.43 33.79 105.61 42.72 105.61 42.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "105.61 42.77 76.43 33.85 76.43 33.82 105.61 42.75 105.61 42.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "105.61 42.8 76.43 33.87 76.43 33.85 105.61 42.77 105.61 42.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "105.61 42.82 76.43 33.9 76.43 33.87 105.61 42.8 105.61 42.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "105.61 42.85 76.43 33.92 76.43 33.9 105.61 42.82 105.61 42.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "105.61 42.88 76.43 33.95 76.43 33.92 105.61 42.85 105.61 42.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "105.61 42.9 76.43 33.97 76.43 33.95 105.61 42.88 105.61 42.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "105.61 42.93 76.43 34 76.43 33.97 105.61 42.9 105.61 42.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "105.61 42.95 76.43 34.02 76.43 34 105.61 42.93 105.61 42.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "105.61 42.98 76.43 34.05 76.43 34.02 105.61 42.95 105.61 42.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "105.61 43 76.43 34.07 76.43 34.05 105.61 42.98 105.61 43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.61 43.03 76.43 34.1 76.43 34.07 105.61 43 105.61 43.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "105.61 43.05 76.43 34.13 76.43 34.1 105.61 43.03 105.61 43.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "105.61 43.08 76.43 34.15 76.43 34.13 105.61 43.05 105.61 43.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "105.61 43.12 76.43 34.19 76.43 34.15 105.61 43.08 105.61 43.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.61 43.16 76.43 34.24 76.43 34.19 105.61 43.12 105.61 43.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "105.61 43.21 76.43 34.28 76.43 34.24 105.61 43.16 105.61 43.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "105.61 43.25 76.43 34.32 76.43 34.28 105.61 43.21 105.61 43.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "105.61 43.29 76.43 34.36 76.43 34.32 105.61 43.25 105.61 43.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "105.61 43.33 76.43 34.41 76.43 34.36 105.61 43.29 105.61 43.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "105.61 43.51 76.43 34.58 76.43 34.41 105.61 43.33 105.61 43.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "105.61 43.68 76.43 34.75 76.43 34.58 105.61 43.51 105.61 43.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "105.61 43.85 76.43 34.92 76.43 34.75 105.61 43.68 105.61 43.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "105.61 44.02 76.43 35.09 76.43 34.92 105.61 43.85 105.61 44.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "105.61 44.19 76.43 35.26 76.43 35.09 105.61 44.02 105.61 44.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.61 44.36 76.43 35.43 76.43 35.26 105.61 44.19 105.61 44.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "105.61 44.53 76.43 35.6 76.43 35.43 105.61 44.36 105.61 44.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "105.61 44.7 76.43 35.77 76.43 35.6 105.61 44.53 105.61 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.61 44.87 76.43 35.95 76.43 35.77 105.61 44.7 105.61 44.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "105.61 45.04 76.43 36.12 76.43 35.95 105.61 44.87 105.61 45.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "105.61 45.22 76.43 36.29 76.43 36.12 105.61 45.04 105.61 45.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "105.61 45.39 76.43 36.46 76.43 36.29 105.61 45.22 105.61 45.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "105.61 45.56 76.43 36.63 76.43 36.46 105.61 45.39 105.61 45.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "105.61 45.73 76.43 36.8 76.43 36.63 105.61 45.56 105.61 45.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "105.61 45.9 76.43 36.97 76.43 36.8 105.61 45.73 105.61 45.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "105.61 46.07 76.43 37.14 76.43 36.97 105.61 45.9 105.61 46.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "105.61 46.24 76.43 37.31 76.43 37.14 105.61 46.07 105.61 46.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "105.61 46.41 76.43 37.48 76.43 37.31 105.61 46.24 105.61 46.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "105.61 46.58 76.43 37.65 76.43 37.48 105.61 46.41 105.61 46.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "105.61 46.75 76.43 37.83 76.43 37.65 105.61 46.58 105.61 46.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "105.61 46.92 76.43 38 76.43 37.83 105.61 46.75 105.61 46.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "105.61 47.1 76.43 38.17 76.43 38 105.61 46.92 105.61 47.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "105.61 47.27 76.43 38.34 76.43 38.17 105.61 47.1 105.61 47.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "105.61 47.44 76.43 38.51 76.43 38.34 105.61 47.27 105.61 47.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "105.61 47.61 76.43 38.68 76.43 38.51 105.61 47.44 105.61 47.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "105.61 47.78 76.43 38.85 76.43 38.68 105.61 47.61 105.61 47.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "105.61 47.95 76.43 39.02 76.43 38.85 105.61 47.78 105.61 47.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "105.61 48.12 76.43 39.19 76.43 39.02 105.61 47.95 105.61 48.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "105.61 48.29 76.43 39.36 76.43 39.19 105.61 48.12 105.61 48.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-772",
    points: "105.61 48.46 76.43 39.53 76.43 39.36 105.61 48.29 105.61 48.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-746",
    points: "105.61 48.63 76.43 39.71 76.43 39.53 105.61 48.46 105.61 48.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-785",
    points: "105.61 48.8 76.43 39.88 76.43 39.71 105.61 48.63 105.61 48.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-688",
    points: "105.61 48.96 105.61 48.97 76.43 40.05 76.43 39.88 105.61 48.8 105.61 48.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-721",
    points: "105.61 48.97 105.56 49.13 76.43 40.22 76.43 40.05 105.61 48.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-728",
    points: "105.56 49.13 105.51 49.29 76.43 40.39 76.43 40.22 105.56 49.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-735",
    points: "105.51 49.29 105.46 49.44 76.43 40.56 76.43 40.39 105.51 49.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-738",
    points: "105.46 49.44 105.42 49.6 76.43 40.73 76.43 40.56 105.46 49.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-590",
    points: "105.42 49.6 105.37 49.76 76.43 40.9 76.43 40.73 105.42 49.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-747",
    points: "105.37 49.76 105.32 49.91 76.43 41.07 76.43 40.9 105.37 49.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-717",
    points: "105.32 49.91 105.27 50.07 76.43 41.24 76.43 41.07 105.32 49.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-782",
    points: "105.27 50.07 105.22 50.22 76.43 41.41 76.43 41.24 105.27 50.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-733",
    points: "105.22 50.22 105.18 50.38 76.43 41.59 76.43 41.41 105.22 50.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-720",
    points: "105.18 50.38 105.13 50.54 76.43 41.76 76.43 41.59 105.18 50.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-693",
    points: "105.13 50.54 105.08 50.69 76.43 41.93 76.43 41.76 105.13 50.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-698",
    points: "105.08 50.69 105.03 50.85 76.43 42.1 76.43 41.93 105.08 50.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-674",
    points: "105.03 50.85 104.99 51.01 76.43 42.27 76.43 42.1 105.03 50.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-705",
    points: "104.99 51.01 104.94 51.16 76.43 42.44 76.43 42.27 104.99 51.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-523",
    points: "104.94 51.16 104.89 51.32 76.43 42.61 76.43 42.44 104.94 51.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-526",
    points: "104.89 51.32 104.84 51.47 76.43 42.78 76.43 42.61 104.89 51.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-655",
    points: "104.84 51.47 104.84 51.49 104.32 51.49 76.43 42.95 76.43 42.78 104.84 51.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-659",
    points: "103.76 51.49 76.43 43.12 76.43 42.95 104.32 51.49 103.76 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-665",
    points: "103.2 51.49 76.43 43.3 76.43 43.12 103.76 51.49 103.2 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-669",
    points: "102.64 51.49 76.43 43.47 76.43 43.3 103.2 51.49 102.64 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-778",
    points: "102.08 51.49 76.43 43.64 76.43 43.47 102.64 51.49 102.08 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-680",
    points: "101.53 51.49 76.43 43.81 76.43 43.64 102.08 51.49 101.53 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-767",
    points: "100.97 51.49 76.43 43.98 76.43 43.81 101.53 51.49 100.97 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-765",
    points: "100.41 51.49 76.43 44.15 76.43 43.98 100.97 51.49 100.41 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-653",
    points: "99.85 51.49 76.43 44.32 76.43 44.15 100.41 51.49 99.85 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-711",
    points: "99.29 51.49 76.43 44.49 76.43 44.32 99.85 51.49 99.29 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-711",
    points: "99.23 51.49 76.43 44.51 76.43 44.49 99.29 51.49 99.23 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-397",
    points: "99.16 51.49 76.43 44.53 76.43 44.51 99.23 51.49 99.16 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-432",
    points: "99.1 51.49 76.43 44.55 76.43 44.53 99.16 51.49 99.1 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-633",
    points: "99.03 51.49 76.43 44.57 76.43 44.55 99.1 51.49 99.03 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-597",
    points: "98.97 51.49 76.43 44.59 76.43 44.57 99.03 51.49 98.97 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-635",
    points: "98.9 51.49 76.43 44.61 76.43 44.59 98.97 51.49 98.9 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-620",
    points: "98.84 51.49 76.43 44.63 76.43 44.61 98.9 51.49 98.84 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-564",
    points: "98.78 51.49 76.43 44.65 76.43 44.63 98.84 51.49 98.78 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-615",
    points: "98.71 51.49 76.43 44.67 76.43 44.65 98.78 51.49 98.71 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-461",
    points: "98.65 51.49 76.43 44.69 76.43 44.67 98.71 51.49 98.65 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-490",
    points: "98.58 51.49 76.43 44.71 76.43 44.69 98.65 51.49 98.58 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-364",
    points: "98.52 51.49 76.43 44.73 76.43 44.71 98.58 51.49 98.52 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-507",
    points: "98.46 51.49 76.43 44.75 76.43 44.73 98.52 51.49 98.46 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-507",
    points: "98.42 51.49 76.43 44.76 76.43 44.75 98.46 51.49 98.42 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-438",
    points: "98.38 51.49 76.43 44.77 76.43 44.76 98.42 51.49 98.38 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-335",
    points: "98.34 51.49 76.43 44.78 76.43 44.77 98.38 51.49 98.34 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-332",
    points: "98.3 51.49 76.43 44.79 76.43 44.78 98.34 51.49 98.3 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-415",
    points: "98.26 51.49 76.43 44.81 76.43 44.79 98.3 51.49 98.26 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-563",
    points: "98.22 51.49 76.43 44.82 76.43 44.81 98.26 51.49 98.22 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-602",
    points: "98.18 51.49 76.43 44.83 76.43 44.82 98.22 51.49 98.18 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-577",
    points: "98.14 51.49 76.43 44.84 76.43 44.83 98.18 51.49 98.14 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-587",
    points: "98.1 51.49 76.43 44.85 76.43 44.84 98.14 51.49 98.1 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-610",
    points: "98.06 51.49 76.43 44.87 76.43 44.85 98.1 51.49 98.06 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-582",
    points: "98.03 51.49 76.43 44.88 76.43 44.87 98.06 51.49 98.03 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-753",
    points: "97.99 51.49 76.43 44.89 76.43 44.88 98.03 51.49 97.99 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-532",
    points: "97.95 51.49 76.43 44.9 76.43 44.89 97.99 51.49 97.95 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-642",
    points: "97.91 51.49 76.43 44.91 76.43 44.9 97.95 51.49 97.91 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-547",
    points: "97.87 51.49 76.43 44.93 76.43 44.91 97.91 51.49 97.87 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-792",
    points: "97.83 51.49 76.43 44.94 76.43 44.93 97.87 51.49 97.83 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-556",
    points: "97.79 51.49 76.43 44.95 76.43 44.94 97.83 51.49 97.79 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-595",
    points: "97.75 51.49 76.43 44.96 76.43 44.95 97.79 51.49 97.75 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-541",
    points: "97.71 51.49 76.43 44.97 76.43 44.96 97.75 51.49 97.71 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-814",
    points: "97.67 51.49 76.43 44.99 76.43 44.97 97.71 51.49 97.67 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-875",
    points: "97.63 51.49 76.43 45 76.43 44.99 97.67 51.49 97.63 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "97.59 51.49 76.43 45.01 76.43 45 97.63 51.49 97.59 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-288",
    points: "97.56 51.49 76.43 45.02 76.43 45.01 97.59 51.49 97.56 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "97.52 51.49 76.43 45.03 76.43 45.02 97.56 51.49 97.52 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-376",
    points: "97.48 51.49 76.43 45.05 76.43 45.03 97.52 51.49 97.48 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-366",
    points: "97.44 51.49 76.43 45.06 76.43 45.05 97.48 51.49 97.44 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "97.4 51.49 76.43 45.07 76.43 45.06 97.44 51.49 97.4 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-823",
    points: "97.36 51.49 76.43 45.08 76.43 45.07 97.4 51.49 97.36 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-924",
    points: "97.32 51.49 76.43 45.09 76.43 45.08 97.36 51.49 97.32 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "97.28 51.49 76.43 45.11 76.43 45.09 97.32 51.49 97.28 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "97.24 51.49 76.43 45.12 76.43 45.11 97.28 51.49 97.24 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "97.2 51.49 76.43 45.13 76.43 45.12 97.24 51.49 97.2 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "97.17 51.49 76.43 45.14 76.43 45.13 97.2 51.49 97.17 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "97.14 51.49 76.43 45.15 76.43 45.14 97.17 51.49 97.14 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-889",
    points: "97.11 51.49 76.43 45.16 76.43 45.15 97.14 51.49 97.11 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-859",
    points: "97.08 51.49 76.43 45.17 76.43 45.16 97.11 51.49 97.08 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-324",
    points: "97.04 51.49 76.43 45.18 76.43 45.17 97.08 51.49 97.04 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "97.01 51.49 76.43 45.19 76.43 45.18 97.04 51.49 97.01 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "96.98 51.49 76.43 45.2 76.43 45.19 97.01 51.49 96.98 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-425",
    points: "96.95 51.49 76.43 45.21 76.43 45.2 96.98 51.49 96.95 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-393",
    points: "96.91 51.49 76.43 45.22 76.43 45.21 96.95 51.49 96.91 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-486",
    points: "96.88 51.49 76.43 45.23 76.43 45.22 96.91 51.49 96.88 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-474",
    points: "96.85 51.49 76.43 45.24 76.43 45.23 96.88 51.49 96.85 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-389",
    points: "96.82 51.49 76.43 45.25 76.43 45.24 96.85 51.49 96.82 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-373",
    points: "96.79 51.49 76.43 45.26 76.43 45.25 96.82 51.49 96.79 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-345",
    points: "96.75 51.49 76.43 45.27 76.43 45.26 96.79 51.49 96.75 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-809",
    points: "96.72 51.49 76.43 45.28 76.43 45.27 96.75 51.49 96.72 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-958",
    points: "96.69 51.49 76.43 45.29 76.43 45.28 96.72 51.49 96.69 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-920",
    points: "96.66 51.49 76.43 45.3 76.43 45.29 96.69 51.49 96.66 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-907",
    points: "96.63 51.49 76.43 45.31 76.43 45.3 96.66 51.49 96.63 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-512",
    points: "96.59 51.49 76.43 45.32 76.43 45.31 96.63 51.49 96.59 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "96.56 51.49 76.43 45.33 76.43 45.32 96.59 51.49 96.56 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1196",
    points: "96.53 51.49 76.43 45.34 76.43 45.33 96.56 51.49 96.53 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1218",
    points: "96.5 51.49 76.43 45.35 76.43 45.34 96.53 51.49 96.5 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "96.47 51.49 76.43 45.36 76.43 45.35 96.5 51.49 96.47 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "96.43 51.49 76.43 45.37 76.43 45.36 96.47 51.49 96.43 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "96.4 51.49 76.43 45.38 76.43 45.37 96.43 51.49 96.4 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "96.37 51.49 76.43 45.39 76.43 45.38 96.4 51.49 96.37 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "96.34 51.49 76.43 45.39 76.43 45.39 96.37 51.49 96.34 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "96.3 51.49 76.43 45.4 76.43 45.39 96.34 51.49 96.3 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1253",
    points: "96.27 51.49 76.43 45.41 76.43 45.4 96.3 51.49 96.27 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1225",
    points: "96.24 51.49 76.43 45.42 76.43 45.41 96.27 51.49 96.24 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1145",
    points: "96.21 51.49 76.43 45.43 76.43 45.42 96.24 51.49 96.21 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1153",
    points: "96.18 51.49 76.43 45.44 76.43 45.43 96.21 51.49 96.18 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1235",
    points: "96.14 51.49 76.43 45.45 76.43 45.44 96.18 51.49 96.14 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1148",
    points: "96.11 51.49 76.43 45.46 76.43 45.45 96.14 51.49 96.11 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1120",
    points: "96.08 51.49 76.43 45.47 76.43 45.46 96.11 51.49 96.08 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "96.05 51.49 76.43 45.48 76.43 45.47 96.08 51.49 96.05 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-447",
    points: "96.02 51.49 76.43 45.49 76.43 45.48 96.05 51.49 96.02 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1177",
    points: "95.98 51.49 76.43 45.5 76.43 45.49 96.02 51.49 95.98 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-839",
    points: "95.95 51.49 76.43 45.51 76.43 45.5 95.98 51.49 95.95 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-836",
    points: "95.92 51.49 76.43 45.52 76.43 45.51 95.95 51.49 95.92 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-861",
    points: "95.89 51.49 76.43 45.53 76.43 45.52 95.92 51.49 95.89 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-939",
    points: "95.86 51.49 76.43 45.54 76.43 45.53 95.89 51.49 95.86 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-977",
    points: "95.82 51.49 76.43 45.55 76.43 45.54 95.86 51.49 95.82 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "95.79 51.49 76.43 45.56 76.43 45.55 95.82 51.49 95.79 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "95.76 51.49 76.43 45.57 76.43 45.56 95.79 51.49 95.76 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "95.73 51.49 76.43 45.58 76.43 45.57 95.76 51.49 95.73 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "95.69 51.49 76.43 45.59 76.43 45.58 95.73 51.49 95.69 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "95.66 51.49 76.43 45.6 76.43 45.59 95.69 51.49 95.66 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "95.63 51.49 76.43 45.61 76.43 45.6 95.66 51.49 95.63 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "95.6 51.49 76.43 45.62 76.43 45.61 95.63 51.49 95.6 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "95.57 51.49 76.43 45.63 76.43 45.62 95.6 51.49 95.57 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-991",
    points: "95.53 51.49 76.43 45.64 76.43 45.63 95.57 51.49 95.53 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-991",
    points: "95.5 51.49 76.43 45.65 76.43 45.64 95.53 51.49 95.5 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-997",
    points: "95.47 51.49 76.43 45.66 76.43 45.65 95.5 51.49 95.47 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1006",
    points: "95.44 51.49 76.43 45.67 76.43 45.66 95.47 51.49 95.44 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1093",
    points: "95.41 51.49 76.43 45.68 76.43 45.67 95.44 51.49 95.41 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1170",
    points: "95.39 51.49 76.43 45.69 76.43 45.68 95.41 51.49 95.39 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1102",
    points: "95.36 51.49 76.43 45.7 76.43 45.69 95.39 51.49 95.36 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1106",
    points: "95.33 51.49 76.43 45.7 76.43 45.7 95.36 51.49 95.33 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1164",
    points: "95.3 51.49 76.43 45.71 76.43 45.7 95.33 51.49 95.3 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1028",
    points: "95.27 51.49 76.43 45.72 76.43 45.71 95.3 51.49 95.27 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1017",
    points: "95.24 51.49 76.43 45.73 76.43 45.72 95.27 51.49 95.24 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1060",
    points: "95.21 51.49 76.43 45.74 76.43 45.73 95.24 51.49 95.21 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1018",
    points: "95.18 51.49 76.43 45.75 76.43 45.74 95.21 51.49 95.18 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1069",
    points: "95.15 51.49 76.43 45.76 76.43 45.75 95.18 51.49 95.15 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1076",
    points: "95.12 51.49 76.43 45.77 76.43 45.76 95.15 51.49 95.12 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-989",
    points: "95.09 51.49 76.43 45.78 76.43 45.77 95.12 51.49 95.09 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1112",
    points: "95.06 51.49 76.43 45.79 76.43 45.78 95.09 51.49 95.06 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-901",
    points: "95.03 51.49 76.43 45.8 76.43 45.79 95.06 51.49 95.03 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1186",
    points: "95 51.49 76.43 45.8 76.43 45.8 95.03 51.49 95 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1245",
    points: "94.97 51.49 76.43 45.81 76.43 45.8 95 51.49 94.97 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1208",
    points: "94.94 51.49 76.43 45.82 76.43 45.81 94.97 51.49 94.94 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1212",
    points: "94.91 51.49 76.43 45.83 76.43 45.82 94.94 51.49 94.91 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1263",
    points: "94.88 51.49 76.43 45.84 76.43 45.83 94.91 51.49 94.88 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1260",
    points: "94.85 51.49 76.43 45.85 76.43 45.84 94.88 51.49 94.85 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1087",
    points: "94.82 51.49 76.43 45.86 76.43 45.85 94.85 51.49 94.82 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1158",
    points: "94.79 51.49 76.43 45.87 76.43 45.86 94.82 51.49 94.79 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1030",
    points: "94.76 51.49 76.43 45.88 76.43 45.87 94.79 51.49 94.76 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1110",
    points: "94.73 51.49 76.43 45.89 76.43 45.88 94.76 51.49 94.73 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1034",
    points: "94.7 51.49 76.43 45.9 76.43 45.89 94.73 51.49 94.7 51.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1034",
    points: "76.43 45.9 94.7 51.49 76.43 51.49 76.43 45.9"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1277"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-752",
    points: "75.97 33.38 58.89 49.96 58.89 33.38 75.97 33.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-752",
    points: "76.2 33.38 58.89 50.19 58.89 49.96 75.97 33.38 76.2 33.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-534",
    points: "76.43 33.38 58.89 50.42 58.89 50.19 76.2 33.38 76.43 33.38 76.43 33.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-621",
    points: "76.43 33.61 58.89 50.64 58.89 50.42 76.43 33.38 76.43 33.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-549",
    points: "76.43 33.84 58.89 50.87 58.89 50.64 76.43 33.61 76.43 33.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-791",
    points: "76.43 34.06 58.89 51.09 58.89 50.87 76.43 33.84 76.43 34.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-573",
    points: "76.43 34.29 58.89 51.32 58.89 51.09 76.43 34.06 76.43 34.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-544",
    points: "76.43 34.51 58.89 51.55 58.89 51.32 76.43 34.29 76.43 34.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-594",
    points: "76.43 34.74 58.89 51.77 58.89 51.55 76.43 34.51 76.43 34.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-540",
    points: "76.43 34.97 58.89 52 58.89 51.77 76.43 34.74 76.43 34.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-816",
    points: "76.43 35.19 58.89 52.22 58.89 52 76.43 34.97 76.43 35.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-872",
    points: "76.43 35.42 58.91 52.43 58.89 52.42 58.89 52.22 76.43 35.19 76.43 35.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "76.43 35.64 59.02 52.55 58.91 52.43 76.43 35.42 76.43 35.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-382",
    points: "76.43 35.87 59.13 52.67 59.02 52.55 76.43 35.64 76.43 35.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "76.43 36.09 59.34 52.69 59.16 52.69 59.13 52.67 76.43 35.87 76.43 36.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-286",
    points: "76.43 36.32 59.57 52.69 59.34 52.69 76.43 36.09 76.43 36.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-378",
    points: "76.43 36.55 59.8 52.69 59.57 52.69 76.43 36.32 76.43 36.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-374",
    points: "76.43 36.77 60.04 52.69 59.8 52.69 76.43 36.55 76.43 36.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-273",
    points: "76.43 37 60.27 52.69 60.04 52.69 76.43 36.77 76.43 37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-822",
    points: "76.43 37.22 60.5 52.69 60.27 52.69 76.43 37 76.43 37.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-925",
    points: "76.43 37.45 60.73 52.69 60.5 52.69 76.43 37.22 76.43 37.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "76.43 37.68 60.97 52.69 60.73 52.69 76.43 37.45 76.43 37.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "76.43 37.9 61.2 52.69 60.97 52.69 76.43 37.68 76.43 37.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "76.43 38.13 61.43 52.69 61.2 52.69 76.43 37.9 76.43 38.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "76.43 38.35 61.66 52.69 61.43 52.69 76.43 38.13 76.43 38.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-885",
    points: "76.43 38.58 61.9 52.69 61.66 52.69 76.43 38.35 76.43 38.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-885",
    points: "76.43 38.78 62.1 52.69 61.9 52.69 76.43 38.58 76.43 38.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-851",
    points: "76.43 38.98 62.3 52.69 62.1 52.69 76.43 38.78 76.43 38.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "76.43 39.18 62.51 52.69 62.3 52.69 76.43 38.98 76.43 39.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "76.43 39.37 62.71 52.69 62.51 52.69 76.43 39.18 76.43 39.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-402",
    points: "76.43 39.57 62.92 52.69 62.71 52.69 76.43 39.37 76.43 39.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-408",
    points: "76.43 39.77 63.12 52.69 62.92 52.69 76.43 39.57 76.43 39.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-420",
    points: "76.43 39.97 63.33 52.69 63.12 52.69 76.43 39.77 76.43 39.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-500",
    points: "76.43 40.17 63.53 52.69 63.33 52.69 76.43 39.97 76.43 40.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-496",
    points: "76.43 40.37 63.73 52.69 63.53 52.69 76.43 40.17 76.43 40.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-503",
    points: "76.43 40.56 63.94 52.69 63.73 52.69 76.43 40.37 76.43 40.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "76.43 40.76 64.14 52.69 63.94 52.69 76.43 40.56 76.43 40.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-347",
    points: "76.43 40.96 64.35 52.69 64.14 52.69 76.43 40.76 76.43 40.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-934",
    points: "76.43 41.16 64.55 52.69 64.35 52.69 76.43 40.96 76.43 41.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-935",
    points: "76.43 41.36 64.75 52.69 64.55 52.69 76.43 41.16 76.43 41.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-952",
    points: "76.43 41.56 64.96 52.69 64.75 52.69 76.43 41.36 76.43 41.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-966",
    points: "76.43 41.75 65.16 52.69 64.96 52.69 76.43 41.56 76.43 41.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-910",
    points: "76.43 41.95 65.37 52.69 65.16 52.69 76.43 41.75 76.43 41.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-515",
    points: "76.43 42.15 65.57 52.69 65.37 52.69 76.43 41.95 76.43 42.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "76.43 42.35 65.78 52.69 65.57 52.69 76.43 42.15 76.43 42.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1084",
    points: "76.43 42.55 65.98 52.69 65.78 52.69 76.43 42.35 76.43 42.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1232",
    points: "76.43 42.75 66.18 52.69 65.98 52.69 76.43 42.55 76.43 42.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "76.43 42.94 66.39 52.69 66.18 52.69 76.43 42.75 76.43 42.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-982",
    points: "76.43 43.14 66.59 52.69 66.39 52.69 76.43 42.94 76.43 43.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "76.43 43.34 66.8 52.69 66.59 52.69 76.43 43.14 76.43 43.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "76.43 43.54 67 52.69 66.8 52.69 76.43 43.34 76.43 43.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "76.43 43.74 67.21 52.69 67 52.69 76.43 43.54 76.43 43.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "76.43 43.78 67.25 52.69 67.21 52.69 76.43 43.74 76.43 43.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "76.43 43.82 67.29 52.69 67.25 52.69 76.43 43.78 76.43 43.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1252",
    points: "76.43 43.86 67.33 52.69 67.29 52.69 76.43 43.82 76.43 43.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1157",
    points: "76.43 43.9 67.37 52.69 67.33 52.69 76.43 43.86 76.43 43.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1149",
    points: "76.43 43.94 67.42 52.69 67.37 52.69 76.43 43.9 76.43 43.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1143",
    points: "76.43 43.98 67.46 52.69 67.42 52.69 76.43 43.94 76.43 43.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1127",
    points: "76.43 44.02 67.5 52.69 67.46 52.69 76.43 43.98 76.43 44.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1239",
    points: "76.43 44.06 67.54 52.69 67.5 52.69 76.43 44.02 76.43 44.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "76.43 44.11 67.58 52.69 67.54 52.69 76.43 44.06 76.43 44.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "76.43 44.13 67.61 52.69 67.58 52.69 76.43 44.11 76.43 44.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "76.43 44.15 67.64 52.69 67.61 52.69 76.43 44.13 76.43 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-866",
    points: "76.43 44.18 67.66 52.69 67.64 52.69 76.43 44.15 76.43 44.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-841",
    points: "76.43 44.2 67.69 52.69 67.66 52.69 76.43 44.18 76.43 44.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-825",
    points: "76.43 44.23 67.71 52.69 67.69 52.69 76.43 44.2 76.43 44.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-864",
    points: "76.43 44.25 67.74 52.69 67.71 52.69 76.43 44.23 76.43 44.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-942",
    points: "76.43 44.28 67.76 52.69 67.74 52.69 76.43 44.25 76.43 44.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-938",
    points: "76.43 44.3 67.79 52.69 67.76 52.69 76.43 44.28 76.43 44.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "76.43 44.33 67.81 52.69 67.79 52.69 76.43 44.3 76.43 44.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "76.43 44.35 67.84 52.69 67.81 52.69 76.43 44.33 76.43 44.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "76.43 44.38 67.86 52.69 67.84 52.69 76.43 44.35 76.43 44.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "76.43 44.4 67.89 52.69 67.86 52.69 76.43 44.38 76.43 44.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "76.43 44.42 67.91 52.69 67.89 52.69 76.43 44.4 76.43 44.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-440",
    points: "76.43 44.45 67.94 52.69 67.91 52.69 76.43 44.42 76.43 44.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "76.43 44.47 67.96 52.69 67.94 52.69 76.43 44.45 76.43 44.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-996",
    points: "76.43 44.5 67.99 52.69 67.96 52.69 76.43 44.47 76.43 44.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1003",
    points: "76.43 44.52 68.01 52.69 67.99 52.69 76.43 44.5 76.43 44.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1010",
    points: "76.43 44.55 68.04 52.69 68.01 52.69 76.43 44.52 76.43 44.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1096",
    points: "76.43 44.57 68.06 52.69 68.04 52.69 76.43 44.55 76.43 44.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1104",
    points: "76.43 44.6 68.09 52.69 68.06 52.69 76.43 44.57 76.43 44.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1089",
    points: "76.43 44.62 68.12 52.69 68.09 52.69 76.43 44.6 76.43 44.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1163",
    points: "76.43 44.65 68.14 52.69 68.12 52.69 76.43 44.62 76.43 44.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1109",
    points: "76.43 44.67 68.17 52.69 68.14 52.69 76.43 44.65 76.43 44.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1041",
    points: "76.43 44.7 68.19 52.69 68.17 52.69 76.43 44.67 76.43 44.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1016",
    points: "76.43 44.72 68.22 52.69 68.19 52.69 76.43 44.7 76.43 44.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1016",
    points: "76.43 44.74 68.24 52.69 68.22 52.69 76.43 44.72 76.43 44.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1059",
    points: "76.43 44.77 68.26 52.69 68.24 52.69 76.43 44.74 76.43 44.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1022",
    points: "76.43 44.79 68.29 52.69 68.26 52.69 76.43 44.77 76.43 44.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1064",
    points: "76.43 44.81 68.31 52.69 68.29 52.69 76.43 44.79 76.43 44.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1074",
    points: "76.43 44.84 68.34 52.69 68.31 52.69 76.43 44.81 76.43 44.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1027",
    points: "76.43 44.86 68.36 52.69 68.34 52.69 76.43 44.84 76.43 44.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-987",
    points: "76.43 44.88 68.39 52.69 68.36 52.69 76.43 44.86 76.43 44.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-898",
    points: "76.43 44.91 68.41 52.69 68.39 52.69 76.43 44.88 76.43 44.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-904",
    points: "76.43 44.93 68.43 52.69 68.41 52.69 76.43 44.91 76.43 44.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1188",
    points: "76.43 44.95 68.46 52.69 68.43 52.69 76.43 44.93 76.43 44.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1267",
    points: "76.43 44.98 68.48 52.69 68.46 52.69 76.43 44.95 76.43 44.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1183",
    points: "76.43 45 68.51 52.69 68.48 52.69 76.43 44.98 76.43 45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1261",
    points: "76.43 45.02 68.53 52.69 68.51 52.69 76.43 45 76.43 45.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1259",
    points: "76.43 45.05 68.55 52.69 68.53 52.69 76.43 45.02 76.43 45.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1088",
    points: "76.43 45.07 68.58 52.69 68.55 52.69 76.43 45.05 76.43 45.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1160",
    points: "76.43 45.09 68.6 52.69 68.58 52.69 76.43 45.07 76.43 45.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1031",
    points: "76.43 45.12 68.63 52.69 68.6 52.69 76.43 45.09 76.43 45.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1099",
    points: "76.43 45.14 68.65 52.69 68.63 52.69 76.43 45.12 76.43 45.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1035",
    points: "76.43 45.16 68.67 52.69 68.65 52.69 76.43 45.14 76.43 45.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1033",
    points: "76.43 45.19 68.7 52.69 68.67 52.69 76.43 45.16 76.43 45.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-896",
    points: "76.43 45.21 68.72 52.69 68.7 52.69 76.43 45.19 76.43 45.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-896",
    points: "68.72 52.69 76.43 45.21 76.43 52.69 68.72 52.69"
  }))), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 58.87,
    y: 32.21,
    width: 46.78,
    height: 17.36
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.88,
    y: 41.83,
    width: 18.03,
    height: 17.4
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 54.61,
    y: 93.6,
    width: 55.32,
    height: 29.47
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.79,
    y: 90.77,
    width: 43.5,
    height: 16.79
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 75.87,
    y: 33.12,
    width: 31.2,
    height: 9.32
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.49,
    y: 0.85,
    width: 10.8,
    height: 19.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1077",
    d: "M55.36,116.09s42.47-28.28,48.53-32.24c6.05-3.96,16.6-8.18,36.73-8.71,20.13-.53,30.3-17.95,30.3-17.95,0,0,.22,22.68-15.5,36.15-15.73,13.47-29.72,4.48-33.26,2.67-3.55-1.82-7.7-4.75-16.54,.78-8.83,5.54-46.72,24.71-46.72,24.71l-3.53-5.41Z"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1281"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-751",
    x: 115.51,
    y: 89.13,
    width: 48.48,
    height: 2.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-751",
    x: 115.51,
    y: 88.91,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-585",
    x: 115.51,
    y: 88.69,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-609",
    x: 115.51,
    y: 88.47,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-581",
    x: 115.51,
    y: 88.25,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-588",
    x: 115.51,
    y: 88.03,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-560",
    x: 115.51,
    y: 87.81,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-553",
    x: 115.51,
    y: 87.59,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-416",
    x: 115.51,
    y: 87.37,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-329",
    x: 115.51,
    y: 87.15,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 115.51,
    y: 86.93,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-436",
    x: 115.51,
    y: 86.71,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 115.51,
    y: 86.48,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-491",
    x: 115.51,
    y: 86.26,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-465",
    x: 115.51,
    y: 86.04,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-612",
    x: 115.51,
    y: 85.82,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-566",
    x: 115.51,
    y: 85.6,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-640",
    x: 115.51,
    y: 85.38,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-649",
    x: 115.51,
    y: 85.16,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-558",
    x: 115.51,
    y: 84.94,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-632",
    x: 115.51,
    y: 84.72,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-431",
    x: 115.51,
    y: 84.5,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-404",
    x: 115.51,
    y: 84.28,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-708",
    x: 115.51,
    y: 84.06,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-714",
    x: 115.51,
    y: 83.84,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-761",
    x: 115.51,
    y: 83.62,
    width: 48.48,
    height: 0.22
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-761",
    x: 115.51,
    y: 83.34,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-768",
    x: 115.51,
    y: 83.07,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-679",
    x: 115.51,
    y: 82.79,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-777",
    x: 115.51,
    y: 82.52,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-668",
    x: 115.51,
    y: 82.24,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-662",
    x: 115.51,
    y: 81.97,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-692",
    x: 115.51,
    y: 81.69,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-657",
    x: 115.51,
    y: 81.42,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-528",
    x: 115.51,
    y: 81.14,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-524",
    x: 115.51,
    y: 80.87,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-677",
    x: 115.51,
    y: 80.59,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-675",
    x: 115.51,
    y: 80.31,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-702",
    x: 115.51,
    y: 80.04,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-697",
    x: 115.51,
    y: 79.76,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-759",
    x: 115.51,
    y: 79.49,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-740",
    x: 115.51,
    y: 79.21,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-783",
    x: 115.51,
    y: 78.94,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-716",
    x: 115.51,
    y: 78.66,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-749",
    x: 115.51,
    y: 78.39,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-592",
    x: 115.51,
    y: 78.11,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-741",
    x: 115.51,
    y: 77.84,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-737",
    x: 115.51,
    y: 77.56,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-727",
    x: 115.51,
    y: 77.28,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-724",
    x: 115.51,
    y: 77.01,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-686",
    x: 115.51,
    y: 76.73,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-684",
    x: 115.51,
    y: 76.46,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-786",
    x: 115.51,
    y: 76.18,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-774",
    x: 115.51,
    y: 75.91,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-771",
    x: 115.51,
    y: 75.63,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 115.51,
    y: 75.36,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 115.51,
    y: 75.08,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 115.51,
    y: 74.81,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 115.51,
    y: 74.42,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 115.51,
    y: 74.04,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 115.51,
    y: 73.66,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 115.51,
    y: 73.28,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 115.51,
    y: 72.9,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 115.51,
    y: 72.52,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 115.51,
    y: 72.14,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 115.51,
    y: 71.75,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 115.51,
    y: 71.37,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 115.51,
    y: 70.99,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 115.51,
    y: 70.61,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 115.51,
    y: 70.23,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 115.51,
    y: 69.85,
    width: 48.48,
    height: 0.38
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 115.51,
    y: 64.78,
    width: 48.48,
    height: 5.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 115.51,
    y: 59.71,
    width: 48.48,
    height: 5.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 115.51,
    y: 54.64,
    width: 48.48,
    height: 5.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 115.51,
    y: 49.57,
    width: 48.48,
    height: 5.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 115.51,
    y: 44.51,
    width: 48.48,
    height: 5.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 115.51,
    y: 44.23,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 115.51,
    y: 43.96,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 115.51,
    y: 43.68,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 115.51,
    y: 43.4,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 115.51,
    y: 43.13,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 115.51,
    y: 42.85,
    width: 48.48,
    height: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 115.51,
    y: 42.74,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 115.51,
    y: 42.63,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 115.51,
    y: 42.52,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 115.51,
    y: 42.41,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 115.51,
    y: 42.3,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-771",
    x: 115.51,
    y: 42.19,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-774",
    x: 115.51,
    y: 42.08,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-786",
    x: 115.51,
    y: 41.97,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-687",
    x: 115.51,
    y: 41.86,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-723",
    x: 115.51,
    y: 41.75,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-726",
    x: 115.51,
    y: 41.64,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-734",
    x: 115.51,
    y: 41.53,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-742",
    x: 115.51,
    y: 41.42,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-593",
    x: 115.51,
    y: 41.31,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-748",
    x: 115.51,
    y: 41.2,
    width: 48.48,
    height: 0.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-748",
    x: 115.51,
    y: 41.12,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-715",
    x: 115.51,
    y: 41.03,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-784",
    x: 115.51,
    y: 40.95,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-731",
    x: 115.51,
    y: 40.86,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-758",
    x: 115.51,
    y: 40.78,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-695",
    x: 115.51,
    y: 40.69,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-700",
    x: 115.51,
    y: 40.61,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-673",
    x: 115.51,
    y: 40.52,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-704",
    x: 115.51,
    y: 40.44,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-522",
    x: 115.51,
    y: 40.35,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-527",
    x: 115.51,
    y: 40.27,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-651",
    x: 115.51,
    y: 40.18,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-690",
    x: 115.51,
    y: 40.1,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-671",
    x: 115.51,
    y: 40.01,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-780",
    x: 115.51,
    y: 39.93,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-681",
    x: 115.51,
    y: 39.84,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-770",
    x: 115.51,
    y: 39.76,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-763",
    x: 115.51,
    y: 39.68,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-652",
    x: 115.51,
    y: 39.59,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-710",
    x: 115.51,
    y: 39.51,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-398",
    x: 115.51,
    y: 39.42,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-427",
    x: 115.51,
    y: 39.34,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-630",
    x: 115.51,
    y: 39.25,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-600",
    x: 115.51,
    y: 39.17,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-634",
    x: 115.51,
    y: 39.08,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-619",
    x: 115.51,
    y: 39,
    width: 48.48,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-619",
    x: 115.51,
    y: 38.91,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-625",
    x: 115.51,
    y: 38.81,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-616",
    x: 115.51,
    y: 38.72,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-462",
    x: 115.51,
    y: 38.63,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-493",
    x: 115.51,
    y: 38.54,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-361",
    x: 115.51,
    y: 38.45,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-428",
    x: 115.51,
    y: 38.35,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-336",
    x: 115.51,
    y: 38.26,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 115.51,
    y: 38.17,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-414",
    x: 115.51,
    y: 38.08,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-562",
    x: 115.51,
    y: 37.99,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-531",
    x: 115.51,
    y: 37.9,
    width: 48.48,
    height: 0.09
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-531",
    x: 115.51,
    y: 37.83,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-579",
    x: 115.51,
    y: 37.76,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-744",
    x: 115.51,
    y: 37.69,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-603",
    x: 115.51,
    y: 37.62,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-582",
    x: 115.51,
    y: 37.55,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-753",
    x: 115.51,
    y: 37.48,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-532",
    x: 115.51,
    y: 37.41,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-642",
    x: 115.51,
    y: 37.34,
    width: 48.48,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-642",
    x: 115.51,
    y: 37.32,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-547",
    x: 115.51,
    y: 37.29,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-792",
    x: 115.51,
    y: 37.26,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-628",
    x: 115.51,
    y: 37.23,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-542",
    x: 115.51,
    y: 37.21,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-606",
    x: 115.51,
    y: 37.18,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-537",
    x: 115.51,
    y: 37.15,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-813",
    x: 115.51,
    y: 37.12,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-876",
    x: 115.51,
    y: 37.1,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 115.51,
    y: 37.07,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 115.51,
    y: 37.04,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-379",
    x: 115.51,
    y: 37.01,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-365",
    x: 115.51,
    y: 36.99,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 115.51,
    y: 36.96,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-821",
    x: 115.51,
    y: 36.93,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-923",
    x: 115.51,
    y: 36.9,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 115.51,
    y: 36.88,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 115.51,
    y: 36.85,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 115.51,
    y: 36.82,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 115.51,
    y: 36.79,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 115.51,
    y: 36.76,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-888",
    x: 115.51,
    y: 36.72,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-860",
    x: 115.51,
    y: 36.69,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 115.51,
    y: 36.66,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 115.51,
    y: 36.62,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 115.51,
    y: 36.59,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-426",
    x: 115.51,
    y: 36.55,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-394",
    x: 115.51,
    y: 36.52,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-484",
    x: 115.51,
    y: 36.48,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-473",
    x: 115.51,
    y: 36.45,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-387",
    x: 115.51,
    y: 36.42,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-372",
    x: 115.51,
    y: 36.38,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-344",
    x: 115.51,
    y: 36.35,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-811",
    x: 115.51,
    y: 36.31,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-955",
    x: 115.51,
    y: 36.28,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-918",
    x: 115.51,
    y: 36.24,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-905",
    x: 115.51,
    y: 36.21,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-519",
    x: 115.51,
    y: 36.17,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 115.51,
    y: 36.14,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1199",
    x: 115.51,
    y: 36.11,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1215",
    x: 115.51,
    y: 36.07,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 115.51,
    y: 36.04,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 115.51,
    y: 36,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 115.51,
    y: 35.97,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 115.51,
    y: 35.93,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 115.51,
    y: 35.9,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 115.51,
    y: 35.86,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1254",
    x: 115.51,
    y: 35.83,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1223",
    x: 115.51,
    y: 35.8,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1137",
    x: 115.51,
    y: 35.76,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1152",
    x: 115.51,
    y: 35.73,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1236",
    x: 115.51,
    y: 35.69,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1236",
    x: 115.51,
    y: 35.67,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1128",
    x: 115.51,
    y: 35.65,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1121",
    x: 115.51,
    y: 35.63,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 115.51,
    y: 35.6,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 115.51,
    y: 35.58,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1173",
    x: 115.51,
    y: 35.56,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-845",
    x: 115.51,
    y: 35.54,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-828",
    x: 115.51,
    y: 35.52,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-838",
    x: 115.51,
    y: 35.49,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-945",
    x: 115.51,
    y: 35.47,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-973",
    x: 115.51,
    y: 35.45,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 115.51,
    y: 35.43,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 115.51,
    y: 35.41,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 115.51,
    y: 35.38,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 115.51,
    y: 35.36,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 115.51,
    y: 35.34,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 115.51,
    y: 35.32,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-443",
    x: 115.51,
    y: 35.3,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 115.51,
    y: 35.27,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-994",
    x: 115.51,
    y: 35.25,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-999",
    x: 115.51,
    y: 35.23,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1004",
    x: 115.51,
    y: 35.21,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1095",
    x: 115.51,
    y: 35.19,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1168",
    x: 115.51,
    y: 35.16,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1101",
    x: 115.51,
    y: 35.14,
    width: 48.48,
    height: 0.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1101",
    x: 115.51,
    y: 35.11,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1168",
    x: 115.51,
    y: 35.08,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1095",
    x: 115.51,
    y: 35.05,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1004",
    x: 115.51,
    y: 35.02,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-999",
    x: 115.51,
    y: 34.99,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-994",
    x: 115.51,
    y: 34.96,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 115.51,
    y: 34.93,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-443",
    x: 115.51,
    y: 34.9,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 115.51,
    y: 34.87,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 115.51,
    y: 34.84,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 115.51,
    y: 34.8,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 115.51,
    y: 34.77,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 115.51,
    y: 34.74,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 115.51,
    y: 34.71,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-973",
    x: 115.51,
    y: 34.68,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-945",
    x: 115.51,
    y: 34.65,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-838",
    x: 115.51,
    y: 34.62,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-828",
    x: 115.51,
    y: 34.59,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-828",
    x: 115.51,
    y: 34.56,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-845",
    x: 115.51,
    y: 34.54,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1173",
    x: 115.51,
    y: 34.51,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-446",
    x: 115.51,
    y: 34.49,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 115.51,
    y: 34.46,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1121",
    x: 115.51,
    y: 34.43,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1128",
    x: 115.51,
    y: 34.41,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1236",
    x: 115.51,
    y: 34.38,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1152",
    x: 115.51,
    y: 34.35,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1137",
    x: 115.51,
    y: 34.33,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1221",
    x: 115.51,
    y: 34.3,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1222",
    x: 115.51,
    y: 34.28,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1255",
    x: 115.51,
    y: 34.25,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 115.51,
    y: 34.22,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 115.51,
    y: 34.2,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 115.51,
    y: 34.17,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 115.51,
    y: 34.14,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 115.51,
    y: 34.12,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 115.51,
    y: 34.09,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1213",
    x: 115.51,
    y: 34.07,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1197",
    x: 115.51,
    y: 34.04,
    width: 48.48,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1197",
    x: 115.51,
    y: 32,
    width: 48.48,
    height: 2.04
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1283"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1188",
    points: "135.5 32.23 115.58 52.2 115.58 32.23 135.5 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1188",
    points: "138.29 32.23 115.58 54.99 115.58 52.2 135.5 32.23 138.29 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-904",
    points: "141.08 32.23 115.58 57.79 115.58 54.99 138.29 32.23 141.08 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-898",
    points: "143.86 32.23 115.58 60.59 115.58 57.79 141.08 32.23 143.86 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-988",
    points: "146.65 32.23 115.58 63.38 115.58 60.59 143.86 32.23 146.65 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-986",
    points: "149.44 32.23 115.58 66.18 115.58 63.38 146.65 32.23 149.44 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1025",
    points: "152.23 32.23 115.58 68.97 115.58 66.18 149.44 32.23 152.23 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1071",
    points: "153.98 32.23 154.5 32.75 115.58 71.77 115.58 68.97 152.23 32.23 153.98 32.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1071",
    points: "154.5 32.75 155.27 33.52 115.58 73.32 115.58 71.77 154.5 32.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1067",
    points: "155.27 33.52 156.05 34.29 115.58 74.86 115.58 73.32 155.27 33.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1020",
    points: "156.05 34.29 156.82 35.06 115.58 76.41 115.58 74.86 156.05 34.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1057",
    points: "156.82 35.06 157.59 35.83 115.58 77.95 115.58 76.41 156.82 35.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1014",
    points: "157.59 35.83 158.37 36.6 115.58 79.5 115.58 77.95 157.59 35.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1013",
    points: "158.37 36.6 159.14 37.37 115.58 81.04 115.58 79.5 158.37 36.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1043",
    points: "159.14 37.37 159.91 38.14 115.94 82.23 115.58 81.87 115.58 81.04 159.14 37.37"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1107",
    x: 107.18,
    y: 60.02,
    width: 62.26,
    height: 1.09,
    transform: "translate(-2.24 115.74) rotate(-45.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1165",
    x: 107.95,
    y: 60.79,
    width: 62.26,
    height: 1.09,
    transform: "translate(-2.56 116.51) rotate(-45.08)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1103",
    x: 108.73,
    y: 61.57,
    width: 62.26,
    height: 1.09,
    transform: "translate(-2.88 117.28) rotate(-45.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1167",
    points: "162.23 40.45 162.5 40.73 162.5 41.72 119.03 85.31 118.26 84.54 162.23 40.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1092",
    points: "162.5 43.27 119.81 86.08 119.03 85.31 162.5 41.72 162.5 43.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1011",
    points: "162.5 44.81 120.58 86.85 119.81 86.08 162.5 43.27 162.5 44.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1000",
    points: "162.5 46.36 121.35 87.62 120.58 86.85 162.5 44.81 162.5 46.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1029",
    points: "162.5 47.91 122.12 88.39 121.35 87.62 162.5 46.36 162.5 47.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-984",
    points: "162.5 49.45 122.9 89.16 122.12 88.39 162.5 47.91 162.5 49.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "162.5 51 123.67 89.93 122.9 89.16 162.5 49.45 162.5 51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-453",
    points: "162.5 52.54 124.78 90.37 124.1 90.37 123.67 89.93 162.5 51 162.5 52.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "162.5 54.09 126.32 90.37 124.78 90.37 162.5 52.54 162.5 54.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "162.5 55.17 127.41 90.37 126.32 90.37 162.5 54.09 162.5 55.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "162.5 56.26 128.49 90.37 127.41 90.37 162.5 55.17 162.5 56.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "162.5 57.35 129.57 90.37 128.49 90.37 162.5 56.26 162.5 57.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "162.5 58.44 130.66 90.37 129.57 90.37 162.5 57.35 162.5 58.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "162.5 59.52 131.74 90.37 130.66 90.37 162.5 58.44 162.5 59.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "162.5 60.61 132.83 90.37 131.74 90.37 162.5 59.52 162.5 60.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "162.5 61.7 133.91 90.37 132.83 90.37 162.5 60.61 162.5 61.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-975",
    points: "162.5 62.79 135 90.37 133.91 90.37 162.5 61.7 162.5 62.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-976",
    points: "162.5 63.87 136.08 90.37 135 90.37 162.5 62.79 162.5 63.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-947",
    points: "162.5 64.96 137.17 90.37 136.08 90.37 162.5 63.87 162.5 64.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-863",
    points: "162.5 66.05 138.25 90.37 137.17 90.37 162.5 64.96 162.5 66.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-831",
    points: "162.5 67.14 139.33 90.37 138.25 90.37 162.5 66.05 162.5 67.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-830",
    points: "162.5 68.22 140.42 90.37 139.33 90.37 162.5 67.14 162.5 68.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-847",
    points: "162.5 69.31 141.5 90.37 140.42 90.37 162.5 68.22 162.5 69.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1171",
    points: "162.5 70.4 142.59 90.37 141.5 90.37 162.5 69.31 162.5 70.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1171",
    points: "142.59 90.37 162.5 70.4 162.5 90.37 142.59 90.37"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.08,
    y: 34.36,
    width: 40.49,
    height: 55.39
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 122.08,
    y: 34.36,
    width: 40.3,
    height: 55.24
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1282"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1101",
    x: 122.13,
    y: 80.05,
    width: 33.83,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1101",
    x: 122.13,
    y: 79.88,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1168",
    x: 122.13,
    y: 79.71,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1095",
    x: 122.13,
    y: 79.53,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1004",
    x: 122.13,
    y: 79.36,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-999",
    x: 122.13,
    y: 79.19,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-994",
    x: 122.13,
    y: 79.01,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 122.13,
    y: 78.84,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-443",
    x: 122.13,
    y: 78.67,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 122.13,
    y: 78.5,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 122.13,
    y: 78.32,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 122.13,
    y: 78.15,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 122.13,
    y: 77.98,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 122.13,
    y: 77.81,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 122.13,
    y: 77.63,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-972",
    x: 122.13,
    y: 77.46,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-944",
    x: 122.13,
    y: 77.29,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-837",
    x: 122.13,
    y: 77.11,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-829",
    x: 122.13,
    y: 76.94,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-846",
    x: 122.13,
    y: 76.77,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1172",
    x: 122.13,
    y: 76.6,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-445",
    x: 122.13,
    y: 76.42,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 122.13,
    y: 76.25,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1122",
    x: 122.13,
    y: 76.08,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1129",
    x: 122.13,
    y: 75.9,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1237",
    x: 122.13,
    y: 75.73,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1151",
    x: 122.13,
    y: 75.56,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1138",
    x: 122.13,
    y: 75.39,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1220",
    x: 122.13,
    y: 75.21,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1256",
    x: 122.13,
    y: 75.04,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 122.13,
    y: 74.87,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 122.13,
    y: 74.7,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 122.13,
    y: 74.52,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 122.13,
    y: 74.35,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 122.13,
    y: 74.18,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 122.13,
    y: 74,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1214",
    x: 122.13,
    y: 73.83,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1200",
    x: 122.13,
    y: 73.66,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 122.13,
    y: 73.49,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-520",
    x: 122.13,
    y: 73.31,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-906",
    x: 122.13,
    y: 73.14,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-915",
    x: 122.13,
    y: 72.97,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-957",
    x: 122.13,
    y: 72.79,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-892",
    x: 122.13,
    y: 72.62,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-343",
    x: 122.13,
    y: 72.45,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-370",
    x: 122.13,
    y: 72.28,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-504",
    x: 122.13,
    y: 72.1,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-497",
    x: 122.13,
    y: 71.93,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-499",
    x: 122.13,
    y: 71.76,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-395",
    x: 122.13,
    y: 71.58,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-423",
    x: 122.13,
    y: 71.41,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 122.13,
    y: 71.24,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-294",
    x: 122.13,
    y: 71.07,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-849",
    x: 122.13,
    y: 70.89,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-881",
    x: 122.13,
    y: 70.72,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 122.13,
    y: 70.55,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 122.13,
    y: 70.38,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 122.13,
    y: 70.2,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 122.13,
    y: 70.03,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-929",
    x: 122.13,
    y: 69.86,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-969",
    x: 122.13,
    y: 69.68,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 122.13,
    y: 69.51,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-358",
    x: 122.13,
    y: 69.34,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-380",
    x: 122.13,
    y: 69.17,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 122.13,
    y: 68.99,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-383",
    x: 122.13,
    y: 68.82,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 122.13,
    y: 68.65,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-872",
    x: 122.13,
    y: 68.47,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-816",
    x: 122.13,
    y: 68.3,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-540",
    x: 122.13,
    y: 68.13,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-594",
    x: 122.13,
    y: 67.96,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-544",
    x: 122.13,
    y: 67.78,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-573",
    x: 122.13,
    y: 67.61,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-791",
    x: 122.13,
    y: 67.44,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-549",
    x: 122.13,
    y: 67.26,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-621",
    x: 122.13,
    y: 67.09,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-534",
    x: 122.13,
    y: 66.92,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-752",
    x: 122.13,
    y: 66.75,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-586",
    x: 122.13,
    y: 66.57,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-609",
    x: 122.13,
    y: 66.4,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-581",
    x: 122.13,
    y: 66.23,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-588",
    x: 122.13,
    y: 66.06,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-560",
    x: 122.13,
    y: 65.88,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-553",
    x: 122.13,
    y: 65.71,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-416",
    x: 122.13,
    y: 65.54,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-329",
    x: 122.13,
    y: 65.36,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 122.13,
    y: 65.19,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-436",
    x: 122.13,
    y: 65.02,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 122.13,
    y: 64.85,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-362",
    x: 122.13,
    y: 64.67,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-492",
    x: 122.13,
    y: 64.5,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-464",
    x: 122.13,
    y: 64.33,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-617",
    x: 122.13,
    y: 64.15,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-568",
    x: 122.13,
    y: 63.98,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-637",
    x: 122.13,
    y: 63.81,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-647",
    x: 122.13,
    y: 63.64,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-599",
    x: 122.13,
    y: 63.46,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-629",
    x: 122.13,
    y: 63.29,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-433",
    x: 122.13,
    y: 63.12,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-406",
    x: 122.13,
    y: 62.95,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-706",
    x: 122.13,
    y: 62.77,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-712",
    x: 122.13,
    y: 62.6,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-762",
    x: 122.13,
    y: 62.43,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-661",
    x: 122.13,
    y: 62.25,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-682",
    x: 122.13,
    y: 62.08,
    width: 33.83,
    height: 0.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-682",
    x: 122.13,
    y: 61.92,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-779",
    x: 122.13,
    y: 61.76,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-670",
    x: 122.13,
    y: 61.61,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-664",
    x: 122.13,
    y: 61.45,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-689",
    x: 122.13,
    y: 61.29,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-658",
    x: 122.13,
    y: 61.13,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-530",
    x: 122.13,
    y: 60.97,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-525",
    x: 122.13,
    y: 60.82,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-703",
    x: 122.13,
    y: 60.66,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-672",
    x: 122.13,
    y: 60.5,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-701",
    x: 122.13,
    y: 60.34,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-696",
    x: 122.13,
    y: 60.18,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-757",
    x: 122.13,
    y: 60.03,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-730",
    x: 122.13,
    y: 59.87,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-783",
    x: 122.13,
    y: 59.71,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-716",
    x: 122.13,
    y: 59.55,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-749",
    x: 122.13,
    y: 59.39,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-592",
    x: 122.13,
    y: 59.23,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-741",
    x: 122.13,
    y: 59.08,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-737",
    x: 122.13,
    y: 58.92,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-727",
    x: 122.13,
    y: 58.76,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-685",
    x: 122.13,
    y: 58.6,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-683",
    x: 122.13,
    y: 58.44,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-725",
    x: 122.13,
    y: 58.29,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-775",
    x: 122.13,
    y: 58.13,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-773",
    x: 122.13,
    y: 57.97,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 122.13,
    y: 57.81,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 122.13,
    y: 57.65,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 122.13,
    y: 57.5,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 122.13,
    y: 57.34,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 122.13,
    y: 57.18,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 122.13,
    y: 57.02,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 122.13,
    y: 56.86,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 122.13,
    y: 56.7,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 122.13,
    y: 56.55,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 122.13,
    y: 56.39,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 122.13,
    y: 56.23,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 122.13,
    y: 56.07,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 122.13,
    y: 55.91,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 122.13,
    y: 55.76,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 122.13,
    y: 55.6,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 122.13,
    y: 55.44,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 122.13,
    y: 55.17,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 122.13,
    y: 54.9,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 122.13,
    y: 54.63,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 122.13,
    y: 54.36,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 122.13,
    y: 54.09,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 122.13,
    y: 53.82,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 122.13,
    y: 53.55,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 122.13,
    y: 53.28,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 122.13,
    y: 53.01,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 122.13,
    y: 52.74,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 122.13,
    y: 52.46,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 122.13,
    y: 52.19,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 122.13,
    y: 51.92,
    width: 33.83,
    height: 0.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 122.13,
    y: 51.73,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 122.13,
    y: 51.53,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 122.13,
    y: 51.34,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-771",
    x: 122.13,
    y: 51.14,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-774",
    x: 122.13,
    y: 50.95,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-786",
    x: 122.13,
    y: 50.75,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-684",
    x: 122.13,
    y: 50.56,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-686",
    x: 122.13,
    y: 50.36,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-724",
    x: 122.13,
    y: 50.17,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-727",
    x: 122.13,
    y: 49.97,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-737",
    x: 122.13,
    y: 49.78,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-741",
    x: 122.13,
    y: 49.58,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-592",
    x: 122.13,
    y: 49.38,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-749",
    x: 122.13,
    y: 49.19,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-716",
    x: 122.13,
    y: 48.99,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-783",
    x: 122.13,
    y: 48.8,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-740",
    x: 122.13,
    y: 48.6,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-759",
    x: 122.13,
    y: 48.41,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-697",
    x: 122.13,
    y: 48.21,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-702",
    x: 122.13,
    y: 48.02,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-675",
    x: 122.13,
    y: 47.82,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-677",
    x: 122.13,
    y: 47.63,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-524",
    x: 122.13,
    y: 47.43,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-528",
    x: 122.13,
    y: 47.24,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-657",
    x: 122.13,
    y: 47.04,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-692",
    x: 122.13,
    y: 46.85,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-662",
    x: 122.13,
    y: 46.65,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-668",
    x: 122.13,
    y: 46.45,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-777",
    x: 122.13,
    y: 46.26,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-679",
    x: 122.13,
    y: 46.06,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-768",
    x: 122.13,
    y: 45.87,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-761",
    x: 122.13,
    y: 45.67,
    width: 33.83,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-761",
    x: 122.13,
    y: 45.52,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-714",
    x: 122.13,
    y: 45.36,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-708",
    x: 122.13,
    y: 45.2,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-404",
    x: 122.13,
    y: 45.05,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-431",
    x: 122.13,
    y: 44.89,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-632",
    x: 122.13,
    y: 44.74,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-558",
    x: 122.13,
    y: 44.58,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-649",
    x: 122.13,
    y: 44.42,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-640",
    x: 122.13,
    y: 44.27,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-566",
    x: 122.13,
    y: 44.11,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-612",
    x: 122.13,
    y: 43.95,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-465",
    x: 122.13,
    y: 43.8,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-491",
    x: 122.13,
    y: 43.64,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-342",
    x: 122.13,
    y: 43.49,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-436",
    x: 122.13,
    y: 43.33,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 122.13,
    y: 43.17,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-329",
    x: 122.13,
    y: 43.02,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-416",
    x: 122.13,
    y: 42.86,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-553",
    x: 122.13,
    y: 42.7,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-560",
    x: 122.13,
    y: 42.55,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-588",
    x: 122.13,
    y: 42.39,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-581",
    x: 122.13,
    y: 42.24,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-609",
    x: 122.13,
    y: 42.08,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-585",
    x: 122.13,
    y: 41.92,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-751",
    x: 122.13,
    y: 41.77,
    width: 33.83,
    height: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-751",
    x: 122.13,
    y: 40.34,
    width: 33.83,
    height: 1.43
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1285"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1100",
    x: 123.71,
    y: 40.34,
    width: 1.65,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1100",
    x: 125.36,
    y: 40.34,
    width: 1.91,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1169",
    x: 127.26,
    y: 40.34,
    width: 1.91,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1005",
    x: 129.17,
    y: 40.34,
    width: 1.91,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-998",
    x: 131.08,
    y: 40.34,
    width: 1.91,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-998",
    x: 132.99,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-993",
    x: 133.68,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 134.36,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-442",
    x: 135.05,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 135.74,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 136.42,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 137.11,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 137.8,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-251",
    x: 138.49,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-975",
    x: 139.17,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-948",
    x: 139.86,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-862",
    x: 140.55,
    y: 40.34,
    width: 0.69,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-862",
    x: 141.23,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-832",
    x: 141.63,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-843",
    x: 142.02,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1180",
    x: 142.41,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-449",
    x: 142.8,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 143.2,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1114",
    x: 143.59,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1130",
    x: 143.98,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1240",
    x: 144.37,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1156",
    x: 144.77,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1226",
    x: 145.16,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1258",
    x: 145.55,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 145.94,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 146.34,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 146.73,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 147.12,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 147.52,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 147.91,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1219",
    x: 148.3,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1205",
    x: 148.69,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 149.09,
    y: 40.34,
    width: 0.39,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 149.48,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-510",
    x: 149.77,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-913",
    x: 150.06,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-967",
    x: 150.35,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-960",
    x: 150.64,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-891",
    x: 150.94,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-351",
    x: 151.23,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-368",
    x: 151.52,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-391",
    x: 151.81,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-476",
    x: 152.1,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-481",
    x: 152.39,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-409",
    x: 152.68,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-400",
    x: 152.98,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 153.27,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 153.56,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-856",
    x: 153.85,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-883",
    x: 154.14,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 154.43,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 154.72,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 155.02,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 155.31,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-926",
    x: 155.6,
    y: 40.34,
    width: 0.29,
    height: 41.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-926",
    x: 155.89,
    y: 40.34,
    width: 1.65,
    height: 41.92
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 124.53,
    y: 41.3,
    width: 26.15,
    height: 39.66
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullTime);
export default __webpack_public_path__ + "static/media/full-time.4ea7db55234520c394473f7aad14f44b.svg";
export { ForwardRef as ReactComponent };